
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea868"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea868"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caV3w", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Xr8A"));

});
parcelRegister("4Xr8A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $39c1b90c41ffc6ad$export$ffb0004e005737fa; }, function (v) { return $39c1b90c41ffc6ad$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $39c1b90c41ffc6ad$export$34b9dba7ce09269b; }, function (v) { return $39c1b90c41ffc6ad$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $39c1b90c41ffc6ad$export$25062201e9e25d76; }, function (v) { return $39c1b90c41ffc6ad$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39c1b90c41ffc6ad$export$ffb0004e005737fa;
var $39c1b90c41ffc6ad$export$34b9dba7ce09269b;
var $39c1b90c41ffc6ad$export$25062201e9e25d76;
"use strict";
var $39c1b90c41ffc6ad$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $39c1b90c41ffc6ad$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $39c1b90c41ffc6ad$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $39c1b90c41ffc6ad$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$39c1b90c41ffc6ad$export$ffb0004e005737fa = $39c1b90c41ffc6ad$var$REACT_FRAGMENT_TYPE;
$39c1b90c41ffc6ad$export$34b9dba7ce09269b = $39c1b90c41ffc6ad$var$jsxProd;
$39c1b90c41ffc6ad$export$25062201e9e25d76 = $39c1b90c41ffc6ad$var$jsxProd;

});


parcelRegister("iERLf", function(module, exports) {
'use strict';
function $d955aa3bcb03bbc5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d955aa3bcb03bbc5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d955aa3bcb03bbc5$var$checkDCE();

module.exports = (parcelRequire("gHMOm"));

});
parcelRegister("gHMOm", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c2968667ab46cac6$export$882461b6382ed46c; }, function (v) { return $c2968667ab46cac6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c2968667ab46cac6$export$757ceba2d55c277e; }, function (v) { return $c2968667ab46cac6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $c2968667ab46cac6$export$83d89fbfd8236492; }, function (v) { return $c2968667ab46cac6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c2968667ab46cac6$export$882461b6382ed46c;
var $c2968667ab46cac6$export$757ceba2d55c277e;
var $c2968667ab46cac6$export$83d89fbfd8236492;
"use strict";

var $f04nL = parcelRequire("f04nL");

var $8XEkF = parcelRequire("8XEkF");

var $fdu5P = parcelRequire("fdu5P");
function $c2968667ab46cac6$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c2968667ab46cac6$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c2968667ab46cac6$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c2968667ab46cac6$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $c2968667ab46cac6$var$assertIsMounted(fiber) {
    if ($c2968667ab46cac6$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
}
function $c2968667ab46cac6$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c2968667ab46cac6$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c2968667ab46cac6$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c2968667ab46cac6$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c2968667ab46cac6$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c2968667ab46cac6$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c2968667ab46cac6$var$assign = Object.assign, $c2968667ab46cac6$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c2968667ab46cac6$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c2968667ab46cac6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c2968667ab46cac6$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c2968667ab46cac6$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c2968667ab46cac6$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c2968667ab46cac6$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c2968667ab46cac6$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c2968667ab46cac6$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c2968667ab46cac6$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c2968667ab46cac6$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c2968667ab46cac6$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c2968667ab46cac6$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c2968667ab46cac6$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c2968667ab46cac6$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $c2968667ab46cac6$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c2968667ab46cac6$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c2968667ab46cac6$var$getComponentNameFromType(type.type) || "Memo";
        case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c2968667ab46cac6$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c2968667ab46cac6$var$isArrayImpl = Array.isArray, $c2968667ab46cac6$var$ReactSharedInternals = $8XEkF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2968667ab46cac6$var$ReactDOMSharedInternals = $fdu5P.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2968667ab46cac6$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c2968667ab46cac6$var$valueStack = [], $c2968667ab46cac6$var$index = -1;
function $c2968667ab46cac6$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c2968667ab46cac6$var$pop(cursor) {
    0 > $c2968667ab46cac6$var$index || (cursor.current = $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index], $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index] = null, $c2968667ab46cac6$var$index--);
}
function $c2968667ab46cac6$var$push(cursor, value) {
    $c2968667ab46cac6$var$index++;
    $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index] = cursor.current;
    cursor.current = value;
}
var $c2968667ab46cac6$var$contextStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$contextFiberStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$rootInstanceStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$hostTransitionProviderCursor = $c2968667ab46cac6$var$createCursor(null);
function $c2968667ab46cac6$var$pushHostContainer(fiber, nextRootInstance) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$rootInstanceStackCursor, nextRootInstance);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextFiberStackCursor, fiber);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c2968667ab46cac6$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c2968667ab46cac6$var$getOwnHostContext(nextRootInstance), fiber = $c2968667ab46cac6$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, fiber);
}
function $c2968667ab46cac6$var$popHostContainer() {
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextFiberStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$rootInstanceStackCursor);
}
function $c2968667ab46cac6$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c2968667ab46cac6$var$push($c2968667ab46cac6$var$hostTransitionProviderCursor, fiber);
    var context = $c2968667ab46cac6$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c2968667ab46cac6$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextFiberStackCursor, fiber), $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, JSCompiler_inline_result));
}
function $c2968667ab46cac6$var$popHostContext(fiber) {
    $c2968667ab46cac6$var$contextFiberStackCursor.current === fiber && ($c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor), $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextFiberStackCursor));
    $c2968667ab46cac6$var$hostTransitionProviderCursor.current === fiber && ($c2968667ab46cac6$var$pop($c2968667ab46cac6$var$hostTransitionProviderCursor), $c2968667ab46cac6$var$HostTransitionContext._currentValue = $c2968667ab46cac6$var$sharedNotPendingObject);
}
var $c2968667ab46cac6$var$prefix, $c2968667ab46cac6$var$suffix;
function $c2968667ab46cac6$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c2968667ab46cac6$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c2968667ab46cac6$var$prefix = match && match[1] || "";
        $c2968667ab46cac6$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c2968667ab46cac6$var$prefix + name + $c2968667ab46cac6$var$suffix;
}
var $c2968667ab46cac6$var$reentry = !1;
function $c2968667ab46cac6$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c2968667ab46cac6$var$reentry) return "";
    $c2968667ab46cac6$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c2968667ab46cac6$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c2968667ab46cac6$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c2968667ab46cac6$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $c2968667ab46cac6$var$describeBuiltInComponentFrame("Suspense Fallback") : $c2968667ab46cac6$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $c2968667ab46cac6$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $c2968667ab46cac6$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $c2968667ab46cac6$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c2968667ab46cac6$var$scheduleCallback$3 = $f04nL.unstable_scheduleCallback, $c2968667ab46cac6$var$cancelCallback$1 = $f04nL.unstable_cancelCallback, $c2968667ab46cac6$var$shouldYield = $f04nL.unstable_shouldYield, $c2968667ab46cac6$var$requestPaint = $f04nL.unstable_requestPaint, $c2968667ab46cac6$var$now = $f04nL.unstable_now, $c2968667ab46cac6$var$getCurrentPriorityLevel = $f04nL.unstable_getCurrentPriorityLevel, $c2968667ab46cac6$var$ImmediatePriority = $f04nL.unstable_ImmediatePriority, $c2968667ab46cac6$var$UserBlockingPriority = $f04nL.unstable_UserBlockingPriority, $c2968667ab46cac6$var$NormalPriority$1 = $f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$LowPriority = $f04nL.unstable_LowPriority, $c2968667ab46cac6$var$IdlePriority = $f04nL.unstable_IdlePriority, $c2968667ab46cac6$var$log$1 = $f04nL.log, $c2968667ab46cac6$var$unstable_setDisableYieldValue = $f04nL.unstable_setDisableYieldValue, $c2968667ab46cac6$var$rendererID = null, $c2968667ab46cac6$var$injectedHook = null;
function $c2968667ab46cac6$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c2968667ab46cac6$var$log$1 && $c2968667ab46cac6$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.setStrictMode) try {
        $c2968667ab46cac6$var$injectedHook.setStrictMode($c2968667ab46cac6$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c2968667ab46cac6$var$clz32 = Math.clz32 ? Math.clz32 : $c2968667ab46cac6$var$clz32Fallback, $c2968667ab46cac6$var$log = Math.log, $c2968667ab46cac6$var$LN2 = Math.LN2;
function $c2968667ab46cac6$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c2968667ab46cac6$var$log(x) / $c2968667ab46cac6$var$LN2 | 0) | 0;
}
var $c2968667ab46cac6$var$nextTransitionUpdateLane = 256, $c2968667ab46cac6$var$nextTransitionDeferredLane = 262144, $c2968667ab46cac6$var$nextRetryLane = 4194304;
function $c2968667ab46cac6$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c2968667ab46cac6$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c2968667ab46cac6$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c2968667ab46cac6$var$claimNextRetryLane() {
    var lane = $c2968667ab46cac6$var$nextRetryLane;
    $c2968667ab46cac6$var$nextRetryLane <<= 1;
    0 === ($c2968667ab46cac6$var$nextRetryLane & 62914560) && ($c2968667ab46cac6$var$nextRetryLane = 4194304);
    return lane;
}
function $c2968667ab46cac6$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c2968667ab46cac6$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c2968667ab46cac6$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c2968667ab46cac6$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c2968667ab46cac6$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $c2968667ab46cac6$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c2968667ab46cac6$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c2968667ab46cac6$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c2968667ab46cac6$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c2968667ab46cac6$var$resolveUpdatePriority() {
    var updatePriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c2968667ab46cac6$var$getEventPriority(updatePriority.type);
}
function $c2968667ab46cac6$var$runWithPriority(priority, fn) {
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        return $c2968667ab46cac6$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c2968667ab46cac6$var$randomKey = Math.random().toString(36).slice(2), $c2968667ab46cac6$var$internalInstanceKey = "__reactFiber$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalPropsKey = "__reactProps$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalContainerInstanceKey = "__reactContainer$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlersKey = "__reactEvents$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlerListenersKey = "__reactListeners$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlesSetKey = "__reactHandles$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalRootNodeResourcesKey = "__reactResources$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalHoistableMarker = "__reactMarker$" + $c2968667ab46cac6$var$randomKey;
function $c2968667ab46cac6$var$detachDeletedInstance(node) {
    delete node[$c2968667ab46cac6$var$internalInstanceKey];
    delete node[$c2968667ab46cac6$var$internalPropsKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlersKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlerListenersKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlesSetKey];
}
function $c2968667ab46cac6$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c2968667ab46cac6$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c2968667ab46cac6$var$internalContainerInstanceKey] || parentNode[$c2968667ab46cac6$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c2968667ab46cac6$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c2968667ab46cac6$var$internalInstanceKey]) return parentNode;
                targetNode = $c2968667ab46cac6$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c2968667ab46cac6$var$getInstanceFromNode(node) {
    if (node = node[$c2968667ab46cac6$var$internalInstanceKey] || node[$c2968667ab46cac6$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c2968667ab46cac6$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(33));
}
function $c2968667ab46cac6$var$getResourcesFromRoot(root) {
    var resources = root[$c2968667ab46cac6$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c2968667ab46cac6$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c2968667ab46cac6$var$markNodeAsHoistable(node) {
    node[$c2968667ab46cac6$var$internalHoistableMarker] = !0;
}
var $c2968667ab46cac6$var$allNativeEvents = new Set(), $c2968667ab46cac6$var$registrationNameDependencies = {};
function $c2968667ab46cac6$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c2968667ab46cac6$var$registerDirectEvent(registrationName, dependencies);
    $c2968667ab46cac6$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c2968667ab46cac6$var$registerDirectEvent(registrationName, dependencies) {
    $c2968667ab46cac6$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c2968667ab46cac6$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c2968667ab46cac6$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c2968667ab46cac6$var$illegalAttributeNameCache = {}, $c2968667ab46cac6$var$validatedAttributeNameCache = {};
function $c2968667ab46cac6$var$isAttributeNameSafe(attributeName) {
    if ($c2968667ab46cac6$var$hasOwnProperty.call($c2968667ab46cac6$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c2968667ab46cac6$var$hasOwnProperty.call($c2968667ab46cac6$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c2968667ab46cac6$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c2968667ab46cac6$var$validatedAttributeNameCache[attributeName] = !0;
    $c2968667ab46cac6$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c2968667ab46cac6$var$setValueForAttribute(node, name, value) {
    if ($c2968667ab46cac6$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c2968667ab46cac6$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c2968667ab46cac6$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $c2968667ab46cac6$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c2968667ab46cac6$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c2968667ab46cac6$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c2968667ab46cac6$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $c2968667ab46cac6$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $c2968667ab46cac6$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $c2968667ab46cac6$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c2968667ab46cac6$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c2968667ab46cac6$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c2968667ab46cac6$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c2968667ab46cac6$var$getToStringValue(value);
        } else element.value !== "" + $c2968667ab46cac6$var$getToStringValue(value) && (element.value = "" + $c2968667ab46cac6$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c2968667ab46cac6$var$setDefaultValue(element, type, $c2968667ab46cac6$var$getToStringValue(value)) : null != defaultValue ? $c2968667ab46cac6$var$setDefaultValue(element, type, $c2968667ab46cac6$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c2968667ab46cac6$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c2968667ab46cac6$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $c2968667ab46cac6$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $c2968667ab46cac6$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c2968667ab46cac6$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $c2968667ab46cac6$var$track(element);
}
function $c2968667ab46cac6$var$setDefaultValue(node, type, value) {
    "number" === type && $c2968667ab46cac6$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c2968667ab46cac6$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c2968667ab46cac6$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c2968667ab46cac6$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c2968667ab46cac6$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c2968667ab46cac6$var$getToStringValue(defaultValue) : "";
}
function $c2968667ab46cac6$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(92));
            if ($c2968667ab46cac6$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c2968667ab46cac6$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $c2968667ab46cac6$var$track(element);
}
function $c2968667ab46cac6$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c2968667ab46cac6$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c2968667ab46cac6$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c2968667ab46cac6$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c2968667ab46cac6$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c2968667ab46cac6$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c2968667ab46cac6$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c2968667ab46cac6$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c2968667ab46cac6$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c2968667ab46cac6$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c2968667ab46cac6$var$sanitizeURL(url) {
    return $c2968667ab46cac6$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $c2968667ab46cac6$var$noop$1() {}
var $c2968667ab46cac6$var$currentReplayingEvent = null;
function $c2968667ab46cac6$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c2968667ab46cac6$var$restoreTarget = null, $c2968667ab46cac6$var$restoreQueue = null;
function $c2968667ab46cac6$var$restoreStateOfTarget(target) {
    var internalInstance = $c2968667ab46cac6$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c2968667ab46cac6$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c2968667ab46cac6$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c2968667ab46cac6$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(90));
                            $c2968667ab46cac6$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c2968667ab46cac6$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c2968667ab46cac6$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c2968667ab46cac6$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c2968667ab46cac6$var$isInsideEventHandler = !1;
function $c2968667ab46cac6$var$batchedUpdates$1(fn, a, b) {
    if ($c2968667ab46cac6$var$isInsideEventHandler) return fn(a, b);
    $c2968667ab46cac6$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c2968667ab46cac6$var$isInsideEventHandler = !1, null !== $c2968667ab46cac6$var$restoreTarget || null !== $c2968667ab46cac6$var$restoreQueue) {
            if ($c2968667ab46cac6$var$flushSyncWork$1(), $c2968667ab46cac6$var$restoreTarget && (a = $c2968667ab46cac6$var$restoreTarget, fn = $c2968667ab46cac6$var$restoreQueue, $c2968667ab46cac6$var$restoreQueue = $c2968667ab46cac6$var$restoreTarget = null, $c2968667ab46cac6$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c2968667ab46cac6$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c2968667ab46cac6$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c2968667ab46cac6$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c2968667ab46cac6$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c2968667ab46cac6$var$passiveBrowserEventsSupported = !1;
if ($c2968667ab46cac6$var$canUseDOM) try {
    var $c2968667ab46cac6$var$options = {};
    Object.defineProperty($c2968667ab46cac6$var$options, "passive", {
        get: function() {
            $c2968667ab46cac6$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c2968667ab46cac6$var$options, $c2968667ab46cac6$var$options);
    window.removeEventListener("test", $c2968667ab46cac6$var$options, $c2968667ab46cac6$var$options);
} catch (e) {
    $c2968667ab46cac6$var$passiveBrowserEventsSupported = !1;
}
var $c2968667ab46cac6$var$root = null, $c2968667ab46cac6$var$startText = null, $c2968667ab46cac6$var$fallbackText = null;
function $c2968667ab46cac6$var$getData() {
    if ($c2968667ab46cac6$var$fallbackText) return $c2968667ab46cac6$var$fallbackText;
    var start, startValue = $c2968667ab46cac6$var$startText, startLength = startValue.length, end, endValue = "value" in $c2968667ab46cac6$var$root ? $c2968667ab46cac6$var$root.value : $c2968667ab46cac6$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c2968667ab46cac6$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c2968667ab46cac6$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c2968667ab46cac6$var$functionThatReturnsTrue() {
    return !0;
}
function $c2968667ab46cac6$var$functionThatReturnsFalse() {
    return !1;
}
function $c2968667ab46cac6$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c2968667ab46cac6$var$functionThatReturnsTrue : $c2968667ab46cac6$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c2968667ab46cac6$var$functionThatReturnsFalse;
        return this;
    }
    $c2968667ab46cac6$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c2968667ab46cac6$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c2968667ab46cac6$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c2968667ab46cac6$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c2968667ab46cac6$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c2968667ab46cac6$var$SyntheticEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$EventInterface), $c2968667ab46cac6$var$UIEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    view: 0,
    detail: 0
}), $c2968667ab46cac6$var$SyntheticUIEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$UIEventInterface), $c2968667ab46cac6$var$lastMovementX, $c2968667ab46cac6$var$lastMovementY, $c2968667ab46cac6$var$lastMouseEvent, $c2968667ab46cac6$var$MouseEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c2968667ab46cac6$var$lastMouseEvent && ($c2968667ab46cac6$var$lastMouseEvent && "mousemove" === event.type ? ($c2968667ab46cac6$var$lastMovementX = event.screenX - $c2968667ab46cac6$var$lastMouseEvent.screenX, $c2968667ab46cac6$var$lastMovementY = event.screenY - $c2968667ab46cac6$var$lastMouseEvent.screenY) : $c2968667ab46cac6$var$lastMovementY = $c2968667ab46cac6$var$lastMovementX = 0, $c2968667ab46cac6$var$lastMouseEvent = event);
        return $c2968667ab46cac6$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c2968667ab46cac6$var$lastMovementY;
    }
}), $c2968667ab46cac6$var$SyntheticMouseEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$MouseEventInterface), $c2968667ab46cac6$var$DragEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    dataTransfer: 0
}), $c2968667ab46cac6$var$SyntheticDragEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$DragEventInterface), $c2968667ab46cac6$var$FocusEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    relatedTarget: 0
}), $c2968667ab46cac6$var$SyntheticFocusEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$FocusEventInterface), $c2968667ab46cac6$var$AnimationEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2968667ab46cac6$var$SyntheticAnimationEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$AnimationEventInterface), $c2968667ab46cac6$var$ClipboardEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c2968667ab46cac6$var$SyntheticClipboardEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$ClipboardEventInterface), $c2968667ab46cac6$var$CompositionEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    data: 0
}), $c2968667ab46cac6$var$SyntheticCompositionEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$CompositionEventInterface), $c2968667ab46cac6$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c2968667ab46cac6$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c2968667ab46cac6$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c2968667ab46cac6$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c2968667ab46cac6$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c2968667ab46cac6$var$getEventModifierState() {
    return $c2968667ab46cac6$var$modifierStateGetter;
}
var $c2968667ab46cac6$var$KeyboardEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c2968667ab46cac6$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c2968667ab46cac6$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c2968667ab46cac6$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c2968667ab46cac6$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c2968667ab46cac6$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c2968667ab46cac6$var$SyntheticKeyboardEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$KeyboardEventInterface), $c2968667ab46cac6$var$PointerEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c2968667ab46cac6$var$SyntheticPointerEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$PointerEventInterface), $c2968667ab46cac6$var$TouchEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState
}), $c2968667ab46cac6$var$SyntheticTouchEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$TouchEventInterface), $c2968667ab46cac6$var$TransitionEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2968667ab46cac6$var$SyntheticTransitionEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$TransitionEventInterface), $c2968667ab46cac6$var$WheelEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c2968667ab46cac6$var$SyntheticWheelEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$WheelEventInterface), $c2968667ab46cac6$var$ToggleEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c2968667ab46cac6$var$SyntheticToggleEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$ToggleEventInterface), $c2968667ab46cac6$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c2968667ab46cac6$var$canUseCompositionEvent = $c2968667ab46cac6$var$canUseDOM && "CompositionEvent" in window, $c2968667ab46cac6$var$documentMode = null;
$c2968667ab46cac6$var$canUseDOM && "documentMode" in document && ($c2968667ab46cac6$var$documentMode = document.documentMode);
var $c2968667ab46cac6$var$canUseTextInputEvent = $c2968667ab46cac6$var$canUseDOM && "TextEvent" in window && !$c2968667ab46cac6$var$documentMode, $c2968667ab46cac6$var$useFallbackCompositionData = $c2968667ab46cac6$var$canUseDOM && (!$c2968667ab46cac6$var$canUseCompositionEvent || $c2968667ab46cac6$var$documentMode && 8 < $c2968667ab46cac6$var$documentMode && 11 >= $c2968667ab46cac6$var$documentMode), $c2968667ab46cac6$var$SPACEBAR_CHAR = String.fromCharCode(32), $c2968667ab46cac6$var$hasSpaceKeypress = !1;
function $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c2968667ab46cac6$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c2968667ab46cac6$var$isComposing = !1;
function $c2968667ab46cac6$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c2968667ab46cac6$var$hasSpaceKeypress = !0;
            return $c2968667ab46cac6$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c2968667ab46cac6$var$SPACEBAR_CHAR && $c2968667ab46cac6$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c2968667ab46cac6$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c2968667ab46cac6$var$isComposing) return "compositionend" === domEventName || !$c2968667ab46cac6$var$canUseCompositionEvent && $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c2968667ab46cac6$var$getData(), $c2968667ab46cac6$var$fallbackText = $c2968667ab46cac6$var$startText = $c2968667ab46cac6$var$root = null, $c2968667ab46cac6$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c2968667ab46cac6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c2968667ab46cac6$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c2968667ab46cac6$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c2968667ab46cac6$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c2968667ab46cac6$var$restoreTarget ? $c2968667ab46cac6$var$restoreQueue ? $c2968667ab46cac6$var$restoreQueue.push(target) : $c2968667ab46cac6$var$restoreQueue = [
        target
    ] : $c2968667ab46cac6$var$restoreTarget = target;
    inst = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c2968667ab46cac6$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c2968667ab46cac6$var$activeElement$1 = null, $c2968667ab46cac6$var$activeElementInst$1 = null;
function $c2968667ab46cac6$var$runEventInBatch(dispatchQueue) {
    $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, 0);
}
function $c2968667ab46cac6$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c2968667ab46cac6$var$getNodeFromInstance(targetInst);
    if ($c2968667ab46cac6$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c2968667ab46cac6$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c2968667ab46cac6$var$isInputEventSupported = !1;
if ($c2968667ab46cac6$var$canUseDOM) {
    var $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286;
    if ($c2968667ab46cac6$var$canUseDOM) {
        var $c2968667ab46cac6$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$c2968667ab46cac6$var$isSupported$jscomp$inline_427) {
            var $c2968667ab46cac6$var$element$jscomp$inline_428 = document.createElement("div");
            $c2968667ab46cac6$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $c2968667ab46cac6$var$isSupported$jscomp$inline_427 = "function" === typeof $c2968667ab46cac6$var$element$jscomp$inline_428.oninput;
        }
        $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 = $c2968667ab46cac6$var$isSupported$jscomp$inline_427;
    } else $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 = !1;
    $c2968667ab46cac6$var$isInputEventSupported = $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $c2968667ab46cac6$var$stopWatchingForValueChange() {
    $c2968667ab46cac6$var$activeElement$1 && ($c2968667ab46cac6$var$activeElement$1.detachEvent("onpropertychange", $c2968667ab46cac6$var$handlePropertyChange), $c2968667ab46cac6$var$activeElementInst$1 = $c2968667ab46cac6$var$activeElement$1 = null);
}
function $c2968667ab46cac6$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c2968667ab46cac6$var$getInstIfValueChanged($c2968667ab46cac6$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, $c2968667ab46cac6$var$activeElementInst$1, nativeEvent, $c2968667ab46cac6$var$getEventTarget(nativeEvent));
        $c2968667ab46cac6$var$batchedUpdates$1($c2968667ab46cac6$var$runEventInBatch, dispatchQueue);
    }
}
function $c2968667ab46cac6$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c2968667ab46cac6$var$stopWatchingForValueChange(), $c2968667ab46cac6$var$activeElement$1 = target, $c2968667ab46cac6$var$activeElementInst$1 = targetInst, $c2968667ab46cac6$var$activeElement$1.attachEvent("onpropertychange", $c2968667ab46cac6$var$handlePropertyChange)) : "focusout" === domEventName && $c2968667ab46cac6$var$stopWatchingForValueChange();
}
function $c2968667ab46cac6$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged($c2968667ab46cac6$var$activeElementInst$1);
}
function $c2968667ab46cac6$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged(targetInst);
}
function $c2968667ab46cac6$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged(targetInst);
}
function $c2968667ab46cac6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c2968667ab46cac6$var$objectIs = "function" === typeof Object.is ? Object.is : $c2968667ab46cac6$var$is;
function $c2968667ab46cac6$var$shallowEqual(objA, objB) {
    if ($c2968667ab46cac6$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c2968667ab46cac6$var$hasOwnProperty.call(objB, currentKey) || !$c2968667ab46cac6$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c2968667ab46cac6$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c2968667ab46cac6$var$getNodeForCharacterOffset(root, offset) {
    var node = $c2968667ab46cac6$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c2968667ab46cac6$var$getLeafNode(node);
    }
}
function $c2968667ab46cac6$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c2968667ab46cac6$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c2968667ab46cac6$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c2968667ab46cac6$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c2968667ab46cac6$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c2968667ab46cac6$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c2968667ab46cac6$var$skipSelectionChangeEvent = $c2968667ab46cac6$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c2968667ab46cac6$var$activeElement = null, $c2968667ab46cac6$var$activeElementInst = null, $c2968667ab46cac6$var$lastSelection = null, $c2968667ab46cac6$var$mouseDown = !1;
function $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c2968667ab46cac6$var$mouseDown || null == $c2968667ab46cac6$var$activeElement || $c2968667ab46cac6$var$activeElement !== $c2968667ab46cac6$var$getActiveElement(doc) || (doc = $c2968667ab46cac6$var$activeElement, "selectionStart" in doc && $c2968667ab46cac6$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c2968667ab46cac6$var$lastSelection && $c2968667ab46cac6$var$shallowEqual($c2968667ab46cac6$var$lastSelection, doc) || ($c2968667ab46cac6$var$lastSelection = doc, doc = $c2968667ab46cac6$var$accumulateTwoPhaseListeners($c2968667ab46cac6$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c2968667ab46cac6$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c2968667ab46cac6$var$activeElement)));
}
function $c2968667ab46cac6$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c2968667ab46cac6$var$vendorPrefixes = {
    animationend: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionEnd")
}, $c2968667ab46cac6$var$prefixedEventNames = {}, $c2968667ab46cac6$var$style = {};
$c2968667ab46cac6$var$canUseDOM && ($c2968667ab46cac6$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c2968667ab46cac6$var$vendorPrefixes.animationend.animation, delete $c2968667ab46cac6$var$vendorPrefixes.animationiteration.animation, delete $c2968667ab46cac6$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c2968667ab46cac6$var$vendorPrefixes.transitionend.transition);
function $c2968667ab46cac6$var$getVendorPrefixedEventName(eventName) {
    if ($c2968667ab46cac6$var$prefixedEventNames[eventName]) return $c2968667ab46cac6$var$prefixedEventNames[eventName];
    if (!$c2968667ab46cac6$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c2968667ab46cac6$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c2968667ab46cac6$var$style) return $c2968667ab46cac6$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c2968667ab46cac6$var$ANIMATION_END = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationend"), $c2968667ab46cac6$var$ANIMATION_ITERATION = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationiteration"), $c2968667ab46cac6$var$ANIMATION_START = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationstart"), $c2968667ab46cac6$var$TRANSITION_RUN = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionrun"), $c2968667ab46cac6$var$TRANSITION_START = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionstart"), $c2968667ab46cac6$var$TRANSITION_CANCEL = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitioncancel"), $c2968667ab46cac6$var$TRANSITION_END = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionend"), $c2968667ab46cac6$var$topLevelEventsToReactNames = new Map(), $c2968667ab46cac6$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c2968667ab46cac6$var$simpleEventPluginEvents.push("scrollEnd");
function $c2968667ab46cac6$var$registerSimpleEvent(domEventName, reactName) {
    $c2968667ab46cac6$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c2968667ab46cac6$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c2968667ab46cac6$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $c2968667ab46cac6$var$concurrentQueues = [], $c2968667ab46cac6$var$concurrentQueuesIndex = 0, $c2968667ab46cac6$var$concurrentlyUpdatedLanes = 0;
function $c2968667ab46cac6$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c2968667ab46cac6$var$concurrentQueuesIndex, i = $c2968667ab46cac6$var$concurrentlyUpdatedLanes = $c2968667ab46cac6$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var queue = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var update = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var lane = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = fiber;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = queue;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = update;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = lane;
    $c2968667ab46cac6$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c2968667ab46cac6$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c2968667ab46cac6$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c2968667ab46cac6$var$nestedUpdateCount) throw $c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = null, Error($c2968667ab46cac6$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c2968667ab46cac6$var$emptyContextObject = {};
function $c2968667ab46cac6$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c2968667ab46cac6$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c2968667ab46cac6$var$FiberNode(tag, pendingProps, key, mode);
}
function $c2968667ab46cac6$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c2968667ab46cac6$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c2968667ab46cac6$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c2968667ab46cac6$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c2968667ab46cac6$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c2968667ab46cac6$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c2968667ab46cac6$var$isHostHoistableType(type, pendingProps, $c2968667ab46cac6$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE:
            return $c2968667ab46cac6$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c2968667ab46cac6$var$REACT_PROFILER_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c2968667ab46cac6$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $c2968667ab46cac6$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c2968667ab46cac6$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c2968667ab46cac6$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c2968667ab46cac6$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c2968667ab46cac6$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c2968667ab46cac6$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c2968667ab46cac6$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c2968667ab46cac6$var$createFiberFromText(content, mode, lanes) {
    content = $c2968667ab46cac6$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c2968667ab46cac6$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $c2968667ab46cac6$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $c2968667ab46cac6$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c2968667ab46cac6$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c2968667ab46cac6$var$CapturedStacks = new WeakMap();
function $c2968667ab46cac6$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c2968667ab46cac6$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c2968667ab46cac6$var$getStackByFiberInDevAndProd(source)
        };
        $c2968667ab46cac6$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c2968667ab46cac6$var$getStackByFiberInDevAndProd(source)
    };
}
var $c2968667ab46cac6$var$forkStack = [], $c2968667ab46cac6$var$forkStackIndex = 0, $c2968667ab46cac6$var$treeForkProvider = null, $c2968667ab46cac6$var$treeForkCount = 0, $c2968667ab46cac6$var$idStack = [], $c2968667ab46cac6$var$idStackIndex = 0, $c2968667ab46cac6$var$treeContextProvider = null, $c2968667ab46cac6$var$treeContextId = 1, $c2968667ab46cac6$var$treeContextOverflow = "";
function $c2968667ab46cac6$var$pushTreeFork(workInProgress, totalChildren) {
    $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex++] = $c2968667ab46cac6$var$treeForkCount;
    $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex++] = $c2968667ab46cac6$var$treeForkProvider;
    $c2968667ab46cac6$var$treeForkProvider = workInProgress;
    $c2968667ab46cac6$var$treeForkCount = totalChildren;
}
function $c2968667ab46cac6$var$pushTreeId(workInProgress, totalChildren, index) {
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextId;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextOverflow;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextProvider;
    $c2968667ab46cac6$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c2968667ab46cac6$var$treeContextId;
    workInProgress = $c2968667ab46cac6$var$treeContextOverflow;
    var baseLength = 32 - $c2968667ab46cac6$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c2968667ab46cac6$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c2968667ab46cac6$var$treeContextId = 1 << 32 - $c2968667ab46cac6$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c2968667ab46cac6$var$treeContextOverflow = length + workInProgress;
    } else $c2968667ab46cac6$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c2968667ab46cac6$var$treeContextOverflow = workInProgress;
}
function $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c2968667ab46cac6$var$pushTreeFork(workInProgress, 1), $c2968667ab46cac6$var$pushTreeId(workInProgress, 1, 0));
}
function $c2968667ab46cac6$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c2968667ab46cac6$var$treeForkProvider;)$c2968667ab46cac6$var$treeForkProvider = $c2968667ab46cac6$var$forkStack[--$c2968667ab46cac6$var$forkStackIndex], $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex] = null, $c2968667ab46cac6$var$treeForkCount = $c2968667ab46cac6$var$forkStack[--$c2968667ab46cac6$var$forkStackIndex], $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex] = null;
    for(; workInProgress === $c2968667ab46cac6$var$treeContextProvider;)$c2968667ab46cac6$var$treeContextProvider = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null, $c2968667ab46cac6$var$treeContextOverflow = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null, $c2968667ab46cac6$var$treeContextId = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null;
}
function $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextId;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextOverflow;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextProvider;
    $c2968667ab46cac6$var$treeContextId = suspendedContext.id;
    $c2968667ab46cac6$var$treeContextOverflow = suspendedContext.overflow;
    $c2968667ab46cac6$var$treeContextProvider = workInProgress;
}
var $c2968667ab46cac6$var$hydrationParentFiber = null, $c2968667ab46cac6$var$nextHydratableInstance = null, $c2968667ab46cac6$var$isHydrating = !1, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, $c2968667ab46cac6$var$HydrationMismatchException = Error($c2968667ab46cac6$var$formatProdErrorMessage(519));
function $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c2968667ab46cac6$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(error, fiber));
    throw $c2968667ab46cac6$var$HydrationMismatchException;
}
function $c2968667ab46cac6$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c2968667ab46cac6$var$internalInstanceKey] = fiber;
    instance[$c2968667ab46cac6$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("cancel", instance);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c2968667ab46cac6$var$mediaEventTypes.length; type++)$c2968667ab46cac6$var$listenToNonDelegatedEvent($c2968667ab46cac6$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", instance);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance);
            $c2968667ab46cac6$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance), $c2968667ab46cac6$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c2968667ab46cac6$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", instance), $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c2968667ab46cac6$var$noop$1), instance = !0) : instance = !1;
    instance || $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber, !0);
}
function $c2968667ab46cac6$var$popToNextHostParent(fiber) {
    for($c2968667ab46cac6$var$hydrationParentFiber = fiber.return; $c2968667ab46cac6$var$hydrationParentFiber;)switch($c2968667ab46cac6$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $c2968667ab46cac6$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c2968667ab46cac6$var$rootOrSingletonContext = !0;
            return;
        default:
            $c2968667ab46cac6$var$hydrationParentFiber = $c2968667ab46cac6$var$hydrationParentFiber.return;
    }
}
function $c2968667ab46cac6$var$popHydrationState(fiber) {
    if (fiber !== $c2968667ab46cac6$var$hydrationParentFiber) return !1;
    if (!$c2968667ab46cac6$var$isHydrating) return $c2968667ab46cac6$var$popToNextHostParent(fiber), $c2968667ab46cac6$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c2968667ab46cac6$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c2968667ab46cac6$var$nextHydratableInstance && $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber);
    $c2968667ab46cac6$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $c2968667ab46cac6$var$nextHydratableInstance, $c2968667ab46cac6$var$isSingletonScope(fiber.type) ? (fiber = $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton, $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = null, $c2968667ab46cac6$var$nextHydratableInstance = fiber) : $c2968667ab46cac6$var$nextHydratableInstance = tag) : $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$hydrationParentFiber ? $c2968667ab46cac6$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c2968667ab46cac6$var$resetHydrationState() {
    $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$hydrationParentFiber = null;
    $c2968667ab46cac6$var$isHydrating = !1;
}
function $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c2968667ab46cac6$var$hydrationErrors;
    null !== queuedErrors && (null === $c2968667ab46cac6$var$workInProgressRootRecoverableErrors ? $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = queuedErrors : $c2968667ab46cac6$var$workInProgressRootRecoverableErrors.push.apply($c2968667ab46cac6$var$workInProgressRootRecoverableErrors, queuedErrors), $c2968667ab46cac6$var$hydrationErrors = null);
    return queuedErrors;
}
function $c2968667ab46cac6$var$queueHydrationError(error) {
    null === $c2968667ab46cac6$var$hydrationErrors ? $c2968667ab46cac6$var$hydrationErrors = [
        error
    ] : $c2968667ab46cac6$var$hydrationErrors.push(error);
}
var $c2968667ab46cac6$var$valueCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null, $c2968667ab46cac6$var$lastContextDependency = null;
function $c2968667ab46cac6$var$pushProvider(providerFiber, context, nextValue) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c2968667ab46cac6$var$popProvider(context) {
    context._currentValue = $c2968667ab46cac6$var$valueCursor.current;
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$valueCursor);
}
function $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c2968667ab46cac6$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c2968667ab46cac6$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c2968667ab46cac6$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c2968667ab46cac6$var$HostTransitionContext) : current = [
                $c2968667ab46cac6$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c2968667ab46cac6$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c2968667ab46cac6$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c2968667ab46cac6$var$prepareToReadContext(workInProgress) {
    $c2968667ab46cac6$var$currentlyRenderingFiber$1 = workInProgress;
    $c2968667ab46cac6$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c2968667ab46cac6$var$readContext(context) {
    return $c2968667ab46cac6$var$readContextForConsumer($c2968667ab46cac6$var$currentlyRenderingFiber$1, context);
}
function $c2968667ab46cac6$var$readContextDuringReconciliation(consumer, context) {
    null === $c2968667ab46cac6$var$currentlyRenderingFiber$1 && $c2968667ab46cac6$var$prepareToReadContext(consumer);
    return $c2968667ab46cac6$var$readContextForConsumer(consumer, context);
}
function $c2968667ab46cac6$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c2968667ab46cac6$var$lastContextDependency) {
        if (null === consumer) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(308));
        $c2968667ab46cac6$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$lastContextDependency.next = context;
    return value;
}
var $c2968667ab46cac6$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c2968667ab46cac6$var$scheduleCallback$2 = $f04nL.unstable_scheduleCallback, $c2968667ab46cac6$var$NormalPriority = $f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$CacheContext = {
    $$typeof: $c2968667ab46cac6$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c2968667ab46cac6$var$createCache() {
    return {
        controller: new $c2968667ab46cac6$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c2968667ab46cac6$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c2968667ab46cac6$var$scheduleCallback$2($c2968667ab46cac6$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c2968667ab46cac6$var$currentEntangledListeners = null, $c2968667ab46cac6$var$currentEntangledPendingCount = 0, $c2968667ab46cac6$var$currentEntangledLane = 0, $c2968667ab46cac6$var$currentEntangledActionThenable = null;
function $c2968667ab46cac6$var$entangleAsyncAction(transition, thenable) {
    if (null === $c2968667ab46cac6$var$currentEntangledListeners) {
        var entangledListeners = $c2968667ab46cac6$var$currentEntangledListeners = [];
        $c2968667ab46cac6$var$currentEntangledPendingCount = 0;
        $c2968667ab46cac6$var$currentEntangledLane = $c2968667ab46cac6$var$requestTransitionLane();
        $c2968667ab46cac6$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c2968667ab46cac6$var$currentEntangledPendingCount++;
    thenable.then($c2968667ab46cac6$var$pingEngtangledActionScope, $c2968667ab46cac6$var$pingEngtangledActionScope);
    return thenable;
}
function $c2968667ab46cac6$var$pingEngtangledActionScope() {
    if (0 === --$c2968667ab46cac6$var$currentEntangledPendingCount && null !== $c2968667ab46cac6$var$currentEntangledListeners) {
        null !== $c2968667ab46cac6$var$currentEntangledActionThenable && ($c2968667ab46cac6$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c2968667ab46cac6$var$currentEntangledListeners;
        $c2968667ab46cac6$var$currentEntangledListeners = null;
        $c2968667ab46cac6$var$currentEntangledLane = 0;
        $c2968667ab46cac6$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c2968667ab46cac6$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c2968667ab46cac6$var$prevOnStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
$c2968667ab46cac6$var$ReactSharedInternals.S = function(transition, returnValue) {
    $c2968667ab46cac6$var$globalMostRecentTransitionTime = $c2968667ab46cac6$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c2968667ab46cac6$var$entangleAsyncAction(transition, returnValue);
    null !== $c2968667ab46cac6$var$prevOnStartTransitionFinish && $c2968667ab46cac6$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c2968667ab46cac6$var$resumedCache = $c2968667ab46cac6$var$createCursor(null);
function $c2968667ab46cac6$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c2968667ab46cac6$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c2968667ab46cac6$var$workInProgressRoot.pooledCache;
}
function $c2968667ab46cac6$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c2968667ab46cac6$var$push($c2968667ab46cac6$var$resumedCache, $c2968667ab46cac6$var$resumedCache.current) : $c2968667ab46cac6$var$push($c2968667ab46cac6$var$resumedCache, prevCachePool.pool);
}
function $c2968667ab46cac6$var$getSuspendedCache() {
    var cacheFromPool = $c2968667ab46cac6$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c2968667ab46cac6$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c2968667ab46cac6$var$SuspenseException = Error($c2968667ab46cac6$var$formatProdErrorMessage(460)), $c2968667ab46cac6$var$SuspenseyCommitException = Error($c2968667ab46cac6$var$formatProdErrorMessage(474)), $c2968667ab46cac6$var$SuspenseActionException = Error($c2968667ab46cac6$var$formatProdErrorMessage(542)), $c2968667ab46cac6$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c2968667ab46cac6$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c2968667ab46cac6$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c2968667ab46cac6$var$noop$1, $c2968667ab46cac6$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c2968667ab46cac6$var$noop$1, $c2968667ab46cac6$var$noop$1);
            else {
                thenableState = $c2968667ab46cac6$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c2968667ab46cac6$var$suspendedThenable = thenable;
            throw $c2968667ab46cac6$var$SuspenseException;
    }
}
function $c2968667ab46cac6$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $c2968667ab46cac6$var$suspendedThenable = x, $c2968667ab46cac6$var$SuspenseException;
        throw x;
    }
}
var $c2968667ab46cac6$var$suspendedThenable = null;
function $c2968667ab46cac6$var$getSuspendedThenable() {
    if (null === $c2968667ab46cac6$var$suspendedThenable) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(459));
    var thenable = $c2968667ab46cac6$var$suspendedThenable;
    $c2968667ab46cac6$var$suspendedThenable = null;
    return thenable;
}
function $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c2968667ab46cac6$var$SuspenseException || rejectedReason === $c2968667ab46cac6$var$SuspenseActionException) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(483));
}
var $c2968667ab46cac6$var$thenableState$1 = null, $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
function $c2968667ab46cac6$var$unwrapThenable(thenable) {
    var index = $c2968667ab46cac6$var$thenableIndexCounter$1;
    $c2968667ab46cac6$var$thenableIndexCounter$1 += 1;
    null === $c2968667ab46cac6$var$thenableState$1 && ($c2968667ab46cac6$var$thenableState$1 = []);
    return $c2968667ab46cac6$var$trackUsedThenable($c2968667ab46cac6$var$thenableState$1, thenable, index);
}
function $c2968667ab46cac6$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c2968667ab46cac6$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c2968667ab46cac6$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c2968667ab46cac6$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c2968667ab46cac6$var$REACT_LAZY_TYPE && $c2968667ab46cac6$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c2968667ab46cac6$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c2968667ab46cac6$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c2968667ab46cac6$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c2968667ab46cac6$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c2968667ab46cac6$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c2968667ab46cac6$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return lanes = $c2968667ab46cac6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2968667ab46cac6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return newChild = $c2968667ab46cac6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return newChild = $c2968667ab46cac6$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c2968667ab46cac6$var$REACT_LAZY_TYPE && $c2968667ab46cac6$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c2968667ab46cac6$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE ? (lanes = $c2968667ab46cac6$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c2968667ab46cac6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2968667ab46cac6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c2968667ab46cac6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c2968667ab46cac6$var$getIteratorFn(newChild)) {
                key = $c2968667ab46cac6$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c2968667ab46cac6$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c2968667ab46cac6$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c2968667ab46cac6$var$SuspenseException || x === $c2968667ab46cac6$var$SuspenseActionException) throw x;
            var fiber = $c2968667ab46cac6$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c2968667ab46cac6$var$reconcileChildFibers = $c2968667ab46cac6$var$createChildReconciler(!0), $c2968667ab46cac6$var$mountChildFibers = $c2968667ab46cac6$var$createChildReconciler(!1), $c2968667ab46cac6$var$hasForceUpdate = !1;
function $c2968667ab46cac6$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c2968667ab46cac6$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c2968667ab46cac6$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
        $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c2968667ab46cac6$var$markRootEntangled(root, lane);
    }
}
function $c2968667ab46cac6$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !1;
function $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c2968667ab46cac6$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c2968667ab46cac6$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c2968667ab46cac6$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c2968667ab46cac6$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c2968667ab46cac6$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c2968667ab46cac6$var$currentEntangledLane && ($c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c2968667ab46cac6$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c2968667ab46cac6$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c2968667ab46cac6$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c2968667ab46cac6$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c2968667ab46cac6$var$callCallback(callbacks[updateQueue], context);
}
var $c2968667ab46cac6$var$currentTreeHiddenStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$prevEntangledRenderLanesCursor = $c2968667ab46cac6$var$createCursor(0);
function $c2968667ab46cac6$var$pushHiddenContext(fiber, context) {
    fiber = $c2968667ab46cac6$var$entangledRenderLanes;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$prevEntangledRenderLanesCursor, fiber);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$currentTreeHiddenStackCursor, context);
    $c2968667ab46cac6$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c2968667ab46cac6$var$reuseHiddenContextOnStack() {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$prevEntangledRenderLanesCursor, $c2968667ab46cac6$var$entangledRenderLanes);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$currentTreeHiddenStackCursor, $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current);
}
function $c2968667ab46cac6$var$popHiddenContext() {
    $c2968667ab46cac6$var$entangledRenderLanes = $c2968667ab46cac6$var$prevEntangledRenderLanesCursor.current;
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$currentTreeHiddenStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$prevEntangledRenderLanesCursor);
}
var $c2968667ab46cac6$var$suspenseHandlerStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$shellBoundary = null;
function $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current & 1);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, handler);
    null === $c2968667ab46cac6$var$shellBoundary && (null === current || null !== $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current ? $c2968667ab46cac6$var$shellBoundary = handler : null !== current.memoizedState && ($c2968667ab46cac6$var$shellBoundary = handler));
}
function $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, fiber);
    null === $c2968667ab46cac6$var$shellBoundary && ($c2968667ab46cac6$var$shellBoundary = fiber);
}
function $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current), $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, fiber), null === $c2968667ab46cac6$var$shellBoundary && ($c2968667ab46cac6$var$shellBoundary = fiber)) : $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack() {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, $c2968667ab46cac6$var$suspenseHandlerStackCursor.current);
}
function $c2968667ab46cac6$var$popSuspenseHandler(fiber) {
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseHandlerStackCursor);
    $c2968667ab46cac6$var$shellBoundary === fiber && ($c2968667ab46cac6$var$shellBoundary = null);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
}
var $c2968667ab46cac6$var$suspenseStackCursor = $c2968667ab46cac6$var$createCursor(0);
function $c2968667ab46cac6$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $c2968667ab46cac6$var$isSuspenseInstancePending(state) || $c2968667ab46cac6$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c2968667ab46cac6$var$renderLanes = 0, $c2968667ab46cac6$var$currentlyRenderingFiber = null, $c2968667ab46cac6$var$currentHook = null, $c2968667ab46cac6$var$workInProgressHook = null, $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1, $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c2968667ab46cac6$var$localIdCounter = 0, $c2968667ab46cac6$var$thenableIndexCounter = 0, $c2968667ab46cac6$var$thenableState = null, $c2968667ab46cac6$var$globalClientIdCounter = 0;
function $c2968667ab46cac6$var$throwInvalidHookError() {
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(321));
}
function $c2968667ab46cac6$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c2968667ab46cac6$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c2968667ab46cac6$var$renderLanes = nextRenderLanes;
    $c2968667ab46cac6$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c2968667ab46cac6$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c2968667ab46cac6$var$HooksDispatcherOnMount : $c2968667ab46cac6$var$HooksDispatcherOnUpdate;
    $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c2968667ab46cac6$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c2968667ab46cac6$var$finishRenderingHooks(current) {
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c2968667ab46cac6$var$currentHook && null !== $c2968667ab46cac6$var$currentHook.next;
    $c2968667ab46cac6$var$renderLanes = 0;
    $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1;
    $c2968667ab46cac6$var$thenableIndexCounter = 0;
    $c2968667ab46cac6$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(300));
    null === current || $c2968667ab46cac6$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c2968667ab46cac6$var$checkIfContextChanged(current) && ($c2968667ab46cac6$var$didReceiveUpdate = !0));
}
function $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c2968667ab46cac6$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c2968667ab46cac6$var$thenableState = null);
        $c2968667ab46cac6$var$thenableIndexCounter = 0;
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c2968667ab46cac6$var$TransitionAwareHostComponent() {
    var dispatcher = $c2968667ab46cac6$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c2968667ab46cac6$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c2968667ab46cac6$var$currentHook ? $c2968667ab46cac6$var$currentHook.memoizedState : null) !== dispatcher && ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c2968667ab46cac6$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c2968667ab46cac6$var$localIdCounter;
    $c2968667ab46cac6$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c2968667ab46cac6$var$resetHooksOnUnwind(workInProgress) {
    if ($c2968667ab46cac6$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c2968667ab46cac6$var$renderLanes = 0;
    $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c2968667ab46cac6$var$thenableIndexCounter = $c2968667ab46cac6$var$localIdCounter = 0;
    $c2968667ab46cac6$var$thenableState = null;
}
function $c2968667ab46cac6$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState = $c2968667ab46cac6$var$workInProgressHook = hook : $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$workInProgressHook.next = hook;
    return $c2968667ab46cac6$var$workInProgressHook;
}
function $c2968667ab46cac6$var$updateWorkInProgressHook() {
    if (null === $c2968667ab46cac6$var$currentHook) {
        var nextCurrentHook = $c2968667ab46cac6$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c2968667ab46cac6$var$currentHook.next;
    var nextWorkInProgressHook = null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState : $c2968667ab46cac6$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c2968667ab46cac6$var$workInProgressHook = nextWorkInProgressHook, $c2968667ab46cac6$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c2968667ab46cac6$var$currentlyRenderingFiber.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(467));
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(310));
        }
        $c2968667ab46cac6$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c2968667ab46cac6$var$currentHook.memoizedState,
            baseState: $c2968667ab46cac6$var$currentHook.baseState,
            baseQueue: $c2968667ab46cac6$var$currentHook.baseQueue,
            queue: $c2968667ab46cac6$var$currentHook.queue,
            next: null
        };
        null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState = $c2968667ab46cac6$var$workInProgressHook = nextCurrentHook : $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c2968667ab46cac6$var$workInProgressHook;
}
function $c2968667ab46cac6$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c2968667ab46cac6$var$useThenable(thenable) {
    var index = $c2968667ab46cac6$var$thenableIndexCounter;
    $c2968667ab46cac6$var$thenableIndexCounter += 1;
    null === $c2968667ab46cac6$var$thenableState && ($c2968667ab46cac6$var$thenableState = []);
    thenable = $c2968667ab46cac6$var$trackUsedThenable($c2968667ab46cac6$var$thenableState, thenable, index);
    index = $c2968667ab46cac6$var$currentlyRenderingFiber;
    null === (null === $c2968667ab46cac6$var$workInProgressHook ? index.memoizedState : $c2968667ab46cac6$var$workInProgressHook.next) && (index = index.alternate, $c2968667ab46cac6$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c2968667ab46cac6$var$HooksDispatcherOnMount : $c2968667ab46cac6$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c2968667ab46cac6$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c2968667ab46cac6$var$useThenable(usable);
        if (usable.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return $c2968667ab46cac6$var$readContext(usable);
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(438, String(usable)));
}
function $c2968667ab46cac6$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c2968667ab46cac6$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c2968667ab46cac6$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c2968667ab46cac6$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c2968667ab46cac6$var$updateReducer(reducer) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    return $c2968667ab46cac6$var$updateReducerImpl(hook, $c2968667ab46cac6$var$currentHook, reducer);
}
function $c2968667ab46cac6$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c2968667ab46cac6$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c2968667ab46cac6$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c2968667ab46cac6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($c2968667ab46cac6$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c2968667ab46cac6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= revertLane, $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= updateLane, $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c2968667ab46cac6$var$objectIs(pendingQueue, hook.memoizedState) && ($c2968667ab46cac6$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $c2968667ab46cac6$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c2968667ab46cac6$var$rerenderReducer(reducer) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c2968667ab46cac6$var$objectIs(newState, hook.memoizedState) || ($c2968667ab46cac6$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c2968667ab46cac6$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c2968667ab46cac6$var$currentlyRenderingFiber, hook = $c2968667ab46cac6$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c2968667ab46cac6$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c2968667ab46cac6$var$objectIs(($c2968667ab46cac6$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c2968667ab46cac6$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c2968667ab46cac6$var$updateEffect($c2968667ab46cac6$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c2968667ab46cac6$var$workInProgressHook && $c2968667ab46cac6$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c2968667ab46cac6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c2968667ab46cac6$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $c2968667ab46cac6$var$workInProgressRoot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c2968667ab46cac6$var$renderLanes & 127) || $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c2968667ab46cac6$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) && $c2968667ab46cac6$var$forceStoreRerender(fiber);
}
function $c2968667ab46cac6$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) && $c2968667ab46cac6$var$forceStoreRerender(fiber);
    });
}
function $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c2968667ab46cac6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c2968667ab46cac6$var$forceStoreRerender(fiber) {
    var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c2968667ab46cac6$var$mountStateImpl(initialState) {
    var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c2968667ab46cac6$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c2968667ab46cac6$var$updateReducerImpl(hook, $c2968667ab46cac6$var$currentHook, "function" === typeof reducer ? reducer : $c2968667ab46cac6$var$basicStateReducer);
}
function $c2968667ab46cac6$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c2968667ab46cac6$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c2968667ab46cac6$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c2968667ab46cac6$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, currentTransition = {};
        $c2968667ab46cac6$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c2968667ab46cac6$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $c2968667ab46cac6$var$onActionError(actionQueue, node, error$66);
    }
}
function $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c2968667ab46cac6$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c2968667ab46cac6$var$onActionError(actionQueue, node, error);
    }) : $c2968667ab46cac6$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c2968667ab46cac6$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c2968667ab46cac6$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c2968667ab46cac6$var$runActionStateAction(actionQueue, nextState)));
}
function $c2968667ab46cac6$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c2968667ab46cac6$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c2968667ab46cac6$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c2968667ab46cac6$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c2968667ab46cac6$var$mountActionState(action, initialStateProp) {
    if ($c2968667ab46cac6$var$isHydrating) {
        var ssrFormState = $c2968667ab46cac6$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c2968667ab46cac6$var$currentlyRenderingFiber;
                if ($c2968667ab46cac6$var$isHydrating) {
                    if ($c2968667ab46cac6$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c2968667ab46cac6$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c2968667ab46cac6$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c2968667ab46cac6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c2968667ab46cac6$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c2968667ab46cac6$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2968667ab46cac6$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c2968667ab46cac6$var$dispatchSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c2968667ab46cac6$var$mountStateImpl(!1);
    inRootOrSingleton = $c2968667ab46cac6$var$dispatchOptimisticSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c2968667ab46cac6$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c2968667ab46cac6$var$dispatchActionState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c2968667ab46cac6$var$updateActionState(action) {
    var stateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    return $c2968667ab46cac6$var$updateActionStateImpl(stateHook, $c2968667ab46cac6$var$currentHook, action);
}
function $c2968667ab46cac6$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c2968667ab46cac6$var$updateReducerImpl(stateHook, currentStateHook, $c2968667ab46cac6$var$actionStateReducer)[0];
    stateHook = $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c2968667ab46cac6$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c2968667ab46cac6$var$SuspenseException) throw $c2968667ab46cac6$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 2048, $c2968667ab46cac6$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $c2968667ab46cac6$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c2968667ab46cac6$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c2968667ab46cac6$var$rerenderActionState(action) {
    var stateHook = $c2968667ab46cac6$var$updateWorkInProgressHook(), currentStateHook = $c2968667ab46cac6$var$currentHook;
    if (null !== currentStateHook) return $c2968667ab46cac6$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c2968667ab46cac6$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c2968667ab46cac6$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $c2968667ab46cac6$var$updateRef() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
    $c2968667ab46cac6$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $c2968667ab46cac6$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c2968667ab46cac6$var$currentHook && null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, $c2968667ab46cac6$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c2968667ab46cac6$var$mountEffect(create, deps) {
    $c2968667ab46cac6$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c2968667ab46cac6$var$updateEffect(create, deps) {
    $c2968667ab46cac6$var$updateEffectImpl(2048, 8, create, deps);
}
function $c2968667ab46cac6$var$useEffectEventImpl(payload) {
    $c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $c2968667ab46cac6$var$updateEvent(callback) {
    var ref = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
    $c2968667ab46cac6$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $c2968667ab46cac6$var$updateInsertionEffect(create, deps) {
    return $c2968667ab46cac6$var$updateEffectImpl(4, 2, create, deps);
}
function $c2968667ab46cac6$var$updateLayoutEffect(create, deps) {
    return $c2968667ab46cac6$var$updateEffectImpl(4, 4, create, deps);
}
function $c2968667ab46cac6$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c2968667ab46cac6$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c2968667ab46cac6$var$updateEffectImpl(4, 4, $c2968667ab46cac6$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c2968667ab46cac6$var$mountDebugValue() {}
function $c2968667ab46cac6$var$updateCallback(callback, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c2968667ab46cac6$var$updateMemo(nextCreate, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c2968667ab46cac6$var$renderLanes & 1073741824) && 0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c2968667ab46cac6$var$requestDeferredLane();
    $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= hook;
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c2968667ab46cac6$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c2968667ab46cac6$var$objectIs(value, prevValue)) return value;
    if (null !== $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current) return hook = $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue), $c2968667ab46cac6$var$objectIs(hook, prevValue) || ($c2968667ab46cac6$var$didReceiveUpdate = !0), hook;
    if (0 === ($c2968667ab46cac6$var$renderLanes & 42) || 0 !== ($c2968667ab46cac6$var$renderLanes & 1073741824) && 0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 261930)) return $c2968667ab46cac6$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c2968667ab46cac6$var$requestDeferredLane();
    $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= hook;
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c2968667ab46cac6$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, currentTransition = {};
    $c2968667ab46cac6$var$ReactSharedInternals.T = currentTransition;
    $c2968667ab46cac6$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c2968667ab46cac6$var$chainThenableValue(returnValue, finishedState);
            $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c2968667ab46cac6$var$requestUpdateLane(fiber));
        } else $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, finishedState, $c2968667ab46cac6$var$requestUpdateLane(fiber));
    } catch (error) {
        $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c2968667ab46cac6$var$requestUpdateLane());
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$noop() {}
function $c2968667ab46cac6$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(476));
    var queue = $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber).queue;
    $c2968667ab46cac6$var$startTransition(formFiber, queue, pendingState, $c2968667ab46cac6$var$sharedNotPendingObject, null === action ? $c2968667ab46cac6$var$noop : function() {
        $c2968667ab46cac6$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c2968667ab46cac6$var$sharedNotPendingObject,
        baseState: $c2968667ab46cac6$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
            lastRenderedState: $c2968667ab46cac6$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c2968667ab46cac6$var$requestFormReset$1(formFiber) {
    var stateHook = $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $c2968667ab46cac6$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $c2968667ab46cac6$var$requestUpdateLane());
}
function $c2968667ab46cac6$var$useHostTransitionStatus() {
    return $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$HostTransitionContext);
}
function $c2968667ab46cac6$var$updateId() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$updateRefresh() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c2968667ab46cac6$var$requestUpdateLane();
                fiber = $c2968667ab46cac6$var$createUpdate(lane);
                var root$69 = $c2968667ab46cac6$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(root$69, provider, lane), $c2968667ab46cac6$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $c2968667ab46cac6$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c2968667ab46cac6$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c2968667ab46cac6$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c2968667ab46cac6$var$isRenderPhaseUpdate(fiber) ? $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(action, fiber, lane), $c2968667ab46cac6$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c2968667ab46cac6$var$dispatchSetState(fiber, queue, action) {
    var lane = $c2968667ab46cac6$var$requestUpdateLane();
    $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c2968667ab46cac6$var$objectIs(eagerState, currentState)) return $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c2968667ab46cac6$var$workInProgressRoot && $c2968667ab46cac6$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c2968667ab46cac6$var$scheduleUpdateOnFiber(action, fiber, lane), $c2968667ab46cac6$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c2968667ab46cac6$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c2968667ab46cac6$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c2968667ab46cac6$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c2968667ab46cac6$var$currentlyRenderingFiber || null !== alternate && alternate === $c2968667ab46cac6$var$currentlyRenderingFiber;
}
function $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, update) {
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c2968667ab46cac6$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c2968667ab46cac6$var$markRootEntangled(root, lane);
    }
}
var $c2968667ab46cac6$var$ContextOnlyDispatcher = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$throwInvalidHookError,
    useContext: $c2968667ab46cac6$var$throwInvalidHookError,
    useEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useImperativeHandle: $c2968667ab46cac6$var$throwInvalidHookError,
    useLayoutEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useInsertionEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useMemo: $c2968667ab46cac6$var$throwInvalidHookError,
    useReducer: $c2968667ab46cac6$var$throwInvalidHookError,
    useRef: $c2968667ab46cac6$var$throwInvalidHookError,
    useState: $c2968667ab46cac6$var$throwInvalidHookError,
    useDebugValue: $c2968667ab46cac6$var$throwInvalidHookError,
    useDeferredValue: $c2968667ab46cac6$var$throwInvalidHookError,
    useTransition: $c2968667ab46cac6$var$throwInvalidHookError,
    useSyncExternalStore: $c2968667ab46cac6$var$throwInvalidHookError,
    useId: $c2968667ab46cac6$var$throwInvalidHookError,
    useHostTransitionStatus: $c2968667ab46cac6$var$throwInvalidHookError,
    useFormState: $c2968667ab46cac6$var$throwInvalidHookError,
    useActionState: $c2968667ab46cac6$var$throwInvalidHookError,
    useOptimistic: $c2968667ab46cac6$var$throwInvalidHookError,
    useMemoCache: $c2968667ab46cac6$var$throwInvalidHookError,
    useCacheRefresh: $c2968667ab46cac6$var$throwInvalidHookError
};
$c2968667ab46cac6$var$ContextOnlyDispatcher.useEffectEvent = $c2968667ab46cac6$var$throwInvalidHookError;
var $c2968667ab46cac6$var$HooksDispatcherOnMount = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: function(callback, deps) {
        $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c2968667ab46cac6$var$mountEffectImpl(4194308, 4, $c2968667ab46cac6$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c2968667ab46cac6$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c2968667ab46cac6$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c2968667ab46cac6$var$dispatchReducerAction.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c2968667ab46cac6$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c2968667ab46cac6$var$dispatchSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        return $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c2968667ab46cac6$var$mountStateImpl(!1);
        stateHook = $c2968667ab46cac6$var$startTransition.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c2968667ab46cac6$var$currentlyRenderingFiber, hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        if ($c2968667ab46cac6$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c2968667ab46cac6$var$workInProgressRoot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(349));
            0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 127) || $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c2968667ab46cac6$var$mountEffect($c2968667ab46cac6$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c2968667ab46cac6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c2968667ab46cac6$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook(), identifierPrefix = $c2968667ab46cac6$var$workInProgressRoot.identifierPrefix;
        if ($c2968667ab46cac6$var$isHydrating) {
            var JSCompiler_inline_result = $c2968667ab46cac6$var$treeContextOverflow;
            var idWithLeadingBit = $c2968667ab46cac6$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c2968667ab46cac6$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c2968667ab46cac6$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $c2968667ab46cac6$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$mountActionState,
    useActionState: $c2968667ab46cac6$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c2968667ab46cac6$var$dispatchOptimisticSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: function() {
        return $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = $c2968667ab46cac6$var$refreshCache.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $c2968667ab46cac6$var$HooksDispatcherOnUpdate = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$updateCallback,
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$updateEffect,
    useImperativeHandle: $c2968667ab46cac6$var$updateImperativeHandle,
    useInsertionEffect: $c2968667ab46cac6$var$updateInsertionEffect,
    useLayoutEffect: $c2968667ab46cac6$var$updateLayoutEffect,
    useMemo: $c2968667ab46cac6$var$updateMemo,
    useReducer: $c2968667ab46cac6$var$updateReducer,
    useRef: $c2968667ab46cac6$var$updateRef,
    useState: function() {
        return $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer);
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return $c2968667ab46cac6$var$updateDeferredValueImpl(hook, $c2968667ab46cac6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer)[0], start = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2968667ab46cac6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2968667ab46cac6$var$updateSyncExternalStore,
    useId: $c2968667ab46cac6$var$updateId,
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$updateActionState,
    useActionState: $c2968667ab46cac6$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return $c2968667ab46cac6$var$updateOptimisticImpl(hook, $c2968667ab46cac6$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: $c2968667ab46cac6$var$updateRefresh
};
$c2968667ab46cac6$var$HooksDispatcherOnUpdate.useEffectEvent = $c2968667ab46cac6$var$updateEvent;
var $c2968667ab46cac6$var$HooksDispatcherOnRerender = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$updateCallback,
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$updateEffect,
    useImperativeHandle: $c2968667ab46cac6$var$updateImperativeHandle,
    useInsertionEffect: $c2968667ab46cac6$var$updateInsertionEffect,
    useLayoutEffect: $c2968667ab46cac6$var$updateLayoutEffect,
    useMemo: $c2968667ab46cac6$var$updateMemo,
    useReducer: $c2968667ab46cac6$var$rerenderReducer,
    useRef: $c2968667ab46cac6$var$updateRef,
    useState: function() {
        return $c2968667ab46cac6$var$rerenderReducer($c2968667ab46cac6$var$basicStateReducer);
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return null === $c2968667ab46cac6$var$currentHook ? $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue) : $c2968667ab46cac6$var$updateDeferredValueImpl(hook, $c2968667ab46cac6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c2968667ab46cac6$var$rerenderReducer($c2968667ab46cac6$var$basicStateReducer)[0], start = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2968667ab46cac6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2968667ab46cac6$var$updateSyncExternalStore,
    useId: $c2968667ab46cac6$var$updateId,
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$rerenderActionState,
    useActionState: $c2968667ab46cac6$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        if (null !== $c2968667ab46cac6$var$currentHook) return $c2968667ab46cac6$var$updateOptimisticImpl(hook, $c2968667ab46cac6$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: $c2968667ab46cac6$var$updateRefresh
};
$c2968667ab46cac6$var$HooksDispatcherOnRerender.useEffectEvent = $c2968667ab46cac6$var$updateEvent;
function $c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c2968667ab46cac6$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c2968667ab46cac6$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(payload, inst, lane), $c2968667ab46cac6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(payload, inst, lane), $c2968667ab46cac6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(callback, inst, lane), $c2968667ab46cac6$var$entangleTransitions(callback, inst, lane));
    }
};
function $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c2968667ab46cac6$var$shallowEqual(oldProps, newProps) || !$c2968667ab46cac6$var$shallowEqual(oldState, newState) : !0;
}
function $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c2968667ab46cac6$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c2968667ab46cac6$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c2968667ab46cac6$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $c2968667ab46cac6$var$defaultOnUncaughtError(error) {
    $c2968667ab46cac6$var$reportGlobalError(error);
}
function $c2968667ab46cac6$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c2968667ab46cac6$var$defaultOnRecoverableError(error) {
    $c2968667ab46cac6$var$reportGlobalError(error);
}
function $c2968667ab46cac6$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $c2968667ab46cac6$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $c2968667ab46cac6$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c2968667ab46cac6$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c2968667ab46cac6$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c2968667ab46cac6$var$createClassErrorUpdate(lane) {
    lane = $c2968667ab46cac6$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c2968667ab46cac6$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c2968667ab46cac6$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c2968667ab46cac6$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed ? $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c2968667ab46cac6$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c2968667ab46cac6$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $c2968667ab46cac6$var$shellBoundary ? $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c2968667ab46cac6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c2968667ab46cac6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes);
        $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c2968667ab46cac6$var$isHydrating) return returnFiber = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c2968667ab46cac6$var$HydrationMismatchException && (root = Error($c2968667ab46cac6$var$formatProdErrorMessage(422), {
        cause: value
    }), $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c2968667ab46cac6$var$HydrationMismatchException && (returnFiber = Error($c2968667ab46cac6$var$formatProdErrorMessage(423), {
        cause: value
    }), $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c2968667ab46cac6$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c2968667ab46cac6$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c2968667ab46cac6$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c2968667ab46cac6$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c2968667ab46cac6$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c2968667ab46cac6$var$workInProgressRootConcurrentErrors ? $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c2968667ab46cac6$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c2968667ab46cac6$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c2968667ab46cac6$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c2968667ab46cac6$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed || !$c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c2968667ab46cac6$var$createClassErrorUpdate(rootRenderLanes), $c2968667ab46cac6$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c2968667ab46cac6$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c2968667ab46cac6$var$SelectiveHydrationException = Error($c2968667ab46cac6$var$formatProdErrorMessage(461)), $c2968667ab46cac6$var$didReceiveUpdate = !1;
function $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c2968667ab46cac6$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c2968667ab46cac6$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    nextProps = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && key && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c2968667ab46cac6$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c2968667ab46cac6$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c2968667ab46cac6$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c2968667ab46cac6$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c2968667ab46cac6$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c2968667ab46cac6$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c2968667ab46cac6$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c2968667ab46cac6$var$pushHiddenContext(workInProgress, prevState) : $c2968667ab46cac6$var$reuseHiddenContextOnStack(), $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($c2968667ab46cac6$var$pushTransition(workInProgress, prevState.cachePool), $c2968667ab46cac6$var$pushHiddenContext(workInProgress, prevState), $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null), $c2968667ab46cac6$var$reuseHiddenContextOnStack(), $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $c2968667ab46cac6$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c2968667ab46cac6$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null);
    $c2968667ab46cac6$var$reuseHiddenContextOnStack();
    $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $c2968667ab46cac6$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($c2968667ab46cac6$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, current);
            $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $c2968667ab46cac6$var$nextHydratableInstance) ? (current = $c2968667ab46cac6$var$canHydrateHydrationBoundary(current, $c2968667ab46cac6$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c2968667ab46cac6$var$treeContextProvider ? {
                    id: $c2968667ab46cac6$var$treeContextId,
                    overflow: $c2968667ab46cac6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c2968667ab46cac6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($c2968667ab46cac6$var$formatProdErrorMessage(558));
        } else if ($c2968667ab46cac6$var$didReceiveUpdate || $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $c2968667ab46cac6$var$didReceiveUpdate || didSuspend) {
            nextProps = $c2968667ab46cac6$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $c2968667ab46cac6$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(current, dehydrated), $c2968667ab46cac6$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $c2968667ab46cac6$var$SelectiveHydrationException;
            $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(dehydrated.nextSibling), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$isHydrating = !0, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, null !== current && $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $c2968667ab46cac6$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $c2968667ab46cac6$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    Component = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && nextProps && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c2968667ab46cac6$var$finishRenderingHooks(current);
    Component = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && Component && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c2968667ab46cac6$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c2968667ab46cac6$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c2968667ab46cac6$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c2968667ab46cac6$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c2968667ab46cac6$var$readContext(contextType) : $c2968667ab46cac6$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c2968667ab46cac6$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c2968667ab46cac6$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c2968667ab46cac6$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c2968667ab46cac6$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c2968667ab46cac6$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c2968667ab46cac6$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c2968667ab46cac6$var$hasForceUpdate || $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c2968667ab46cac6$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c2968667ab46cac6$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c2968667ab46cac6$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c2968667ab46cac6$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c2968667ab46cac6$var$hasForceUpdate || null !== current && null !== current.dependencies && $c2968667ab46cac6$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c2968667ab46cac6$var$hasForceUpdate || $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c2968667ab46cac6$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c2968667ab46cac6$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c2968667ab46cac6$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c2968667ab46cac6$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c2968667ab46cac6$var$getSuspendedCache()
    };
}
function $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c2968667ab46cac6$var$workInProgressDeferredLane);
    return current;
}
function $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c2968667ab46cac6$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c2968667ab46cac6$var$isHydrating) {
            showFallback ? $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $c2968667ab46cac6$var$nextHydratableInstance) ? (current = $c2968667ab46cac6$var$canHydrateHydrationBoundary(current, $c2968667ab46cac6$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c2968667ab46cac6$var$treeContextProvider ? {
                    id: $c2968667ab46cac6$var$treeContextId,
                    overflow: $c2968667ab46cac6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c2968667ab46cac6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            $c2968667ab46cac6$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $c2968667ab46cac6$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps);
        $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $c2968667ab46cac6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, workInProgress = $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps));
        else if ($c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), $c2968667ab46cac6$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c2968667ab46cac6$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c2968667ab46cac6$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c2968667ab46cac6$var$didReceiveUpdate || $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c2968667ab46cac6$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c2968667ab46cac6$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $c2968667ab46cac6$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(current, nextProps), $c2968667ab46cac6$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c2968667ab46cac6$var$SelectiveHydrationException;
            $c2968667ab46cac6$var$isSuspenseInstancePending(nextPrimaryChildren) || $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $c2968667ab46cac6$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(nextPrimaryChildren.nextSibling), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$isHydrating = !0, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, null !== current && $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $c2968667ab46cac6$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $c2968667ab46cac6$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $c2968667ab46cac6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $c2968667ab46cac6$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $c2968667ab46cac6$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, $c2968667ab46cac6$var$bailoutOffscreenComponent(current.child, nextProps);
    $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c2968667ab46cac6$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c2968667ab46cac6$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $c2968667ab46cac6$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, suspenseContext);
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $c2968667ab46cac6$var$isHydrating ? $c2968667ab46cac6$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c2968667ab46cac6$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c2968667ab46cac6$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c2968667ab46cac6$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c2968667ab46cac6$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c2968667ab46cac6$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c2968667ab46cac6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, current.memoizedState.cache);
            $c2968667ab46cac6$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c2968667ab46cac6$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c2968667ab46cac6$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, current.memoizedState.cache);
    }
    return $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c2968667ab46cac6$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c2968667ab46cac6$var$didReceiveUpdate = !0;
        else {
            if (!$c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c2968667ab46cac6$var$didReceiveUpdate = !1, $c2968667ab46cac6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c2968667ab46cac6$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c2968667ab46cac6$var$didReceiveUpdate = !1, $c2968667ab46cac6$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c2968667ab46cac6$var$pushTreeId(workInProgress, $c2968667ab46cac6$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $c2968667ab46cac6$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $c2968667ab46cac6$var$shouldConstruct(current) ? (props = $c2968667ab46cac6$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $c2968667ab46cac6$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c2968667ab46cac6$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c2968667ab46cac6$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $c2968667ab46cac6$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c2968667ab46cac6$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c2968667ab46cac6$var$getComponentNameFromType(current) || current;
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $c2968667ab46cac6$var$resolveClassComponentProps(props, workInProgress.pendingProps), $c2968667ab46cac6$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress);
                $c2968667ab46cac6$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props);
                props !== prevState.cache && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, [
                    $c2968667ab46cac6$var$CacheContext
                ], renderLanes, !0);
                $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $c2968667ab46cac6$var$createCapturedValueAtFiber(Error($c2968667ab46cac6$var$formatProdErrorMessage(424)), workInProgress);
                        $c2968667ab46cac6$var$queueHydrationError($$typeof);
                        workInProgress = $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(current.firstChild);
                        $c2968667ab46cac6$var$hydrationParentFiber = workInProgress;
                        $c2968667ab46cac6$var$isHydrating = !0;
                        $c2968667ab46cac6$var$hydrationErrors = null;
                        $c2968667ab46cac6$var$rootOrSingletonContext = !0;
                        renderLanes = $c2968667ab46cac6$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c2968667ab46cac6$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c2968667ab46cac6$var$markRef(current, workInProgress), null === current ? (renderLanes = $c2968667ab46cac6$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c2968667ab46cac6$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer($c2968667ab46cac6$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress, props[$c2968667ab46cac6$var$internalPropsKey] = current, $c2968667ab46cac6$var$setInitialProperties(props, renderLanes, current), $c2968667ab46cac6$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $c2968667ab46cac6$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c2968667ab46cac6$var$pushHostContext(workInProgress), null === current && $c2968667ab46cac6$var$isHydrating && (props = workInProgress.stateNode = $c2968667ab46cac6$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c2968667ab46cac6$var$rootInstanceStackCursor.current), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$rootOrSingletonContext = !0, $$typeof = $c2968667ab46cac6$var$nextHydratableInstance, $c2968667ab46cac6$var$isSingletonScope(workInProgress.type) ? ($c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(props.firstChild)) : $c2968667ab46cac6$var$nextHydratableInstance = $$typeof), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c2968667ab46cac6$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c2968667ab46cac6$var$isHydrating) {
                if ($$typeof = props = $c2968667ab46cac6$var$nextHydratableInstance) props = $c2968667ab46cac6$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $c2968667ab46cac6$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(props.firstChild), $c2968667ab46cac6$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            }
            $c2968667ab46cac6$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $c2968667ab46cac6$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $c2968667ab46cac6$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, $c2968667ab46cac6$var$TransitionAwareHostComponent, null, null, renderLanes), $c2968667ab46cac6$var$HostTransitionContext._currentValue = $$typeof);
            $c2968667ab46cac6$var$markRef(current, workInProgress);
            $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c2968667ab46cac6$var$isHydrating) {
                if (current = renderLanes = $c2968667ab46cac6$var$nextHydratableInstance) renderLanes = $c2968667ab46cac6$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c2968667ab46cac6$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $c2968667ab46cac6$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $c2968667ab46cac6$var$pushProvider(workInProgress, workInProgress.type, props.value), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $c2968667ab46cac6$var$prepareToReadContext(workInProgress), $$typeof = $c2968667ab46cac6$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $c2968667ab46cac6$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $c2968667ab46cac6$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $c2968667ab46cac6$var$prepareToReadContext(workInProgress), props = $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext), null === current ? ($$typeof = $c2968667ab46cac6$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $c2968667ab46cac6$var$workInProgressRoot, prevState = $c2968667ab46cac6$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $c2968667ab46cac6$var$initializeUpdateQueue(workInProgress), $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress), $c2968667ab46cac6$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props)) : (props = prevState.cache, $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props), props !== $$typeof.cache && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, [
                $c2968667ab46cac6$var$CacheContext
            ], renderLanes, !0))), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2968667ab46cac6$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($c2968667ab46cac6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $c2968667ab46cac6$var$suspendedThenable = $c2968667ab46cac6$var$noopSuspenseyCommitThenable, $c2968667ab46cac6$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c2968667ab46cac6$var$preloadResource(resource)) {
        if ($c2968667ab46cac6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $c2968667ab46cac6$var$suspendedThenable = $c2968667ab46cac6$var$noopSuspenseyCommitThenable, $c2968667ab46cac6$var$SuspenseyCommitException;
    }
}
function $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c2968667ab46cac6$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c2968667ab46cac6$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c2968667ab46cac6$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $c2968667ab46cac6$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c2968667ab46cac6$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c2968667ab46cac6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
            $c2968667ab46cac6$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c2968667ab46cac6$var$popHydrationState(workInProgress) ? $c2968667ab46cac6$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable());
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($c2968667ab46cac6$var$markUpdate(workInProgress), null !== nextResource ? ($c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($c2968667ab46cac6$var$markUpdate(workInProgress), $c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c2968667ab46cac6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress), $c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $c2968667ab46cac6$var$popHostContext(workInProgress);
            renderLanes = $c2968667ab46cac6$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c2968667ab46cac6$var$contextStackCursor.current;
                $c2968667ab46cac6$var$popHydrationState(workInProgress) ? $c2968667ab46cac6$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c2968667ab46cac6$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c2968667ab46cac6$var$markUpdate(workInProgress));
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c2968667ab46cac6$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $c2968667ab46cac6$var$contextStackCursor.current;
                if ($c2968667ab46cac6$var$popHydrationState(workInProgress)) $c2968667ab46cac6$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer($c2968667ab46cac6$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    nextResource[$c2968667ab46cac6$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($c2968667ab46cac6$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
                }
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                current = $c2968667ab46cac6$var$rootInstanceStackCursor.current;
                if ($c2968667ab46cac6$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c2968667ab46cac6$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c2968667ab46cac6$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $c2968667ab46cac6$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(557));
                        current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    } else $c2968667ab46cac6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(558));
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c2968667ab46cac6$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
                        type[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    } else $c2968667ab46cac6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c2968667ab46cac6$var$popHostContainer(), null === current && $c2968667ab46cac6$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c2968667ab46cac6$var$popProvider(workInProgress.type), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 19:
            $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $c2968667ab46cac6$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $c2968667ab46cac6$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c2968667ab46cac6$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current & 1 | 2);
                            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $c2968667ab46cac6$var$now() > $c2968667ab46cac6$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $c2968667ab46cac6$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, current), $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$c2968667ab46cac6$var$isHydrating) return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c2968667ab46cac6$var$now() - newProps.renderingStartTime > $c2968667ab46cac6$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $c2968667ab46cac6$var$now(), current.sibling = null, renderLanes = $c2968667ab46cac6$var$suspenseStackCursor.current, $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), $c2968667ab46cac6$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c2968667ab46cac6$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c2968667ab46cac6$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2968667ab46cac6$var$unwindWork(current, workInProgress) {
    $c2968667ab46cac6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), $c2968667ab46cac6$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c2968667ab46cac6$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(340));
                $c2968667ab46cac6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(340));
                $c2968667ab46cac6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor), null;
        case 4:
            return $c2968667ab46cac6$var$popHostContainer(), null;
        case 10:
            return $c2968667ab46cac6$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), $c2968667ab46cac6$var$popHiddenContext(), null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c2968667ab46cac6$var$unwindInterruptedWork(current, interruptedWork) {
    $c2968667ab46cac6$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
            $c2968667ab46cac6$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c2968667ab46cac6$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c2968667ab46cac6$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
            break;
        case 10:
            $c2968667ab46cac6$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            $c2968667ab46cac6$var$popHiddenContext();
            null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache);
            break;
        case 24:
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
    }
}
function $c2968667ab46cac6$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c2968667ab46cac6$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c2968667ab46cac6$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c2968667ab46cac6$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2968667ab46cac6$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2968667ab46cac6$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $c2968667ab46cac6$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c2968667ab46cac6$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c2968667ab46cac6$var$internalPropsKey] = newProps;
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c2968667ab46cac6$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c2968667ab46cac6$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c2968667ab46cac6$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c2968667ab46cac6$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c2968667ab46cac6$var$noop$1));
    else if (4 !== tag && (27 === tag && $c2968667ab46cac6$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $c2968667ab46cac6$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c2968667ab46cac6$var$setInitialProperties(singleton, type, props);
        singleton[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
        singleton[$c2968667ab46cac6$var$internalPropsKey] = props;
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c2968667ab46cac6$var$offscreenSubtreeIsHidden = !1, $c2968667ab46cac6$var$offscreenSubtreeWasHidden = !1, $c2968667ab46cac6$var$needsFormReset = !1, $c2968667ab46cac6$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c2968667ab46cac6$var$nextEffect = null;
function $c2968667ab46cac6$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c2968667ab46cac6$var$eventsEnabled = $c2968667ab46cac6$var$_enabled;
    root = $c2968667ab46cac6$var$getActiveElementDeep(root);
    if ($c2968667ab46cac6$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c2968667ab46cac6$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c2968667ab46cac6$var$_enabled = !1;
    for($c2968667ab46cac6$var$nextEffect = firstChild; null !== $c2968667ab46cac6$var$nextEffect;)if (firstChild = $c2968667ab46cac6$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $c2968667ab46cac6$var$nextEffect = root;
    else for(; null !== $c2968667ab46cac6$var$nextEffect;){
        firstChild = $c2968667ab46cac6$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c2968667ab46cac6$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c2968667ab46cac6$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c2968667ab46cac6$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c2968667ab46cac6$var$nextEffect = root;
            break;
        }
        $c2968667ab46cac6$var$nextEffect = firstChild.return;
    }
}
function $c2968667ab46cac6$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c2968667ab46cac6$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $c2968667ab46cac6$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c2968667ab46cac6$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c2968667ab46cac6$var$commitHostMount(finishedWork);
            flags & 512 && $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c2968667ab46cac6$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c2968667ab46cac6$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c2968667ab46cac6$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
                prevProps = $c2968667ab46cac6$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
                $c2968667ab46cac6$var$offscreenSubtreeIsHidden = flags;
                ($c2968667ab46cac6$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevProps;
                $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c2968667ab46cac6$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c2968667ab46cac6$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c2968667ab46cac6$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c2968667ab46cac6$var$hostParent = null, $c2968667ab46cac6$var$hostParentIsContainer = !1;
function $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c2968667ab46cac6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c2968667ab46cac6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onCommitFiberUnmount) try {
        $c2968667ab46cac6$var$injectedHook.onCommitFiberUnmount($c2968667ab46cac6$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c2968667ab46cac6$var$hostParent, prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$isSingletonScope(deletedFiber.type) && ($c2968667ab46cac6$var$hostParent = deletedFiber.stateNode, $c2968667ab46cac6$var$hostParentIsContainer = !1);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$releaseSingletonInstance(deletedFiber.stateNode);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $c2968667ab46cac6$var$hostParent;
            prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$hostParent = null;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c2968667ab46cac6$var$hostParent) {
                if ($c2968667ab46cac6$var$hostParentIsContainer) try {
                    (9 === $c2968667ab46cac6$var$hostParent.nodeType ? $c2968667ab46cac6$var$hostParent.body : "HTML" === $c2968667ab46cac6$var$hostParent.nodeName ? $c2968667ab46cac6$var$hostParent.ownerDocument.body : $c2968667ab46cac6$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c2968667ab46cac6$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c2968667ab46cac6$var$hostParent && ($c2968667ab46cac6$var$hostParentIsContainer ? (finishedRoot = $c2968667ab46cac6$var$hostParent, $c2968667ab46cac6$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot)) : $c2968667ab46cac6$var$clearHydrationBoundary($c2968667ab46cac6$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c2968667ab46cac6$var$hostParent;
            prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c2968667ab46cac6$var$hostParentIsContainer = !0;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c2968667ab46cac6$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || ($c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c2968667ab46cac6$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = (prevHostParent = $c2968667ab46cac6$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c2968667ab46cac6$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c2968667ab46cac6$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c2968667ab46cac6$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $c2968667ab46cac6$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c2968667ab46cac6$var$isSingletonScope(parent.type)) {
                        $c2968667ab46cac6$var$hostParent = parent.stateNode;
                        $c2968667ab46cac6$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c2968667ab46cac6$var$hostParent = parent.stateNode;
                    $c2968667ab46cac6$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c2968667ab46cac6$var$hostParent = parent.stateNode.containerInfo;
                    $c2968667ab46cac6$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c2968667ab46cac6$var$hostParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(160));
        $c2968667ab46cac6$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c2968667ab46cac6$var$hostParent = null;
        $c2968667ab46cac6$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c2968667ab46cac6$var$currentHoistableRoot = null;
function $c2968667ab46cac6$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c2968667ab46cac6$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c2968667ab46cac6$var$commitHookEffectListMount(3, finishedWork), $c2968667ab46cac6$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            flags & 64 && $c2968667ab46cac6$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c2968667ab46cac6$var$internalHoistableMarker] || currentResource[$c2968667ab46cac6$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
                                        $c2968667ab46cac6$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c2968667ab46cac6$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c2968667ab46cac6$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
                                $c2968667ab46cac6$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c2968667ab46cac6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c2968667ab46cac6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c2968667ab46cac6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c2968667ab46cac6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c2968667ab46cac6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c2968667ab46cac6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c2968667ab46cac6$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c2968667ab46cac6$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c2968667ab46cac6$var$needsFormReset = !0);
            break;
        case 6:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c2968667ab46cac6$var$tagCaches = null;
            hoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(root.containerInfo);
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$currentHoistableRoot = hoistableRoot;
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c2968667ab46cac6$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c2968667ab46cac6$var$needsFormReset && ($c2968667ab46cac6$var$needsFormReset = !1, $c2968667ab46cac6$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            $c2968667ab46cac6$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c2968667ab46cac6$var$globalMostRecentFallbackTime = $c2968667ab46cac6$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $c2968667ab46cac6$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
            $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $c2968667ab46cac6$var$offscreenSubtreeIsHidden || $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(instance, !0) : $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork), $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
    }
}
function $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c2968667ab46cac6$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c2968667ab46cac6$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c2968667ab46cac6$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c2968667ab46cac6$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c2968667ab46cac6$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c2968667ab46cac6$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $c2968667ab46cac6$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $c2968667ab46cac6$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c2968667ab46cac6$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c2968667ab46cac6$var$commitClassCallbacks(finishedWork);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c2968667ab46cac6$var$commitHostMount(finishedWork);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c2968667ab46cac6$var$releaseCache(previousCache));
}
function $c2968667ab46cac6$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c2968667ab46cac6$var$releaseCache(current));
}
function $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2968667ab46cac6$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c2968667ab46cac6$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c2968667ab46cac6$var$suspenseyCommitFlag = 8192;
function $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $c2968667ab46cac6$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $c2968667ab46cac6$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c2968667ab46cac6$var$suspendResource(suspendedState, $c2968667ab46cac6$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $c2968667ab46cac6$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c2968667ab46cac6$var$suspenseyCommitFlag, $c2968667ab46cac6$var$suspenseyCommitFlag = 16777216, $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $c2968667ab46cac6$var$suspenseyCommitFlag = previousHoistableRoot) : $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2968667ab46cac6$var$nextEffect = childToDelete;
            $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c2968667ab46cac6$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2968667ab46cac6$var$nextEffect = childToDelete;
            $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c2968667ab46cac6$var$nextEffect;){
        var fiber = $c2968667ab46cac6$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c2968667ab46cac6$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c2968667ab46cac6$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c2968667ab46cac6$var$nextEffect;){
            cache = $c2968667ab46cac6$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c2968667ab46cac6$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c2968667ab46cac6$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c2968667ab46cac6$var$nextEffect = sibling;
                break a;
            }
            $c2968667ab46cac6$var$nextEffect = returnFiber;
        }
    }
}
var $c2968667ab46cac6$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext).controller.signal;
    }
}, $c2968667ab46cac6$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c2968667ab46cac6$var$executionContext = 0, $c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgress = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0, $c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c2968667ab46cac6$var$workInProgressRootIsPrerendering = !1, $c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !1, $c2968667ab46cac6$var$entangledRenderLanes = 0, $c2968667ab46cac6$var$workInProgressRootExitStatus = 0, $c2968667ab46cac6$var$workInProgressRootSkippedLanes = 0, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes = 0, $c2968667ab46cac6$var$workInProgressRootPingedLanes = 0, $c2968667ab46cac6$var$workInProgressDeferredLane = 0, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = 0, $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = null, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = null, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c2968667ab46cac6$var$globalMostRecentFallbackTime = 0, $c2968667ab46cac6$var$globalMostRecentTransitionTime = 0, $c2968667ab46cac6$var$workInProgressRootRenderTargetTime = Infinity, $c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = null, $c2968667ab46cac6$var$pendingEffectsStatus = 0, $c2968667ab46cac6$var$pendingEffectsRoot = null, $c2968667ab46cac6$var$pendingFinishedWork = null, $c2968667ab46cac6$var$pendingEffectsLanes = 0, $c2968667ab46cac6$var$pendingEffectsRemainingLanes = 0, $c2968667ab46cac6$var$pendingPassiveTransitions = null, $c2968667ab46cac6$var$pendingRecoverableErrors = null, $c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = null;
function $c2968667ab46cac6$var$requestUpdateLane() {
    return 0 !== ($c2968667ab46cac6$var$executionContext & 2) && 0 !== $c2968667ab46cac6$var$workInProgressRootRenderLanes ? $c2968667ab46cac6$var$workInProgressRootRenderLanes & -$c2968667ab46cac6$var$workInProgressRootRenderLanes : null !== $c2968667ab46cac6$var$ReactSharedInternals.T ? $c2968667ab46cac6$var$requestTransitionLane() : $c2968667ab46cac6$var$resolveUpdatePriority();
}
function $c2968667ab46cac6$var$requestDeferredLane() {
    if (0 === $c2968667ab46cac6$var$workInProgressDeferredLane) {
        if (0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912) || $c2968667ab46cac6$var$isHydrating) {
            var lane = $c2968667ab46cac6$var$nextTransitionDeferredLane;
            $c2968667ab46cac6$var$nextTransitionDeferredLane <<= 1;
            0 === ($c2968667ab46cac6$var$nextTransitionDeferredLane & 3932160) && ($c2968667ab46cac6$var$nextTransitionDeferredLane = 262144);
            $c2968667ab46cac6$var$workInProgressDeferredLane = lane;
        } else $c2968667ab46cac6$var$workInProgressDeferredLane = 536870912;
    }
    lane = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $c2968667ab46cac6$var$workInProgressDeferredLane;
}
function $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c2968667ab46cac6$var$workInProgressRoot && (2 === $c2968667ab46cac6$var$workInProgressSuspendedReason || 9 === $c2968667ab46cac6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c2968667ab46cac6$var$prepareFreshStack(root, 0), $c2968667ab46cac6$var$markRootSuspended(root, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1);
    $c2968667ab46cac6$var$markRootUpdated$1(root, lane);
    if (0 === ($c2968667ab46cac6$var$executionContext & 2) || root !== $c2968667ab46cac6$var$workInProgressRoot) root === $c2968667ab46cac6$var$workInProgressRoot && (0 === ($c2968667ab46cac6$var$executionContext & 2) && ($c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c2968667ab46cac6$var$workInProgressRootExitStatus && $c2968667ab46cac6$var$markRootSuspended(root, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1)), $c2968667ab46cac6$var$ensureRootIsScheduled(root);
}
function $c2968667ab46cac6$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c2968667ab46cac6$var$renderRootConcurrent(root$jscomp$0, lanes) : $c2968667ab46cac6$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c2968667ab46cac6$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c2968667ab46cac6$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c2968667ab46cac6$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c2968667ab46cac6$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c2968667ab46cac6$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c2968667ab46cac6$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c2968667ab46cac6$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c2968667ab46cac6$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c2968667ab46cac6$var$workInProgressRootRecoverableErrors;
                            $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c2968667ab46cac6$var$workInProgressRootRecoverableErrors ? $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c2968667ab46cac6$var$workInProgressRootRecoverableErrors.push.apply($c2968667ab46cac6$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c2968667ab46cac6$var$prepareFreshStack(root$jscomp$0, 0);
                $c2968667ab46cac6$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $c2968667ab46cac6$var$markRootSuspended(shouldTimeSlice, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !$c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c2968667ab46cac6$var$globalMostRecentFallbackTime + 300 - $c2968667ab46cac6$var$now(), 10 < exitStatus)) {
                    $c2968667ab46cac6$var$markRootSuspended(shouldTimeSlice, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !$c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c2968667ab46cac6$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $c2968667ab46cac6$var$scheduleTimeout($c2968667ab46cac6$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors, $c2968667ab46cac6$var$workInProgressTransitions, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $c2968667ab46cac6$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors, $c2968667ab46cac6$var$workInProgressTransitions, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $c2968667ab46cac6$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c2968667ab46cac6$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $c2968667ab46cac6$var$noop$1
        };
        $c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $c2968667ab46cac6$var$globalMostRecentFallbackTime - $c2968667ab46cac6$var$now() : (lanes & 4194048) === lanes ? $c2968667ab46cac6$var$globalMostRecentTransitionTime - $c2968667ab46cac6$var$now() : 0;
        timeoutOffset = $c2968667ab46cac6$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($c2968667ab46cac6$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $c2968667ab46cac6$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c2968667ab46cac6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $c2968667ab46cac6$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c2968667ab46cac6$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c2968667ab46cac6$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c2968667ab46cac6$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c2968667ab46cac6$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c2968667ab46cac6$var$flushSyncWork$1() {
    return 0 === ($c2968667ab46cac6$var$executionContext & 6) ? ($c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c2968667ab46cac6$var$resetWorkInProgressStack() {
    if (null !== $c2968667ab46cac6$var$workInProgress) {
        if (0 === $c2968667ab46cac6$var$workInProgressSuspendedReason) var interruptedWork = $c2968667ab46cac6$var$workInProgress.return;
        else interruptedWork = $c2968667ab46cac6$var$workInProgress, $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null, $c2968667ab46cac6$var$resetHooksOnUnwind(interruptedWork), $c2968667ab46cac6$var$thenableState$1 = null, $c2968667ab46cac6$var$thenableIndexCounter$1 = 0, interruptedWork = $c2968667ab46cac6$var$workInProgress;
        for(; null !== interruptedWork;)$c2968667ab46cac6$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c2968667ab46cac6$var$workInProgress = null;
    }
}
function $c2968667ab46cac6$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c2968667ab46cac6$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c2968667ab46cac6$var$pendingEffectsLanes = 0;
    $c2968667ab46cac6$var$resetWorkInProgressStack();
    $c2968667ab46cac6$var$workInProgressRoot = root;
    $c2968667ab46cac6$var$workInProgress = timeoutHandle = $c2968667ab46cac6$var$createWorkInProgress(root.current, null);
    $c2968667ab46cac6$var$workInProgressRootRenderLanes = lanes;
    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
    $c2968667ab46cac6$var$workInProgressThrownValue = null;
    $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c2968667ab46cac6$var$workInProgressRootIsPrerendering = $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, lanes);
    $c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !1;
    $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = $c2968667ab46cac6$var$workInProgressDeferredLane = $c2968667ab46cac6$var$workInProgressRootPingedLanes = $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes = $c2968667ab46cac6$var$workInProgressRootSkippedLanes = $c2968667ab46cac6$var$workInProgressRootExitStatus = 0;
    $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = null;
    $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c2968667ab46cac6$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $c2968667ab46cac6$var$entangledRenderLanes = lanes;
    $c2968667ab46cac6$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c2968667ab46cac6$var$handleThrow(root, thrownValue) {
    $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    thrownValue === $c2968667ab46cac6$var$SuspenseException || thrownValue === $c2968667ab46cac6$var$SuspenseActionException ? (thrownValue = $c2968667ab46cac6$var$getSuspendedThenable(), $c2968667ab46cac6$var$workInProgressSuspendedReason = 3) : thrownValue === $c2968667ab46cac6$var$SuspenseyCommitException ? (thrownValue = $c2968667ab46cac6$var$getSuspendedThenable(), $c2968667ab46cac6$var$workInProgressSuspendedReason = 4) : $c2968667ab46cac6$var$workInProgressSuspendedReason = thrownValue === $c2968667ab46cac6$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c2968667ab46cac6$var$workInProgressThrownValue = thrownValue;
    null === $c2968667ab46cac6$var$workInProgress && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 1, $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c2968667ab46cac6$var$shouldRemainOnPreviousScreen() {
    var handler = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 4194048) === $c2968667ab46cac6$var$workInProgressRootRenderLanes ? null === $c2968667ab46cac6$var$shellBoundary ? !0 : !1 : ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 62914560) === $c2968667ab46cac6$var$workInProgressRootRenderLanes || 0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912) ? handler === $c2968667ab46cac6$var$shellBoundary : !1;
}
function $c2968667ab46cac6$var$pushDispatcher() {
    var prevDispatcher = $c2968667ab46cac6$var$ReactSharedInternals.H;
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c2968667ab46cac6$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c2968667ab46cac6$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c2968667ab46cac6$var$ReactSharedInternals.A;
    $c2968667ab46cac6$var$ReactSharedInternals.A = $c2968667ab46cac6$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible() {
    $c2968667ab46cac6$var$workInProgressRootExitStatus = 4;
    $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings || ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 4194048) !== $c2968667ab46cac6$var$workInProgressRootRenderLanes && null !== $c2968667ab46cac6$var$suspenseHandlerStackCursor.current || ($c2968667ab46cac6$var$workInProgressRootIsPrerendering = !0);
    0 === ($c2968667ab46cac6$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c2968667ab46cac6$var$workInProgressRoot || $c2968667ab46cac6$var$markRootSuspended($c2968667ab46cac6$var$workInProgressRoot, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1);
}
function $c2968667ab46cac6$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
    $c2968667ab46cac6$var$executionContext |= 2;
    var prevDispatcher = $c2968667ab46cac6$var$pushDispatcher(), prevAsyncDispatcher = $c2968667ab46cac6$var$pushAsyncDispatcher();
    if ($c2968667ab46cac6$var$workInProgressRoot !== root || $c2968667ab46cac6$var$workInProgressRootRenderLanes !== lanes) $c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c2968667ab46cac6$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && null !== $c2968667ab46cac6$var$workInProgress) {
            var unitOfWork = $c2968667ab46cac6$var$workInProgress, thrownValue = $c2968667ab46cac6$var$workInProgressThrownValue;
            switch($c2968667ab46cac6$var$workInProgressSuspendedReason){
                case 8:
                    $c2968667ab46cac6$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c2968667ab46cac6$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c2968667ab46cac6$var$workInProgressSuspendedReason;
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c2968667ab46cac6$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c2968667ab46cac6$var$workInProgressSuspendedReason, $c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c2968667ab46cac6$var$workLoopSync();
        exitStatus = $c2968667ab46cac6$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $c2968667ab46cac6$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$executionContext = prevExecutionContext;
    $c2968667ab46cac6$var$ReactSharedInternals.H = prevDispatcher;
    $c2968667ab46cac6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c2968667ab46cac6$var$workInProgress && ($c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0, $c2968667ab46cac6$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c2968667ab46cac6$var$workLoopSync() {
    for(; null !== $c2968667ab46cac6$var$workInProgress;)$c2968667ab46cac6$var$performUnitOfWork($c2968667ab46cac6$var$workInProgress);
}
function $c2968667ab46cac6$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
    $c2968667ab46cac6$var$executionContext |= 2;
    var prevDispatcher = $c2968667ab46cac6$var$pushDispatcher(), prevAsyncDispatcher = $c2968667ab46cac6$var$pushAsyncDispatcher();
    $c2968667ab46cac6$var$workInProgressRoot !== root || $c2968667ab46cac6$var$workInProgressRootRenderLanes !== lanes ? ($c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$workInProgressRootRenderTargetTime = $c2968667ab46cac6$var$now() + 500, $c2968667ab46cac6$var$prepareFreshStack(root, lanes)) : $c2968667ab46cac6$var$workInProgressRootIsPrerendering = $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && null !== $c2968667ab46cac6$var$workInProgress) {
            lanes = $c2968667ab46cac6$var$workInProgress;
            var thrownValue = $c2968667ab46cac6$var$workInProgressThrownValue;
            b: switch($c2968667ab46cac6$var$workInProgressSuspendedReason){
                case 1:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c2968667ab46cac6$var$isThenableResolved(thrownValue)) {
                        $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                        $c2968667ab46cac6$var$workInProgressThrownValue = null;
                        $c2968667ab46cac6$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && 9 !== $c2968667ab46cac6$var$workInProgressSuspendedReason || $c2968667ab46cac6$var$workInProgressRoot !== root || ($c2968667ab46cac6$var$workInProgressSuspendedReason = 7);
                        $c2968667ab46cac6$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c2968667ab46cac6$var$isThenableResolved(thrownValue) ? ($c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$replaySuspendedUnitOfWork(lanes)) : ($c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c2968667ab46cac6$var$workInProgress.tag){
                        case 26:
                            resource = $c2968667ab46cac6$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c2968667ab46cac6$var$workInProgress;
                            if (resource ? $c2968667ab46cac6$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                                $c2968667ab46cac6$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c2968667ab46cac6$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c2968667ab46cac6$var$workInProgress = returnFiber, $c2968667ab46cac6$var$completeUnitOfWork(returnFiber)) : $c2968667ab46cac6$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c2968667ab46cac6$var$resetWorkInProgressStack();
                    $c2968667ab46cac6$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(462));
            }
        }
        $c2968667ab46cac6$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $c2968667ab46cac6$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$ReactSharedInternals.H = prevDispatcher;
    $c2968667ab46cac6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c2968667ab46cac6$var$executionContext = prevExecutionContext;
    if (null !== $c2968667ab46cac6$var$workInProgress) return 0;
    $c2968667ab46cac6$var$workInProgressRoot = null;
    $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0;
    $c2968667ab46cac6$var$finishQueueingConcurrentUpdates();
    return $c2968667ab46cac6$var$workInProgressRootExitStatus;
}
function $c2968667ab46cac6$var$workLoopConcurrentByScheduler() {
    for(; null !== $c2968667ab46cac6$var$workInProgress && !$c2968667ab46cac6$var$shouldYield();)$c2968667ab46cac6$var$performUnitOfWork($c2968667ab46cac6$var$workInProgress);
}
function $c2968667ab46cac6$var$performUnitOfWork(unitOfWork) {
    var next = $c2968667ab46cac6$var$beginWork(unitOfWork.alternate, unitOfWork, $c2968667ab46cac6$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) : $c2968667ab46cac6$var$workInProgress = next;
}
function $c2968667ab46cac6$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c2968667ab46cac6$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c2968667ab46cac6$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c2968667ab46cac6$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c2968667ab46cac6$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c2968667ab46cac6$var$resetHooksOnUnwind(next);
        default:
            $c2968667ab46cac6$var$unwindInterruptedWork(current, next), next = $c2968667ab46cac6$var$workInProgress = $c2968667ab46cac6$var$resetWorkInProgress(next, $c2968667ab46cac6$var$entangledRenderLanes), next = $c2968667ab46cac6$var$beginWork(current, next, $c2968667ab46cac6$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) : $c2968667ab46cac6$var$workInProgress = next;
}
function $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$resetHooksOnUnwind(unitOfWork);
    $c2968667ab46cac6$var$thenableState$1 = null;
    $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c2968667ab46cac6$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c2968667ab46cac6$var$workInProgressRootRenderLanes)) {
            $c2968667ab46cac6$var$workInProgressRootExitStatus = 1;
            $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c2968667ab46cac6$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c2968667ab46cac6$var$workInProgress = returnFiber, error;
        $c2968667ab46cac6$var$workInProgressRootExitStatus = 1;
        $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c2968667ab46cac6$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c2968667ab46cac6$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c2968667ab46cac6$var$workInProgressRootIsPrerendering || 0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c2968667ab46cac6$var$unwindUnitOfWork(unitOfWork, root);
    } else $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork);
}
function $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c2968667ab46cac6$var$unwindUnitOfWork(completedWork, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c2968667ab46cac6$var$completeWork(completedWork.alternate, completedWork, $c2968667ab46cac6$var$entangledRenderLanes);
        if (null !== next) {
            $c2968667ab46cac6$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c2968667ab46cac6$var$workInProgress = completedWork;
            return;
        }
        $c2968667ab46cac6$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 5);
}
function $c2968667ab46cac6$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c2968667ab46cac6$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c2968667ab46cac6$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c2968667ab46cac6$var$workInProgress = unitOfWork;
            return;
        }
        $c2968667ab46cac6$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c2968667ab46cac6$var$workInProgressRootExitStatus = 6;
    $c2968667ab46cac6$var$workInProgress = null;
}
function $c2968667ab46cac6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $c2968667ab46cac6$var$flushPendingEffects();
    while (0 !== $c2968667ab46cac6$var$pendingEffectsStatus);
    if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $c2968667ab46cac6$var$concurrentlyUpdatedLanes;
        $c2968667ab46cac6$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $c2968667ab46cac6$var$workInProgressRoot && ($c2968667ab46cac6$var$workInProgress = $c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0);
        $c2968667ab46cac6$var$pendingFinishedWork = finishedWork;
        $c2968667ab46cac6$var$pendingEffectsRoot = root;
        $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
        $c2968667ab46cac6$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $c2968667ab46cac6$var$pendingPassiveTransitions = transitions;
        $c2968667ab46cac6$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $c2968667ab46cac6$var$scheduleCallback$1($c2968667ab46cac6$var$NormalPriority$1, function() {
            $c2968667ab46cac6$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            transitions = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $c2968667ab46cac6$var$executionContext = spawnedLane, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = transitions, $c2968667ab46cac6$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $c2968667ab46cac6$var$pendingEffectsStatus = 1;
        $c2968667ab46cac6$var$flushMutationEffects();
        $c2968667ab46cac6$var$flushLayoutEffects();
        $c2968667ab46cac6$var$flushSpawnedWork();
    }
}
function $c2968667ab46cac6$var$flushMutationEffects() {
    if (1 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $c2968667ab46cac6$var$selectionInformation, curFocusedElem = $c2968667ab46cac6$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c2968667ab46cac6$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c2968667ab46cac6$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c2968667ab46cac6$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c2968667ab46cac6$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c2968667ab46cac6$var$_enabled = !!$c2968667ab46cac6$var$eventsEnabled;
                $c2968667ab46cac6$var$selectionInformation = $c2968667ab46cac6$var$eventsEnabled = null;
            } finally{
                $c2968667ab46cac6$var$executionContext = prevExecutionContext, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c2968667ab46cac6$var$pendingEffectsStatus = 2;
    }
}
function $c2968667ab46cac6$var$flushLayoutEffects() {
    if (2 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c2968667ab46cac6$var$executionContext = prevExecutionContext, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c2968667ab46cac6$var$pendingEffectsStatus = 3;
    }
}
function $c2968667ab46cac6$var$flushSpawnedWork() {
    if (4 === $c2968667ab46cac6$var$pendingEffectsStatus || 3 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        $c2968667ab46cac6$var$requestPaint();
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, lanes = $c2968667ab46cac6$var$pendingEffectsLanes, recoverableErrors = $c2968667ab46cac6$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $c2968667ab46cac6$var$pendingEffectsStatus = 5 : ($c2968667ab46cac6$var$pendingEffectsStatus = 0, $c2968667ab46cac6$var$pendingFinishedWork = $c2968667ab46cac6$var$pendingEffectsRoot = null, $c2968667ab46cac6$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c2968667ab46cac6$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onCommitFiberRoot) try {
            $c2968667ab46cac6$var$injectedHook.onCommitFiberRoot($c2968667ab46cac6$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c2968667ab46cac6$var$ReactSharedInternals.T;
            remainingLanes = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c2968667ab46cac6$var$ReactSharedInternals.T = finishedWork, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($c2968667ab46cac6$var$pendingEffectsLanes & 3) && $c2968667ab46cac6$var$flushPendingEffects();
        $c2968667ab46cac6$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $c2968667ab46cac6$var$rootWithNestedUpdates ? $c2968667ab46cac6$var$nestedUpdateCount++ : ($c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = root) : $c2968667ab46cac6$var$nestedUpdateCount = 0;
        $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c2968667ab46cac6$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c2968667ab46cac6$var$releaseCache(remainingLanes)));
}
function $c2968667ab46cac6$var$flushPendingEffects() {
    $c2968667ab46cac6$var$flushMutationEffects();
    $c2968667ab46cac6$var$flushLayoutEffects();
    $c2968667ab46cac6$var$flushSpawnedWork();
    return $c2968667ab46cac6$var$flushPassiveEffects();
}
function $c2968667ab46cac6$var$flushPassiveEffects() {
    if (5 !== $c2968667ab46cac6$var$pendingEffectsStatus) return !1;
    var root = $c2968667ab46cac6$var$pendingEffectsRoot, remainingLanes = $c2968667ab46cac6$var$pendingEffectsRemainingLanes;
    $c2968667ab46cac6$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c2968667ab46cac6$var$lanesToEventPriority($c2968667ab46cac6$var$pendingEffectsLanes), prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c2968667ab46cac6$var$ReactSharedInternals.T = null;
        renderPriority = $c2968667ab46cac6$var$pendingPassiveTransitions;
        $c2968667ab46cac6$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c2968667ab46cac6$var$pendingEffectsRoot, lanes = $c2968667ab46cac6$var$pendingEffectsLanes;
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        $c2968667ab46cac6$var$pendingFinishedWork = $c2968667ab46cac6$var$pendingEffectsRoot = null;
        $c2968667ab46cac6$var$pendingEffectsLanes = 0;
        if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
        $c2968667ab46cac6$var$executionContext |= 4;
        $c2968667ab46cac6$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c2968667ab46cac6$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c2968667ab46cac6$var$executionContext = prevExecutionContext;
        $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onPostCommitFiberRoot) try {
            $c2968667ab46cac6$var$injectedHook.onPostCommitFiberRoot($c2968667ab46cac6$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition, $c2968667ab46cac6$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c2968667ab46cac6$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c2968667ab46cac6$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c2968667ab46cac6$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c2968667ab46cac6$var$markRootUpdated$1(rootFiber, 2), $c2968667ab46cac6$var$ensureRootIsScheduled(rootFiber));
}
function $c2968667ab46cac6$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed || !$c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c2968667ab46cac6$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c2968667ab46cac6$var$createClassErrorUpdate(2);
                instance = $c2968667ab46cac6$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c2968667ab46cac6$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c2968667ab46cac6$var$markRootUpdated$1(instance, 2), $c2968667ab46cac6$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c2968667ab46cac6$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c2968667ab46cac6$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c2968667ab46cac6$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c2968667ab46cac6$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c2968667ab46cac6$var$workInProgressRoot === root && ($c2968667ab46cac6$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c2968667ab46cac6$var$workInProgressRootExitStatus || 3 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 62914560) === $c2968667ab46cac6$var$workInProgressRootRenderLanes && 300 > $c2968667ab46cac6$var$now() - $c2968667ab46cac6$var$globalMostRecentFallbackTime ? 0 === ($c2968667ab46cac6$var$executionContext & 2) && $c2968667ab46cac6$var$prepareFreshStack(root, 0) : $c2968667ab46cac6$var$workInProgressRootPingedLanes |= pingedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes === $c2968667ab46cac6$var$workInProgressRootRenderLanes && ($c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = 0));
    $c2968667ab46cac6$var$ensureRootIsScheduled(root);
}
function $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c2968667ab46cac6$var$claimNextRetryLane());
    boundaryFiber = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c2968667ab46cac6$var$markRootUpdated$1(boundaryFiber, retryLane), $c2968667ab46cac6$var$ensureRootIsScheduled(boundaryFiber));
}
function $c2968667ab46cac6$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2968667ab46cac6$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2968667ab46cac6$var$scheduleCallback$1(priorityLevel, callback) {
    return $c2968667ab46cac6$var$scheduleCallback$3(priorityLevel, callback);
}
var $c2968667ab46cac6$var$firstScheduledRoot = null, $c2968667ab46cac6$var$lastScheduledRoot = null, $c2968667ab46cac6$var$didScheduleMicrotask = !1, $c2968667ab46cac6$var$mightHavePendingSyncWork = !1, $c2968667ab46cac6$var$isFlushingWork = !1, $c2968667ab46cac6$var$currentEventTransitionLane = 0;
function $c2968667ab46cac6$var$ensureRootIsScheduled(root) {
    root !== $c2968667ab46cac6$var$lastScheduledRoot && null === root.next && (null === $c2968667ab46cac6$var$lastScheduledRoot ? $c2968667ab46cac6$var$firstScheduledRoot = $c2968667ab46cac6$var$lastScheduledRoot = root : $c2968667ab46cac6$var$lastScheduledRoot = $c2968667ab46cac6$var$lastScheduledRoot.next = root);
    $c2968667ab46cac6$var$mightHavePendingSyncWork = !0;
    $c2968667ab46cac6$var$didScheduleMicrotask || ($c2968667ab46cac6$var$didScheduleMicrotask = !0, $c2968667ab46cac6$var$scheduleImmediateRootScheduleTask());
}
function $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c2968667ab46cac6$var$isFlushingWork && $c2968667ab46cac6$var$mightHavePendingSyncWork) {
        $c2968667ab46cac6$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $c2968667ab46cac6$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c2968667ab46cac6$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c2968667ab46cac6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c2968667ab46cac6$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c2968667ab46cac6$var$getNextLanes(root$170, root$170 === $c2968667ab46cac6$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c2968667ab46cac6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $c2968667ab46cac6$var$isFlushingWork = !1;
    }
}
function $c2968667ab46cac6$var$processRootScheduleInImmediateTask() {
    $c2968667ab46cac6$var$processRootScheduleInMicrotask();
}
function $c2968667ab46cac6$var$processRootScheduleInMicrotask() {
    $c2968667ab46cac6$var$mightHavePendingSyncWork = $c2968667ab46cac6$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c2968667ab46cac6$var$currentEventTransitionLane && $c2968667ab46cac6$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c2968667ab46cac6$var$currentEventTransitionLane);
    for(var currentTime = $c2968667ab46cac6$var$now(), prev = null, root = $c2968667ab46cac6$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c2968667ab46cac6$var$firstScheduledRoot = next : prev.next = next, null === next && ($c2968667ab46cac6$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c2968667ab46cac6$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $c2968667ab46cac6$var$pendingEffectsStatus && 5 !== $c2968667ab46cac6$var$pendingEffectsStatus || $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $c2968667ab46cac6$var$currentEventTransitionLane && ($c2968667ab46cac6$var$currentEventTransitionLane = 0);
}
function $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c2968667ab46cac6$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c2968667ab46cac6$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c2968667ab46cac6$var$workInProgressRoot;
    suspendedLanes = $c2968667ab46cac6$var$workInProgressRootRenderLanes;
    suspendedLanes = $c2968667ab46cac6$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c2968667ab46cac6$var$workInProgressSuspendedReason || 9 === $c2968667ab46cac6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes);
        switch($c2968667ab46cac6$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c2968667ab46cac6$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c2968667ab46cac6$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c2968667ab46cac6$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c2968667ab46cac6$var$NormalPriority$1;
        }
        pingedLanes = $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c2968667ab46cac6$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c2968667ab46cac6$var$pendingEffectsStatus && 5 !== $c2968667ab46cac6$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c2968667ab46cac6$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c2968667ab46cac6$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c2968667ab46cac6$var$getNextLanes(root, root === $c2968667ab46cac6$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c2968667ab46cac6$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, $c2968667ab46cac6$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c2968667ab46cac6$var$performSyncWorkOnRoot(root, lanes) {
    if ($c2968667ab46cac6$var$flushPendingEffects()) return null;
    $c2968667ab46cac6$var$performWorkOnRoot(root, lanes, !0);
}
function $c2968667ab46cac6$var$scheduleImmediateRootScheduleTask() {
    $c2968667ab46cac6$var$scheduleMicrotask(function() {
        0 !== ($c2968667ab46cac6$var$executionContext & 6) ? $c2968667ab46cac6$var$scheduleCallback$3($c2968667ab46cac6$var$ImmediatePriority, $c2968667ab46cac6$var$processRootScheduleInImmediateTask) : $c2968667ab46cac6$var$processRootScheduleInMicrotask();
    });
}
function $c2968667ab46cac6$var$requestTransitionLane() {
    if (0 === $c2968667ab46cac6$var$currentEventTransitionLane) {
        var actionScopeLane = $c2968667ab46cac6$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $c2968667ab46cac6$var$nextTransitionUpdateLane, $c2968667ab46cac6$var$nextTransitionUpdateLane <<= 1, 0 === ($c2968667ab46cac6$var$nextTransitionUpdateLane & 261888) && ($c2968667ab46cac6$var$nextTransitionUpdateLane = 256));
        $c2968667ab46cac6$var$currentEventTransitionLane = actionScopeLane;
    }
    return $c2968667ab46cac6$var$currentEventTransitionLane;
}
function $c2968667ab46cac6$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c2968667ab46cac6$var$sanitizeURL("" + actionProp);
}
function $c2968667ab46cac6$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c2968667ab46cac6$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c2968667ab46cac6$var$coerceFormActionProp((nativeEventTarget[$c2968667ab46cac6$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c2968667ab46cac6$var$internalPropsKey] || null) ? $c2968667ab46cac6$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c2968667ab46cac6$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c2968667ab46cac6$var$currentEventTransitionLane) {
                                var formData = submitter ? $c2968667ab46cac6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c2968667ab46cac6$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c2968667ab46cac6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c2968667ab46cac6$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c2968667ab46cac6$var$i$jscomp$inline_1577 = 0; $c2968667ab46cac6$var$i$jscomp$inline_1577 < $c2968667ab46cac6$var$simpleEventPluginEvents.length; $c2968667ab46cac6$var$i$jscomp$inline_1577++){
    var $c2968667ab46cac6$var$eventName$jscomp$inline_1578 = $c2968667ab46cac6$var$simpleEventPluginEvents[$c2968667ab46cac6$var$i$jscomp$inline_1577], $c2968667ab46cac6$var$domEventName$jscomp$inline_1579 = $c2968667ab46cac6$var$eventName$jscomp$inline_1578.toLowerCase(), $c2968667ab46cac6$var$capitalizedEvent$jscomp$inline_1580 = $c2968667ab46cac6$var$eventName$jscomp$inline_1578[0].toUpperCase() + $c2968667ab46cac6$var$eventName$jscomp$inline_1578.slice(1);
    $c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$domEventName$jscomp$inline_1579, "on" + $c2968667ab46cac6$var$capitalizedEvent$jscomp$inline_1580);
}
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_END, "onAnimationEnd");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_ITERATION, "onAnimationIteration");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_START, "onAnimationStart");
$c2968667ab46cac6$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c2968667ab46cac6$var$registerSimpleEvent("focusin", "onFocus");
$c2968667ab46cac6$var$registerSimpleEvent("focusout", "onBlur");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_RUN, "onTransitionRun");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_START, "onTransitionStart");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_CANCEL, "onTransitionCancel");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_END, "onTransitionEnd");
$c2968667ab46cac6$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c2968667ab46cac6$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c2968667ab46cac6$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c2968667ab46cac6$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c2968667ab46cac6$var$mediaEventTypes));
function $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2968667ab46cac6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2968667ab46cac6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c2968667ab46cac6$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c2968667ab46cac6$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c2968667ab46cac6$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c2968667ab46cac6$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c2968667ab46cac6$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c2968667ab46cac6$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c2968667ab46cac6$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c2968667ab46cac6$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c2968667ab46cac6$var$listeningMarker]) {
        rootContainerElement[$c2968667ab46cac6$var$listeningMarker] = !0;
        $c2968667ab46cac6$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c2968667ab46cac6$var$nonDelegatedEvents.has(domEventName) || $c2968667ab46cac6$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c2968667ab46cac6$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c2968667ab46cac6$var$listeningMarker] || (ownerDocument[$c2968667ab46cac6$var$listeningMarker] = !0, $c2968667ab46cac6$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c2968667ab46cac6$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c2968667ab46cac6$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c2968667ab46cac6$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c2968667ab46cac6$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c2968667ab46cac6$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c2968667ab46cac6$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c2968667ab46cac6$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c2968667ab46cac6$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c2968667ab46cac6$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c2968667ab46cac6$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c2968667ab46cac6$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticTouchEvent;
                        break;
                    case $c2968667ab46cac6$var$ANIMATION_END:
                    case $c2968667ab46cac6$var$ANIMATION_ITERATION:
                    case $c2968667ab46cac6$var$ANIMATION_START:
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticAnimationEvent;
                        break;
                    case $c2968667ab46cac6$var$TRANSITION_END:
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c2968667ab46cac6$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c2968667ab46cac6$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c2968667ab46cac6$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c2968667ab46cac6$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c2968667ab46cac6$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c2968667ab46cac6$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c2968667ab46cac6$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c2968667ab46cac6$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c2968667ab46cac6$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c2968667ab46cac6$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c2968667ab46cac6$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c2968667ab46cac6$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $c2968667ab46cac6$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c2968667ab46cac6$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForChangeEvent;
                else if ($c2968667ab46cac6$var$isTextInputElement(reactName)) {
                    if ($c2968667ab46cac6$var$isInputEventSupported) getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c2968667ab46cac6$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c2968667ab46cac6$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c2968667ab46cac6$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c2968667ab46cac6$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c2968667ab46cac6$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c2968667ab46cac6$var$activeElement = handleEventFunc, $c2968667ab46cac6$var$activeElementInst = targetInst, $c2968667ab46cac6$var$lastSelection = null;
                    break;
                case "focusout":
                    $c2968667ab46cac6$var$lastSelection = $c2968667ab46cac6$var$activeElementInst = $c2968667ab46cac6$var$activeElement = null;
                    break;
                case "mousedown":
                    $c2968667ab46cac6$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c2968667ab46cac6$var$mouseDown = !1;
                    $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c2968667ab46cac6$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c2968667ab46cac6$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c2968667ab46cac6$var$isComposing ? $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c2968667ab46cac6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c2968667ab46cac6$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c2968667ab46cac6$var$isComposing && (fallbackData = $c2968667ab46cac6$var$getData()) : ($c2968667ab46cac6$var$root = nativeEventTarget, $c2968667ab46cac6$var$startText = "value" in $c2968667ab46cac6$var$root ? $c2968667ab46cac6$var$root.value : $c2968667ab46cac6$var$root.textContent, $c2968667ab46cac6$var$isComposing = !0)), handleEventFunc = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c2968667ab46cac6$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c2968667ab46cac6$var$canUseTextInputEvent ? $c2968667ab46cac6$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c2968667ab46cac6$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c2968667ab46cac6$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c2968667ab46cac6$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c2968667ab46cac6$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c2968667ab46cac6$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c2968667ab46cac6$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c2968667ab46cac6$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c2968667ab46cac6$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c2968667ab46cac6$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c2968667ab46cac6$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c2968667ab46cac6$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c2968667ab46cac6$var$getListener(target, registrationName), null != stateNode && listeners.push($c2968667ab46cac6$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c2968667ab46cac6$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c2968667ab46cac6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c2968667ab46cac6$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c2968667ab46cac6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c2968667ab46cac6$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c2968667ab46cac6$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c2968667ab46cac6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $c2968667ab46cac6$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c2968667ab46cac6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c2968667ab46cac6$var$setProp(domElement, tag, "name", props.name, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c2968667ab46cac6$var$setProp(domElement, tag, "encType", props.encType, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "method", props.method, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2968667ab46cac6$var$noop$1);
            break;
        case "onScroll":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2968667ab46cac6$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c2968667ab46cac6$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c2968667ab46cac6$var$aliases.get(key) || key, $c2968667ab46cac6$var$setValueForAttribute(domElement, key, value);
    }
}
function $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c2968667ab46cac6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c2968667ab46cac6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $c2968667ab46cac6$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2968667ab46cac6$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c2968667ab46cac6$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c2968667ab46cac6$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c2968667ab46cac6$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c2968667ab46cac6$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                    default:
                        $c2968667ab46cac6$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c2968667ab46cac6$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c2968667ab46cac6$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c2968667ab46cac6$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $c2968667ab46cac6$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c2968667ab46cac6$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c2968667ab46cac6$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c2968667ab46cac6$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("cancel", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c2968667ab46cac6$var$mediaEventTypes.length; hasSrc++)$c2968667ab46cac6$var$listenToNonDelegatedEvent($c2968667ab46cac6$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement), $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c2968667ab46cac6$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c2968667ab46cac6$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c2968667ab46cac6$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c2968667ab46cac6$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $c2968667ab46cac6$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c2968667ab46cac6$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c2968667ab46cac6$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, tag, !0) : $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c2968667ab46cac6$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c2968667ab46cac6$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($c2968667ab46cac6$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $c2968667ab46cac6$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $c2968667ab46cac6$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $c2968667ab46cac6$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $c2968667ab46cac6$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $c2968667ab46cac6$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $c2968667ab46cac6$var$eventsEnabled = null, $c2968667ab46cac6$var$selectionInformation = null;
function $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c2968667ab46cac6$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c2968667ab46cac6$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c2968667ab46cac6$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c2968667ab46cac6$var$currentPopstateTransitionEvent = null;
function $c2968667ab46cac6$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c2968667ab46cac6$var$currentPopstateTransitionEvent) return !1;
        $c2968667ab46cac6$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c2968667ab46cac6$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c2968667ab46cac6$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c2968667ab46cac6$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c2968667ab46cac6$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c2968667ab46cac6$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c2968667ab46cac6$var$localPromise ? function(callback) {
    return $c2968667ab46cac6$var$localPromise.resolve(null).then(callback).catch($c2968667ab46cac6$var$handleErrorInNextTick);
} : $c2968667ab46cac6$var$scheduleTimeout;
function $c2968667ab46cac6$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c2968667ab46cac6$var$isSingletonScope(type) {
    return "head" === type;
}
function $c2968667ab46cac6$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c2968667ab46cac6$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $c2968667ab46cac6$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $c2968667ab46cac6$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$c2968667ab46cac6$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $c2968667ab46cac6$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $c2968667ab46cac6$var$retryIfBlockedOn(hydrationInstance);
}
function $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $c2968667ab46cac6$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c2968667ab46cac6$var$clearContainerSparingly(node);
                $c2968667ab46cac6$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c2968667ab46cac6$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c2968667ab46cac6$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c2968667ab46cac6$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c2968667ab46cac6$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c2968667ab46cac6$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $c2968667ab46cac6$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $c2968667ab46cac6$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c2968667ab46cac6$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = null;
function $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $c2968667ab46cac6$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $c2968667ab46cac6$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c2968667ab46cac6$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(451));
    }
}
function $c2968667ab46cac6$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c2968667ab46cac6$var$detachDeletedInstance(instance);
}
var $c2968667ab46cac6$var$preloadPropsMap = new Map(), $c2968667ab46cac6$var$preconnectsSet = new Set();
function $c2968667ab46cac6$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $c2968667ab46cac6$var$previousDispatcher = $c2968667ab46cac6$var$ReactDOMSharedInternals.d;
$c2968667ab46cac6$var$ReactDOMSharedInternals.d = {
    f: $c2968667ab46cac6$var$flushSyncWork,
    r: $c2968667ab46cac6$var$requestFormReset,
    D: $c2968667ab46cac6$var$prefetchDNS,
    C: $c2968667ab46cac6$var$preconnect,
    L: $c2968667ab46cac6$var$preload,
    m: $c2968667ab46cac6$var$preloadModule,
    X: $c2968667ab46cac6$var$preinitScript,
    S: $c2968667ab46cac6$var$preinitStyle,
    M: $c2968667ab46cac6$var$preinitModuleScript
};
function $c2968667ab46cac6$var$flushSyncWork() {
    var previousWasRendering = $c2968667ab46cac6$var$previousDispatcher.f(), wasRendering = $c2968667ab46cac6$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c2968667ab46cac6$var$requestFormReset(form) {
    var formInst = $c2968667ab46cac6$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c2968667ab46cac6$var$requestFormReset$1(formInst) : $c2968667ab46cac6$var$previousDispatcher.r(form);
}
var $c2968667ab46cac6$var$globalDocument = "undefined" === typeof document ? null : document;
function $c2968667ab46cac6$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c2968667ab46cac6$var$preconnectsSet.has(limitedEscapedHref) || ($c2968667ab46cac6$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c2968667ab46cac6$var$setInitialProperties(href, "link", rel), $c2968667ab46cac6$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c2968667ab46cac6$var$prefetchDNS(href) {
    $c2968667ab46cac6$var$previousDispatcher.D(href);
    $c2968667ab46cac6$var$preconnectAs("dns-prefetch", href, null);
}
function $c2968667ab46cac6$var$preconnect(href, crossOrigin) {
    $c2968667ab46cac6$var$previousDispatcher.C(href, crossOrigin);
    $c2968667ab46cac6$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c2968667ab46cac6$var$preload(href, as, options) {
    $c2968667ab46cac6$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c2968667ab46cac6$var$getStyleKey(href);
                break;
            case "script":
                key = $c2968667ab46cac6$var$getScriptKey(href);
        }
        $c2968667ab46cac6$var$preloadPropsMap.has(key) || (href = $c2968667ab46cac6$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c2968667ab46cac6$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c2968667ab46cac6$var$setInitialProperties(as, "link", href), $c2968667ab46cac6$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c2968667ab46cac6$var$preloadModule(href, options) {
    $c2968667ab46cac6$var$previousDispatcher.m(href, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c2968667ab46cac6$var$getScriptKey(href);
        }
        if (!$c2968667ab46cac6$var$preloadPropsMap.has(key) && (href = $c2968667ab46cac6$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c2968667ab46cac6$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c2968667ab46cac6$var$setInitialProperties(as, "link", href);
            $c2968667ab46cac6$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c2968667ab46cac6$var$preinitStyle(href, precedence, options) {
    $c2968667ab46cac6$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c2968667ab46cac6$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c2968667ab46cac6$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c2968667ab46cac6$var$markNodeAsHoistable(link);
                $c2968667ab46cac6$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c2968667ab46cac6$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c2968667ab46cac6$var$preinitScript(src, options) {
    $c2968667ab46cac6$var$previousDispatcher.X(src, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2968667ab46cac6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)), resource || (src = $c2968667ab46cac6$var$assign({
            src: src,
            async: !0
        }, options), (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2968667ab46cac6$var$markNodeAsHoistable(resource), $c2968667ab46cac6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2968667ab46cac6$var$preinitModuleScript(src, options) {
    $c2968667ab46cac6$var$previousDispatcher.M(src, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2968667ab46cac6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)), resource || (src = $c2968667ab46cac6$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2968667ab46cac6$var$markNodeAsHoistable(resource), $c2968667ab46cac6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2968667ab46cac6$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c2968667ab46cac6$var$rootInstanceStackCursor.current) ? $c2968667ab46cac6$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c2968667ab46cac6$var$getStyleKey(pendingProps.href), pendingProps = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c2968667ab46cac6$var$getStyleKey(pendingProps.href);
                var styles$243 = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $c2968667ab46cac6$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c2968667ab46cac6$var$preloadPropsMap.set(type, pendingProps), styles$243 || $c2968667ab46cac6$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $c2968667ab46cac6$var$getScriptKey(pendingProps), pendingProps = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(444, type));
    }
}
function $c2968667ab46cac6$var$getStyleKey(href) {
    return 'href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c2968667ab46cac6$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c2968667ab46cac6$var$stylesheetPropsFromRawProps(rawProps) {
    return $c2968667ab46cac6$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c2968667ab46cac6$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c2968667ab46cac6$var$setInitialProperties(key, "link", preloadProps), $c2968667ab46cac6$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c2968667ab46cac6$var$getScriptKey(src) {
    return '[src="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c2968667ab46cac6$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c2968667ab46cac6$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c2968667ab46cac6$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c2968667ab46cac6$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance);
            $c2968667ab46cac6$var$setInitialProperties(instance, "style", styleProps);
            $c2968667ab46cac6$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c2968667ab46cac6$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $c2968667ab46cac6$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $c2968667ab46cac6$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c2968667ab46cac6$var$preloadPropsMap.get(styleProps)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2968667ab46cac6$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $c2968667ab46cac6$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $c2968667ab46cac6$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $c2968667ab46cac6$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c2968667ab46cac6$var$preloadPropsMap.get(instance$249)) instance = $c2968667ab46cac6$var$assign({}, props), $c2968667ab46cac6$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c2968667ab46cac6$var$markNodeAsHoistable(styleProps);
            $c2968667ab46cac6$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c2968667ab46cac6$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c2968667ab46cac6$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c2968667ab46cac6$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c2968667ab46cac6$var$tagCaches = null;
function $c2968667ab46cac6$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c2968667ab46cac6$var$tagCaches) {
        var cache = new Map();
        var caches = $c2968667ab46cac6$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c2968667ab46cac6$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c2968667ab46cac6$var$internalHoistableMarker] || node[$c2968667ab46cac6$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c2968667ab46cac6$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c2968667ab46cac6$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $c2968667ab46cac6$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c2968667ab46cac6$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c2968667ab46cac6$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c2968667ab46cac6$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c2968667ab46cac6$var$stylesheetPropsFromRawProps(props);
            (key = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2968667ab46cac6$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c2968667ab46cac6$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $c2968667ab46cac6$var$estimatedBytesWithinLimit = 0;
function $c2968667ab46cac6$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $c2968667ab46cac6$var$estimatedBytesWithinLimit && ($c2968667ab46cac6$var$estimatedBytesWithinLimit = 62500 * $c2968667ab46cac6$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $c2968667ab46cac6$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $c2968667ab46cac6$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $c2968667ab46cac6$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c2968667ab46cac6$var$precedencesByRoot = null;
function $c2968667ab46cac6$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c2968667ab46cac6$var$precedencesByRoot = new Map(), resources.forEach($c2968667ab46cac6$var$insertStylesheetIntoRoot, state), $c2968667ab46cac6$var$precedencesByRoot = null, $c2968667ab46cac6$var$onUnsuspend.call(state));
}
function $c2968667ab46cac6$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c2968667ab46cac6$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c2968667ab46cac6$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c2968667ab46cac6$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c2968667ab46cac6$var$HostTransitionContext = {
    $$typeof: $c2968667ab46cac6$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c2968667ab46cac6$var$sharedNotPendingObject,
    _currentValue2: $c2968667ab46cac6$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c2968667ab46cac6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c2968667ab46cac6$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c2968667ab46cac6$var$createLaneMap(0);
    this.hiddenUpdates = $c2968667ab46cac6$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c2968667ab46cac6$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $c2968667ab46cac6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c2968667ab46cac6$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c2968667ab46cac6$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c2968667ab46cac6$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c2968667ab46cac6$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c2968667ab46cac6$var$emptyContextObject;
    parentComponent = $c2968667ab46cac6$var$emptyContextObject;
    return parentComponent;
}
function $c2968667ab46cac6$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c2968667ab46cac6$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c2968667ab46cac6$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c2968667ab46cac6$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c2968667ab46cac6$var$entangleTransitions(element, rootFiber, lane));
}
function $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane);
}
function $c2968667ab46cac6$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $c2968667ab46cac6$var$requestUpdateLane();
        lane = $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(lane);
        var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, lane);
        $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $c2968667ab46cac6$var$_enabled = !0;
function $c2968667ab46cac6$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T;
    $c2968667ab46cac6$var$ReactSharedInternals.T = null;
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2, $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T;
    $c2968667ab46cac6$var$ReactSharedInternals.T = null;
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 8, $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c2968667ab46cac6$var$_enabled) {
        var blockedOn = $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2968667ab46cac6$var$return_targetInst, targetContainer), $c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c2968667ab46cac6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c2968667ab46cac6$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c2968667ab46cac6$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c2968667ab46cac6$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c2968667ab46cac6$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c2968667ab46cac6$var$ensureRootIsScheduled(fiber);
                                0 === ($c2968667ab46cac6$var$executionContext & 6) && ($c2968667ab46cac6$var$workInProgressRootRenderTargetTime = $c2968667ab46cac6$var$now() + 500, $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 2), $c2968667ab46cac6$var$flushSyncWork$1(), $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2968667ab46cac6$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c2968667ab46cac6$var$getEventTarget(nativeEvent);
    return $c2968667ab46cac6$var$findInstanceBlockingTarget(nativeEvent);
}
var $c2968667ab46cac6$var$return_targetInst = null;
function $c2968667ab46cac6$var$findInstanceBlockingTarget(targetNode) {
    $c2968667ab46cac6$var$return_targetInst = null;
    targetNode = $c2968667ab46cac6$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c2968667ab46cac6$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $c2968667ab46cac6$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c2968667ab46cac6$var$return_targetInst = targetNode;
    return null;
}
function $c2968667ab46cac6$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c2968667ab46cac6$var$getCurrentPriorityLevel()){
                case $c2968667ab46cac6$var$ImmediatePriority:
                    return 2;
                case $c2968667ab46cac6$var$UserBlockingPriority:
                    return 8;
                case $c2968667ab46cac6$var$NormalPriority$1:
                case $c2968667ab46cac6$var$LowPriority:
                    return 32;
                case $c2968667ab46cac6$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c2968667ab46cac6$var$hasScheduledReplayAttempt = !1, $c2968667ab46cac6$var$queuedFocus = null, $c2968667ab46cac6$var$queuedDrag = null, $c2968667ab46cac6$var$queuedMouse = null, $c2968667ab46cac6$var$queuedPointers = new Map(), $c2968667ab46cac6$var$queuedPointerCaptures = new Map(), $c2968667ab46cac6$var$queuedExplicitHydrationTargets = [], $c2968667ab46cac6$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c2968667ab46cac6$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c2968667ab46cac6$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c2968667ab46cac6$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c2968667ab46cac6$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c2968667ab46cac6$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c2968667ab46cac6$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c2968667ab46cac6$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c2968667ab46cac6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c2968667ab46cac6$var$queuedFocus = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c2968667ab46cac6$var$queuedDrag = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c2968667ab46cac6$var$queuedMouse = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c2968667ab46cac6$var$queuedPointers.set(pointerId, $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c2968667ab46cac6$var$queuedPointerCaptures.set(pointerId, $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c2968667ab46cac6$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c2968667ab46cac6$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c2968667ab46cac6$var$runWithPriority(queuedTarget.priority, function() {
                        $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $c2968667ab46cac6$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c2968667ab46cac6$var$runWithPriority(queuedTarget.priority, function() {
                        $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c2968667ab46cac6$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c2968667ab46cac6$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c2968667ab46cac6$var$currentReplayingEvent = null;
        } else return targetContainers = $c2968667ab46cac6$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c2968667ab46cac6$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c2968667ab46cac6$var$replayUnblockedEvents() {
    $c2968667ab46cac6$var$hasScheduledReplayAttempt = !1;
    null !== $c2968667ab46cac6$var$queuedFocus && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedFocus) && ($c2968667ab46cac6$var$queuedFocus = null);
    null !== $c2968667ab46cac6$var$queuedDrag && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedDrag) && ($c2968667ab46cac6$var$queuedDrag = null);
    null !== $c2968667ab46cac6$var$queuedMouse && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedMouse) && ($c2968667ab46cac6$var$queuedMouse = null);
    $c2968667ab46cac6$var$queuedPointers.forEach($c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap);
    $c2968667ab46cac6$var$queuedPointerCaptures.forEach($c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap);
}
function $c2968667ab46cac6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c2968667ab46cac6$var$hasScheduledReplayAttempt || ($c2968667ab46cac6$var$hasScheduledReplayAttempt = !0, $f04nL.unstable_scheduleCallback($f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$replayUnblockedEvents)));
}
var $c2968667ab46cac6$var$lastScheduledReplayQueue = null;
function $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c2968667ab46cac6$var$lastScheduledReplayQueue !== formReplayingQueue && ($c2968667ab46cac6$var$lastScheduledReplayQueue = formReplayingQueue, $f04nL.unstable_scheduleCallback($f04nL.unstable_NormalPriority, function() {
        $c2968667ab46cac6$var$lastScheduledReplayQueue === formReplayingQueue && ($c2968667ab46cac6$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c2968667ab46cac6$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c2968667ab46cac6$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c2968667ab46cac6$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c2968667ab46cac6$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c2968667ab46cac6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c2968667ab46cac6$var$queuedFocus && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedFocus, unblocked);
    null !== $c2968667ab46cac6$var$queuedDrag && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedDrag, unblocked);
    null !== $c2968667ab46cac6$var$queuedMouse && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedMouse, unblocked);
    $c2968667ab46cac6$var$queuedPointers.forEach(unblock);
    $c2968667ab46cac6$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c2968667ab46cac6$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length && (i = $c2968667ab46cac6$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c2968667ab46cac6$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c2968667ab46cac6$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c2968667ab46cac6$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c2968667ab46cac6$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c2968667ab46cac6$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $c2968667ab46cac6$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.render = $c2968667ab46cac6$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c2968667ab46cac6$var$requestUpdateLane();
    $c2968667ab46cac6$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.unmount = $c2968667ab46cac6$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c2968667ab46cac6$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c2968667ab46cac6$var$flushSyncWork$1();
        container[$c2968667ab46cac6$var$internalContainerInstanceKey] = null;
    }
};
function $c2968667ab46cac6$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c2968667ab46cac6$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c2968667ab46cac6$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c2968667ab46cac6$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c2968667ab46cac6$var$attemptExplicitHydrationTarget(target);
    }
};
var $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $8XEkF.version;
if ("19.2.6" !== $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(527, $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$c2968667ab46cac6$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c2968667ab46cac6$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c2968667ab46cac6$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c2968667ab46cac6$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c2968667ab46cac6$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c2968667ab46cac6$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c2968667ab46cac6$var$hook$jscomp$inline_2348.isDisabled && $c2968667ab46cac6$var$hook$jscomp$inline_2348.supportsFiber) try {
        $c2968667ab46cac6$var$rendererID = $c2968667ab46cac6$var$hook$jscomp$inline_2348.inject($c2968667ab46cac6$var$internals$jscomp$inline_2347), $c2968667ab46cac6$var$injectedHook = $c2968667ab46cac6$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$c2968667ab46cac6$export$882461b6382ed46c = function(container, options) {
    if (!$c2968667ab46cac6$var$isValidContainer(container)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2968667ab46cac6$var$defaultOnUncaughtError, onCaughtError = $c2968667ab46cac6$var$defaultOnCaughtError, onRecoverableError = $c2968667ab46cac6$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $c2968667ab46cac6$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator);
    container[$c2968667ab46cac6$var$internalContainerInstanceKey] = options.current;
    $c2968667ab46cac6$var$listenToAllSupportedEvents(container);
    return new $c2968667ab46cac6$var$ReactDOMRoot(options);
};
$c2968667ab46cac6$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c2968667ab46cac6$var$isValidContainer(container)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2968667ab46cac6$var$defaultOnUncaughtError, onCaughtError = $c2968667ab46cac6$var$defaultOnCaughtError, onRecoverableError = $c2968667ab46cac6$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c2968667ab46cac6$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $c2968667ab46cac6$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c2968667ab46cac6$var$requestUpdateLane();
    isStrictMode = $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c2968667ab46cac6$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c2968667ab46cac6$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c2968667ab46cac6$var$markRootUpdated$1(initialChildren, options);
    $c2968667ab46cac6$var$ensureRootIsScheduled(initialChildren);
    container[$c2968667ab46cac6$var$internalContainerInstanceKey] = initialChildren.current;
    $c2968667ab46cac6$var$listenToAllSupportedEvents(container);
    return new $c2968667ab46cac6$var$ReactDOMHydrationRoot(initialChildren);
};
$c2968667ab46cac6$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("f04nL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fUmC"));

});
parcelRegister("5fUmC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $3d3a13239daf5f92$export$c4744153514ff05d; }, function (v) { return $3d3a13239daf5f92$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $3d3a13239daf5f92$export$3e506c1ccc9cc1a7; }, function (v) { return $3d3a13239daf5f92$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $3d3a13239daf5f92$export$e26fe2ed2fa76875; }, function (v) { return $3d3a13239daf5f92$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $3d3a13239daf5f92$export$502329bbf4b505b1; }, function (v) { return $3d3a13239daf5f92$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $3d3a13239daf5f92$export$6e3807111c4874c4; }, function (v) { return $3d3a13239daf5f92$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $3d3a13239daf5f92$export$c27134553091fb3a; }, function (v) { return $3d3a13239daf5f92$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $3d3a13239daf5f92$export$33ee1acdc04fd2a2; }, function (v) { return $3d3a13239daf5f92$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $3d3a13239daf5f92$export$b00a404bbd5edef2; }, function (v) { return $3d3a13239daf5f92$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $3d3a13239daf5f92$export$d66a1c1c77bd778b; }, function (v) { return $3d3a13239daf5f92$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $3d3a13239daf5f92$export$d3dfb8e4810cb555; }, function (v) { return $3d3a13239daf5f92$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $3d3a13239daf5f92$export$72fdf0e06517287b; }, function (v) { return $3d3a13239daf5f92$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $3d3a13239daf5f92$export$816d2913ae6b83b1; }, function (v) { return $3d3a13239daf5f92$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $3d3a13239daf5f92$export$61bcfe829111a1d0; }, function (v) { return $3d3a13239daf5f92$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $3d3a13239daf5f92$export$7ee8c9beb337bc3f; }, function (v) { return $3d3a13239daf5f92$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $3d3a13239daf5f92$export$b5836b71941fa3ed; }, function (v) { return $3d3a13239daf5f92$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $3d3a13239daf5f92$export$cf845f2c119da08a; }, function (v) { return $3d3a13239daf5f92$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3a13239daf5f92$export$c4744153514ff05d;
var $3d3a13239daf5f92$export$3e506c1ccc9cc1a7;
var $3d3a13239daf5f92$export$e26fe2ed2fa76875;
var $3d3a13239daf5f92$export$502329bbf4b505b1;
var $3d3a13239daf5f92$export$6e3807111c4874c4;
var $3d3a13239daf5f92$export$c27134553091fb3a;
var $3d3a13239daf5f92$export$33ee1acdc04fd2a2;
var $3d3a13239daf5f92$export$b00a404bbd5edef2;
var $3d3a13239daf5f92$export$d66a1c1c77bd778b;
var $3d3a13239daf5f92$export$d3dfb8e4810cb555;
var $3d3a13239daf5f92$export$72fdf0e06517287b;
var $3d3a13239daf5f92$export$816d2913ae6b83b1;
var $3d3a13239daf5f92$export$61bcfe829111a1d0;
var $3d3a13239daf5f92$export$7ee8c9beb337bc3f;
var $3d3a13239daf5f92$export$b5836b71941fa3ed;
var $3d3a13239daf5f92$export$cf845f2c119da08a;
"use strict";
function $3d3a13239daf5f92$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $3d3a13239daf5f92$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $3d3a13239daf5f92$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $3d3a13239daf5f92$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $3d3a13239daf5f92$var$compare(left, last)) rightIndex < length && 0 > $3d3a13239daf5f92$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $3d3a13239daf5f92$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $3d3a13239daf5f92$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$3d3a13239daf5f92$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3a13239daf5f92$var$localPerformance = performance;
    $3d3a13239daf5f92$export$c4744153514ff05d = function() {
        return $3d3a13239daf5f92$var$localPerformance.now();
    };
} else {
    var $3d3a13239daf5f92$var$localDate = Date, $3d3a13239daf5f92$var$initialTime = $3d3a13239daf5f92$var$localDate.now();
    $3d3a13239daf5f92$export$c4744153514ff05d = function() {
        return $3d3a13239daf5f92$var$localDate.now() - $3d3a13239daf5f92$var$initialTime;
    };
}
var $3d3a13239daf5f92$var$taskQueue = [], $3d3a13239daf5f92$var$timerQueue = [], $3d3a13239daf5f92$var$taskIdCounter = 1, $3d3a13239daf5f92$var$currentTask = null, $3d3a13239daf5f92$var$currentPriorityLevel = 3, $3d3a13239daf5f92$var$isPerformingWork = !1, $3d3a13239daf5f92$var$isHostCallbackScheduled = !1, $3d3a13239daf5f92$var$isHostTimeoutScheduled = !1, $3d3a13239daf5f92$var$needsPaint = !1, $3d3a13239daf5f92$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $3d3a13239daf5f92$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $3d3a13239daf5f92$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $3d3a13239daf5f92$var$advanceTimers(currentTime) {
    for(var timer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue); null !== timer;){
        if (null === timer.callback) $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$timerQueue);
        else if (timer.startTime <= currentTime) $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$timerQueue), timer.sortIndex = timer.expirationTime, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$taskQueue, timer);
        else break;
        timer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
    }
}
function $3d3a13239daf5f92$var$handleTimeout(currentTime) {
    $3d3a13239daf5f92$var$isHostTimeoutScheduled = !1;
    $3d3a13239daf5f92$var$advanceTimers(currentTime);
    if (!$3d3a13239daf5f92$var$isHostCallbackScheduled) {
        if (null !== $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue)) $3d3a13239daf5f92$var$isHostCallbackScheduled = !0, $3d3a13239daf5f92$var$isMessageLoopRunning || ($3d3a13239daf5f92$var$isMessageLoopRunning = !0, $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
            null !== firstTimer && $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $3d3a13239daf5f92$var$isMessageLoopRunning = !1, $3d3a13239daf5f92$var$taskTimeoutID = -1, $3d3a13239daf5f92$var$frameInterval = 5, $3d3a13239daf5f92$var$startTime = -1;
function $3d3a13239daf5f92$var$shouldYieldToHost() {
    return $3d3a13239daf5f92$var$needsPaint ? !0 : $3d3a13239daf5f92$export$c4744153514ff05d() - $3d3a13239daf5f92$var$startTime < $3d3a13239daf5f92$var$frameInterval ? !1 : !0;
}
function $3d3a13239daf5f92$var$performWorkUntilDeadline() {
    $3d3a13239daf5f92$var$needsPaint = !1;
    if ($3d3a13239daf5f92$var$isMessageLoopRunning) {
        var currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
        $3d3a13239daf5f92$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $3d3a13239daf5f92$var$isHostCallbackScheduled = !1;
                $3d3a13239daf5f92$var$isHostTimeoutScheduled && ($3d3a13239daf5f92$var$isHostTimeoutScheduled = !1, $3d3a13239daf5f92$var$localClearTimeout($3d3a13239daf5f92$var$taskTimeoutID), $3d3a13239daf5f92$var$taskTimeoutID = -1);
                $3d3a13239daf5f92$var$isPerformingWork = !0;
                var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
                try {
                    b: {
                        $3d3a13239daf5f92$var$advanceTimers(currentTime);
                        for($3d3a13239daf5f92$var$currentTask = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue); null !== $3d3a13239daf5f92$var$currentTask && !($3d3a13239daf5f92$var$currentTask.expirationTime > currentTime && $3d3a13239daf5f92$var$shouldYieldToHost());){
                            var callback = $3d3a13239daf5f92$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $3d3a13239daf5f92$var$currentTask.callback = null;
                                $3d3a13239daf5f92$var$currentPriorityLevel = $3d3a13239daf5f92$var$currentTask.priorityLevel;
                                var continuationCallback = callback($3d3a13239daf5f92$var$currentTask.expirationTime <= currentTime);
                                currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $3d3a13239daf5f92$var$currentTask.callback = continuationCallback;
                                    $3d3a13239daf5f92$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $3d3a13239daf5f92$var$currentTask === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue) && $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$taskQueue);
                                $3d3a13239daf5f92$var$advanceTimers(currentTime);
                            } else $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$taskQueue);
                            $3d3a13239daf5f92$var$currentTask = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue);
                        }
                        if (null !== $3d3a13239daf5f92$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
                            null !== firstTimer && $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $3d3a13239daf5f92$var$currentTask = null, $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel, $3d3a13239daf5f92$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline() : $3d3a13239daf5f92$var$isMessageLoopRunning = !1;
        }
    }
}
var $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $3d3a13239daf5f92$var$localSetImmediate) $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
    $3d3a13239daf5f92$var$localSetImmediate($3d3a13239daf5f92$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3a13239daf5f92$var$channel = new MessageChannel(), $3d3a13239daf5f92$var$port = $3d3a13239daf5f92$var$channel.port2;
    $3d3a13239daf5f92$var$channel.port1.onmessage = $3d3a13239daf5f92$var$performWorkUntilDeadline;
    $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
        $3d3a13239daf5f92$var$port.postMessage(null);
    };
} else $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
    $3d3a13239daf5f92$var$localSetTimeout($3d3a13239daf5f92$var$performWorkUntilDeadline, 0);
};
function $3d3a13239daf5f92$var$requestHostTimeout(callback, ms) {
    $3d3a13239daf5f92$var$taskTimeoutID = $3d3a13239daf5f92$var$localSetTimeout(function() {
        callback($3d3a13239daf5f92$export$c4744153514ff05d());
    }, ms);
}
$3d3a13239daf5f92$export$3e506c1ccc9cc1a7 = 5;
$3d3a13239daf5f92$export$e26fe2ed2fa76875 = 1;
$3d3a13239daf5f92$export$502329bbf4b505b1 = 4;
$3d3a13239daf5f92$export$6e3807111c4874c4 = 3;
$3d3a13239daf5f92$export$c27134553091fb3a = null;
$3d3a13239daf5f92$export$33ee1acdc04fd2a2 = 2;
$3d3a13239daf5f92$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$3d3a13239daf5f92$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3a13239daf5f92$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$3d3a13239daf5f92$export$d3dfb8e4810cb555 = function() {
    return $3d3a13239daf5f92$var$currentPriorityLevel;
};
$3d3a13239daf5f92$export$72fdf0e06517287b = function(eventHandler) {
    switch($3d3a13239daf5f92$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    $3d3a13239daf5f92$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$3d3a13239daf5f92$export$816d2913ae6b83b1 = function() {
    $3d3a13239daf5f92$var$needsPaint = !0;
};
$3d3a13239daf5f92$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    $3d3a13239daf5f92$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$3d3a13239daf5f92$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $3d3a13239daf5f92$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$timerQueue, priorityLevel), null === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue) && priorityLevel === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue) && ($3d3a13239daf5f92$var$isHostTimeoutScheduled ? ($3d3a13239daf5f92$var$localClearTimeout($3d3a13239daf5f92$var$taskTimeoutID), $3d3a13239daf5f92$var$taskTimeoutID = -1) : $3d3a13239daf5f92$var$isHostTimeoutScheduled = !0, $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$taskQueue, priorityLevel), $3d3a13239daf5f92$var$isHostCallbackScheduled || $3d3a13239daf5f92$var$isPerformingWork || ($3d3a13239daf5f92$var$isHostCallbackScheduled = !0, $3d3a13239daf5f92$var$isMessageLoopRunning || ($3d3a13239daf5f92$var$isMessageLoopRunning = !0, $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$3d3a13239daf5f92$export$b5836b71941fa3ed = $3d3a13239daf5f92$var$shouldYieldToHost;
$3d3a13239daf5f92$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
        $3d3a13239daf5f92$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8XEkF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("flJa4"));

});
parcelRegister("flJa4", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $b2cbd94ccd281a1e$export$9c16c1426311996d; }, function (v) { return $b2cbd94ccd281a1e$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $b2cbd94ccd281a1e$export$dca3b0875bd9a954; }, function (v) { return $b2cbd94ccd281a1e$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b2cbd94ccd281a1e$export$16fa2f45be04daa8; }, function (v) { return $b2cbd94ccd281a1e$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b2cbd94ccd281a1e$export$ffb0004e005737fa; }, function (v) { return $b2cbd94ccd281a1e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b2cbd94ccd281a1e$export$e2c29f18771995cb; }, function (v) { return $b2cbd94ccd281a1e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b2cbd94ccd281a1e$export$221d75b3f55bb0bd; }, function (v) { return $b2cbd94ccd281a1e$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b2cbd94ccd281a1e$export$5f8d39834fd61797; }, function (v) { return $b2cbd94ccd281a1e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b2cbd94ccd281a1e$export$74bf444e3cd11ea5; }, function (v) { return $b2cbd94ccd281a1e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $b2cbd94ccd281a1e$export$1ced07cd6b1985ce; }, function (v) { return $b2cbd94ccd281a1e$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $b2cbd94ccd281a1e$export$abd8e32b826d7ea7; }, function (v) { return $b2cbd94ccd281a1e$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $b2cbd94ccd281a1e$export$69a3209f1a06c04d; }, function (v) { return $b2cbd94ccd281a1e$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $b2cbd94ccd281a1e$export$8c538325882c7eec; }, function (v) { return $b2cbd94ccd281a1e$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b2cbd94ccd281a1e$export$e530037191fcd5d7; }, function (v) { return $b2cbd94ccd281a1e$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b2cbd94ccd281a1e$export$fd42f52fd3ae1109; }, function (v) { return $b2cbd94ccd281a1e$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b2cbd94ccd281a1e$export$c8a8987d4410bf2d; }, function (v) { return $b2cbd94ccd281a1e$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43; }, function (v) { return $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b2cbd94ccd281a1e$export$257a8862b851cb5b; }, function (v) { return $b2cbd94ccd281a1e$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b2cbd94ccd281a1e$export$a8257692ac88316c; }, function (v) { return $b2cbd94ccd281a1e$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b2cbd94ccd281a1e$export$488013bae63b21da; }, function (v) { return $b2cbd94ccd281a1e$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b2cbd94ccd281a1e$export$7c73462e0d25e514; }, function (v) { return $b2cbd94ccd281a1e$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b2cbd94ccd281a1e$export$7568632d0d33d16d; }, function (v) { return $b2cbd94ccd281a1e$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8; }, function (v) { return $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $b2cbd94ccd281a1e$export$1f96ae73734a86cc; }, function (v) { return $b2cbd94ccd281a1e$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $b2cbd94ccd281a1e$export$9a47ced3238df325; }, function (v) { return $b2cbd94ccd281a1e$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b2cbd94ccd281a1e$export$35808ee640e87ca7; }, function (v) { return $b2cbd94ccd281a1e$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b2cbd94ccd281a1e$export$fae74005e78b1a27; }, function (v) { return $b2cbd94ccd281a1e$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e; }, function (v) { return $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf; }, function (v) { return $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b2cbd94ccd281a1e$export$6d9c69b0de29b591; }, function (v) { return $b2cbd94ccd281a1e$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $b2cbd94ccd281a1e$export$7f54fc3180508a52; }, function (v) { return $b2cbd94ccd281a1e$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $b2cbd94ccd281a1e$export$f680877a34711e37; }, function (v) { return $b2cbd94ccd281a1e$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b2cbd94ccd281a1e$export$d5a552a76deda3c2; }, function (v) { return $b2cbd94ccd281a1e$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b2cbd94ccd281a1e$export$aaabe4eda9ed9969; }, function (v) { return $b2cbd94ccd281a1e$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b2cbd94ccd281a1e$export$e5c5a5f917a5871c; }, function (v) { return $b2cbd94ccd281a1e$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b2cbd94ccd281a1e$export$1538c33de8887b59; }, function (v) { return $b2cbd94ccd281a1e$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $b2cbd94ccd281a1e$export$fca7f784ae7a249a; }, function (v) { return $b2cbd94ccd281a1e$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $b2cbd94ccd281a1e$export$13e3392192263954; }, function (v) { return $b2cbd94ccd281a1e$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b2cbd94ccd281a1e$export$b8f5890fc79d6aca; }, function (v) { return $b2cbd94ccd281a1e$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b2cbd94ccd281a1e$export$60241385465d0a34; }, function (v) { return $b2cbd94ccd281a1e$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b2cbd94ccd281a1e$export$306c0aa65ff9ec16; }, function (v) { return $b2cbd94ccd281a1e$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b2cbd94ccd281a1e$export$7b286972b8d8ccbf; }, function (v) { return $b2cbd94ccd281a1e$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b2cbd94ccd281a1e$export$83d89fbfd8236492; }, function (v) { return $b2cbd94ccd281a1e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2cbd94ccd281a1e$export$9c16c1426311996d;
var $b2cbd94ccd281a1e$export$dca3b0875bd9a954;
var $b2cbd94ccd281a1e$export$16fa2f45be04daa8;
var $b2cbd94ccd281a1e$export$ffb0004e005737fa;
var $b2cbd94ccd281a1e$export$e2c29f18771995cb;
var $b2cbd94ccd281a1e$export$221d75b3f55bb0bd;
var $b2cbd94ccd281a1e$export$5f8d39834fd61797;
var $b2cbd94ccd281a1e$export$74bf444e3cd11ea5;
var $b2cbd94ccd281a1e$export$1ced07cd6b1985ce;
var $b2cbd94ccd281a1e$export$abd8e32b826d7ea7;
var $b2cbd94ccd281a1e$export$69a3209f1a06c04d;
var $b2cbd94ccd281a1e$export$8c538325882c7eec;
var $b2cbd94ccd281a1e$export$e530037191fcd5d7;
var $b2cbd94ccd281a1e$export$fd42f52fd3ae1109;
var $b2cbd94ccd281a1e$export$c8a8987d4410bf2d;
var $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43;
var $b2cbd94ccd281a1e$export$257a8862b851cb5b;
var $b2cbd94ccd281a1e$export$a8257692ac88316c;
var $b2cbd94ccd281a1e$export$488013bae63b21da;
var $b2cbd94ccd281a1e$export$7c73462e0d25e514;
var $b2cbd94ccd281a1e$export$7568632d0d33d16d;
var $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8;
var $b2cbd94ccd281a1e$export$1f96ae73734a86cc;
var $b2cbd94ccd281a1e$export$9a47ced3238df325;
var $b2cbd94ccd281a1e$export$35808ee640e87ca7;
var $b2cbd94ccd281a1e$export$fae74005e78b1a27;
var $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e;
var $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf;
var $b2cbd94ccd281a1e$export$6d9c69b0de29b591;
var $b2cbd94ccd281a1e$export$7f54fc3180508a52;
var $b2cbd94ccd281a1e$export$f680877a34711e37;
var $b2cbd94ccd281a1e$export$d5a552a76deda3c2;
var $b2cbd94ccd281a1e$export$aaabe4eda9ed9969;
var $b2cbd94ccd281a1e$export$e5c5a5f917a5871c;
var $b2cbd94ccd281a1e$export$1538c33de8887b59;
var $b2cbd94ccd281a1e$export$fca7f784ae7a249a;
var $b2cbd94ccd281a1e$export$13e3392192263954;
var $b2cbd94ccd281a1e$export$b8f5890fc79d6aca;
var $b2cbd94ccd281a1e$export$60241385465d0a34;
var $b2cbd94ccd281a1e$export$306c0aa65ff9ec16;
var $b2cbd94ccd281a1e$export$7b286972b8d8ccbf;
var $b2cbd94ccd281a1e$export$83d89fbfd8236492;
"use strict";
var $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b2cbd94ccd281a1e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b2cbd94ccd281a1e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b2cbd94ccd281a1e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b2cbd94ccd281a1e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b2cbd94ccd281a1e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b2cbd94ccd281a1e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b2cbd94ccd281a1e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b2cbd94ccd281a1e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b2cbd94ccd281a1e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $b2cbd94ccd281a1e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b2cbd94ccd281a1e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b2cbd94ccd281a1e$var$assign = Object.assign, $b2cbd94ccd281a1e$var$emptyObject = {};
function $b2cbd94ccd281a1e$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b2cbd94ccd281a1e$var$emptyObject;
    this.updater = updater || $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue;
}
$b2cbd94ccd281a1e$var$Component.prototype.isReactComponent = {};
$b2cbd94ccd281a1e$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$b2cbd94ccd281a1e$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $b2cbd94ccd281a1e$var$ComponentDummy() {}
$b2cbd94ccd281a1e$var$ComponentDummy.prototype = $b2cbd94ccd281a1e$var$Component.prototype;
function $b2cbd94ccd281a1e$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b2cbd94ccd281a1e$var$emptyObject;
    this.updater = updater || $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue;
}
var $b2cbd94ccd281a1e$var$pureComponentPrototype = $b2cbd94ccd281a1e$var$PureComponent.prototype = new $b2cbd94ccd281a1e$var$ComponentDummy();
$b2cbd94ccd281a1e$var$pureComponentPrototype.constructor = $b2cbd94ccd281a1e$var$PureComponent;
$b2cbd94ccd281a1e$var$assign($b2cbd94ccd281a1e$var$pureComponentPrototype, $b2cbd94ccd281a1e$var$Component.prototype);
$b2cbd94ccd281a1e$var$pureComponentPrototype.isPureReactComponent = !0;
var $b2cbd94ccd281a1e$var$isArrayImpl = Array.isArray;
function $b2cbd94ccd281a1e$var$noop() {}
var $b2cbd94ccd281a1e$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $b2cbd94ccd281a1e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b2cbd94ccd281a1e$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $b2cbd94ccd281a1e$var$cloneAndReplaceKey(oldElement, newKey) {
    return $b2cbd94ccd281a1e$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $b2cbd94ccd281a1e$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE;
}
function $b2cbd94ccd281a1e$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex = /\/+/g;
function $b2cbd94ccd281a1e$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $b2cbd94ccd281a1e$var$escape("" + element.key) : index.toString(36);
}
function $b2cbd94ccd281a1e$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($b2cbd94ccd281a1e$var$noop, $b2cbd94ccd281a1e$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $b2cbd94ccd281a1e$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE:
                case $b2cbd94ccd281a1e$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $b2cbd94ccd281a1e$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $b2cbd94ccd281a1e$var$getElementKey(children, 0) : nameSoFar, $b2cbd94ccd281a1e$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $b2cbd94ccd281a1e$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($b2cbd94ccd281a1e$var$isValidElement(callback) && (callback = $b2cbd94ccd281a1e$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($b2cbd94ccd281a1e$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $b2cbd94ccd281a1e$var$getElementKey(nameSoFar, i), invokeCallback += $b2cbd94ccd281a1e$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $b2cbd94ccd281a1e$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $b2cbd94ccd281a1e$var$getElementKey(nameSoFar, i++), invokeCallback += $b2cbd94ccd281a1e$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $b2cbd94ccd281a1e$var$mapIntoArray($b2cbd94ccd281a1e$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $b2cbd94ccd281a1e$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $b2cbd94ccd281a1e$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $b2cbd94ccd281a1e$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $b2cbd94ccd281a1e$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b2cbd94ccd281a1e$var$Children = {
    map: $b2cbd94ccd281a1e$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $b2cbd94ccd281a1e$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $b2cbd94ccd281a1e$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $b2cbd94ccd281a1e$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$b2cbd94ccd281a1e$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$b2cbd94ccd281a1e$export$9c16c1426311996d = $b2cbd94ccd281a1e$var$REACT_ACTIVITY_TYPE;
$b2cbd94ccd281a1e$export$dca3b0875bd9a954 = $b2cbd94ccd281a1e$var$Children;
$b2cbd94ccd281a1e$export$16fa2f45be04daa8 = $b2cbd94ccd281a1e$var$Component;
$b2cbd94ccd281a1e$export$ffb0004e005737fa = $b2cbd94ccd281a1e$var$REACT_FRAGMENT_TYPE;
$b2cbd94ccd281a1e$export$e2c29f18771995cb = $b2cbd94ccd281a1e$var$REACT_PROFILER_TYPE;
$b2cbd94ccd281a1e$export$221d75b3f55bb0bd = $b2cbd94ccd281a1e$var$PureComponent;
$b2cbd94ccd281a1e$export$5f8d39834fd61797 = $b2cbd94ccd281a1e$var$REACT_STRICT_MODE_TYPE;
$b2cbd94ccd281a1e$export$74bf444e3cd11ea5 = $b2cbd94ccd281a1e$var$REACT_SUSPENSE_TYPE;
$b2cbd94ccd281a1e$export$1ced07cd6b1985ce = $b2cbd94ccd281a1e$var$ReactSharedInternals;
$b2cbd94ccd281a1e$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$b2cbd94ccd281a1e$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$b2cbd94ccd281a1e$export$8c538325882c7eec = function() {
    return null;
};
$b2cbd94ccd281a1e$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $b2cbd94ccd281a1e$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$b2cbd94ccd281a1e$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $b2cbd94ccd281a1e$var$ReactElement(element.type, key, props);
};
$b2cbd94ccd281a1e$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$b2cbd94ccd281a1e$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$b2cbd94ccd281a1e$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $b2cbd94ccd281a1e$var$ReactElement(type, key, props);
};
$b2cbd94ccd281a1e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b2cbd94ccd281a1e$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$b2cbd94ccd281a1e$export$a8257692ac88316c = $b2cbd94ccd281a1e$var$isValidElement;
$b2cbd94ccd281a1e$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $b2cbd94ccd281a1e$var$lazyInitializer
    };
};
$b2cbd94ccd281a1e$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$b2cbd94ccd281a1e$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $b2cbd94ccd281a1e$var$ReactSharedInternals.T, currentTransition = {};
    $b2cbd94ccd281a1e$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $b2cbd94ccd281a1e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($b2cbd94ccd281a1e$var$noop, $b2cbd94ccd281a1e$var$reportGlobalError);
    } catch (error) {
        $b2cbd94ccd281a1e$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b2cbd94ccd281a1e$var$ReactSharedInternals.T = prevTransition;
    }
};
$b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8 = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useCacheRefresh();
};
$b2cbd94ccd281a1e$export$1f96ae73734a86cc = function(usable) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.use(usable);
};
$b2cbd94ccd281a1e$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$b2cbd94ccd281a1e$export$35808ee640e87ca7 = function(callback, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$b2cbd94ccd281a1e$export$fae74005e78b1a27 = function(Context) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useContext(Context);
};
$b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e = function() {};
$b2cbd94ccd281a1e$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$b2cbd94ccd281a1e$export$6d9c69b0de29b591 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useEffect(create, deps);
};
$b2cbd94ccd281a1e$export$7f54fc3180508a52 = function(callback) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$b2cbd94ccd281a1e$export$f680877a34711e37 = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useId();
};
$b2cbd94ccd281a1e$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$b2cbd94ccd281a1e$export$aaabe4eda9ed9969 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$b2cbd94ccd281a1e$export$e5c5a5f917a5871c = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$b2cbd94ccd281a1e$export$1538c33de8887b59 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useMemo(create, deps);
};
$b2cbd94ccd281a1e$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$b2cbd94ccd281a1e$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$b2cbd94ccd281a1e$export$b8f5890fc79d6aca = function(initialValue) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useRef(initialValue);
};
$b2cbd94ccd281a1e$export$60241385465d0a34 = function(initialState) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useState(initialState);
};
$b2cbd94ccd281a1e$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$b2cbd94ccd281a1e$export$7b286972b8d8ccbf = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useTransition();
};
$b2cbd94ccd281a1e$export$83d89fbfd8236492 = "19.2.6";

});


parcelRegister("fdu5P", function(module, exports) {
'use strict';
function $b13f69bcf1ce8446$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b13f69bcf1ce8446$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b13f69bcf1ce8446$var$checkDCE();

module.exports = (parcelRequire("gShnY"));

});
parcelRegister("gShnY", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $c48f2ceb33338744$export$69ce8ef3fe5cead0; }, function (v) { return $c48f2ceb33338744$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $c48f2ceb33338744$export$d39a5bbd09211389; }, function (v) { return $c48f2ceb33338744$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c48f2ceb33338744$export$cd75ccfd720a3cd4; }, function (v) { return $c48f2ceb33338744$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $c48f2ceb33338744$export$a0816fa17a9e79be; }, function (v) { return $c48f2ceb33338744$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $c48f2ceb33338744$export$7292efcadded39f3; }, function (v) { return $c48f2ceb33338744$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $c48f2ceb33338744$export$da407abadb9b8f86; }, function (v) { return $c48f2ceb33338744$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $c48f2ceb33338744$export$314cfea32580671c; }, function (v) { return $c48f2ceb33338744$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $c48f2ceb33338744$export$513ccb98c53b8039; }, function (v) { return $c48f2ceb33338744$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $c48f2ceb33338744$export$dbca993bc2d264a; }, function (v) { return $c48f2ceb33338744$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $c48f2ceb33338744$export$4797a8006f0655d0; }, function (v) { return $c48f2ceb33338744$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c48f2ceb33338744$export$c78a37762a8d58e1; }, function (v) { return $c48f2ceb33338744$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $c48f2ceb33338744$export$606f11b2eb45ecc6; }, function (v) { return $c48f2ceb33338744$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $c48f2ceb33338744$export$f7e8a0bf92324b1e; }, function (v) { return $c48f2ceb33338744$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $c48f2ceb33338744$export$83d89fbfd8236492; }, function (v) { return $c48f2ceb33338744$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c48f2ceb33338744$export$69ce8ef3fe5cead0;
var $c48f2ceb33338744$export$d39a5bbd09211389;
var $c48f2ceb33338744$export$cd75ccfd720a3cd4;
var $c48f2ceb33338744$export$a0816fa17a9e79be;
var $c48f2ceb33338744$export$7292efcadded39f3;
var $c48f2ceb33338744$export$da407abadb9b8f86;
var $c48f2ceb33338744$export$314cfea32580671c;
var $c48f2ceb33338744$export$513ccb98c53b8039;
var $c48f2ceb33338744$export$dbca993bc2d264a;
var $c48f2ceb33338744$export$4797a8006f0655d0;
var $c48f2ceb33338744$export$c78a37762a8d58e1;
var $c48f2ceb33338744$export$606f11b2eb45ecc6;
var $c48f2ceb33338744$export$f7e8a0bf92324b1e;
var $c48f2ceb33338744$export$83d89fbfd8236492;
"use strict";

var $8XEkF = parcelRequire("8XEkF");
function $c48f2ceb33338744$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c48f2ceb33338744$var$noop() {}
var $c48f2ceb33338744$var$Internals = {
    d: {
        f: $c48f2ceb33338744$var$noop,
        r: function() {
            throw Error($c48f2ceb33338744$var$formatProdErrorMessage(522));
        },
        D: $c48f2ceb33338744$var$noop,
        C: $c48f2ceb33338744$var$noop,
        L: $c48f2ceb33338744$var$noop,
        m: $c48f2ceb33338744$var$noop,
        X: $c48f2ceb33338744$var$noop,
        S: $c48f2ceb33338744$var$noop,
        M: $c48f2ceb33338744$var$noop
    },
    p: 0,
    findDOMNode: null
}, $c48f2ceb33338744$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $c48f2ceb33338744$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c48f2ceb33338744$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $c48f2ceb33338744$var$ReactSharedInternals = $8XEkF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $c48f2ceb33338744$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$c48f2ceb33338744$export$69ce8ef3fe5cead0 = $c48f2ceb33338744$var$Internals;
$c48f2ceb33338744$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($c48f2ceb33338744$var$formatProdErrorMessage(299));
    return $c48f2ceb33338744$var$createPortal$1(children, container, null, key);
};
$c48f2ceb33338744$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $c48f2ceb33338744$var$ReactSharedInternals.T, previousUpdatePriority = $c48f2ceb33338744$var$Internals.p;
    try {
        if ($c48f2ceb33338744$var$ReactSharedInternals.T = null, $c48f2ceb33338744$var$Internals.p = 2, fn) return fn();
    } finally{
        $c48f2ceb33338744$var$ReactSharedInternals.T = previousTransition, $c48f2ceb33338744$var$Internals.p = previousUpdatePriority, $c48f2ceb33338744$var$Internals.d.f();
    }
};
$c48f2ceb33338744$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $c48f2ceb33338744$var$Internals.d.C(href, options));
};
$c48f2ceb33338744$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $c48f2ceb33338744$var$Internals.d.D(href);
};
$c48f2ceb33338744$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $c48f2ceb33338744$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $c48f2ceb33338744$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$c48f2ceb33338744$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $c48f2ceb33338744$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $c48f2ceb33338744$var$Internals.d.M(href);
    }
};
$c48f2ceb33338744$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(as, options.crossOrigin);
        $c48f2ceb33338744$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$c48f2ceb33338744$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $c48f2ceb33338744$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $c48f2ceb33338744$var$Internals.d.m(href);
    }
};
$c48f2ceb33338744$export$4797a8006f0655d0 = function(form) {
    $c48f2ceb33338744$var$Internals.d.r(form);
};
$c48f2ceb33338744$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$c48f2ceb33338744$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $c48f2ceb33338744$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$c48f2ceb33338744$export$f7e8a0bf92324b1e = function() {
    return $c48f2ceb33338744$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$c48f2ceb33338744$export$83d89fbfd8236492 = "19.2.6";

});




parcelRegister("5FWqM", function(module, exports) {

$parcel$export(module.exports, "RoadmapView", function () { return $c34dc2e4c25042c0$export$e0a377037e4b345e; });
$parcel$export(module.exports, "SixGRoadmap", function () { return $c34dc2e4c25042c0$export$fe700ce4426e1829; });
$parcel$export(module.exports, "Kicker", function () { return $c34dc2e4c25042c0$export$10edde2d298a8102; });
$parcel$export(module.exports, "Heading", function () { return $c34dc2e4c25042c0$export$a8a3e93435678ff9; });
$parcel$export(module.exports, "Lede", function () { return $c34dc2e4c25042c0$export$b8e2ce21bebdf7bd; });
$parcel$export(module.exports, "default", function () { return $c34dc2e4c25042c0$export$2e2bcd8739ae039; });

var $caV3w = parcelRequire("caV3w");

var $8XEkF = parcelRequire("8XEkF");

var $6uXpe = parcelRequire("6uXpe");

var $5jQtK = parcelRequire("5jQtK");
/* ═══════════════════════════════════════════════════════════════════════
   NORTHSTAR — THE NEXT DECADE
   A future-facing 5G SA vision presentation (2026 → 2036).

   HOW TO EDIT THE TEXT
   All on-screen copy lives in  src/js/copy.js  (colours in  src/js/palette.js).
     - Visual editor: open  /copy-editor.html  ("Live NorthStar deck" tab),
       edit text + colours, then export an updated copy.js and commit it.
     - Or edit copy.js directly. Headline-array formatting:
         "plain text"                       -> normal words
         { t: "word", c: P.cyan }           -> a coloured word
         { t: "word", c: P.gold, b: true }  -> bold + colour
         { t: "words", grad: [P.a, P.b] }   -> gradient text
         { br: true }                       -> a line break

   Embeds:  /5g-sa-architecture-diagram.html  and  /unified-5g-viz.html (iframes)
   ═══════════════════════════════════════════════════════════════════════ */ const $c34dc2e4c25042c0$var$FF_HEAD = "'Telia Sans Heading', 'Telia Sans', system-ui, sans-serif";
const $c34dc2e4c25042c0$var$FF_BODY = "'Telia Sans', system-ui, sans-serif";
const $c34dc2e4c25042c0$var$FF_MONO = "'JetBrains Mono', ui-monospace, 'SFMono-Regular', monospace";
// Section ids (structural — order matches COPY.navLabels)
const $c34dc2e4c25042c0$var$SECTIONS = [
    "hero",
    "inflection",
    "waves",
    "innovation",
    "demo",
    "core",
    "slicing",
    "ainative",
    "ambient",
    "positioning",
    "ntn",
    "verticals",
    "economy",
    "vision"
];


// AstaZero demo clips (asset URLs — paired by index with COPY.demo.clips).
const $c34dc2e4c25042c0$var$DEMO_VIDEOS = [
    new URL((parcelRequire("8hO7X"))),
    new URL((parcelRequire("eLjQa")))
];
// ═════════════════════════════════════════════════════════════════════════
// Rich — renders a COPY text array (strings + styled segments) into spans.
// (You don't need to edit this; it just paints the words from COPY.)
// ═════════════════════════════════════════════════════════════════════════
function $c34dc2e4c25042c0$var$Rich({ parts: parts }) {
    return (parts || []).map((p, i)=>{
        if (typeof p === "string") return /*#__PURE__*/ (0, $caV3w.jsx)("span", {
            children: p
        }, i);
        if (p.br) return /*#__PURE__*/ (0, $caV3w.jsx)("br", {}, i);
        if (p.grad) return /*#__PURE__*/ (0, $caV3w.jsx)("span", {
            style: {
                background: `linear-gradient(135deg, ${p.grad.join(", ")})`,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
                ...p.anim ? {
                    backgroundSize: "200% 200%",
                    animation: "shimmer 6s ease-in-out infinite"
                } : {}
            },
            children: p.t
        }, i);
        const st = {};
        if (p.c) st.color = p.c;
        if (p.size) st.fontSize = p.size;
        return p.b ? /*#__PURE__*/ (0, $caV3w.jsx)("strong", {
            style: st,
            children: p.t
        }, i) : /*#__PURE__*/ (0, $caV3w.jsx)("span", {
            style: st,
            children: p.t
        }, i);
    });
}
// ─────────────────────────────────────────────────────────────────────────
// BACKGROUND: layered animated canvas
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$NeuralNebula({ active: active }) {
    const ref = (0, $8XEkF.useRef)(null);
    const raf = (0, $8XEkF.useRef)(0);
    const t = (0, $8XEkF.useRef)(0);
    const nodes = (0, $8XEkF.useRef)([]);
    const last = (0, $8XEkF.useRef)(active);
    (0, $8XEkF.useEffect)(()=>{
        const cvs = ref.current;
        if (!cvs) return;
        const ctx = cvs.getContext("2d");
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const resize = ()=>{
            cvs.width = window.innerWidth * dpr;
            cvs.height = window.innerHeight * dpr;
            cvs.style.width = window.innerWidth + "px";
            cvs.style.height = window.innerHeight + "px";
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            const N = Math.min(Math.floor(window.innerWidth * window.innerHeight / 24000), 90);
            nodes.current = Array.from({
                length: N
            }, ()=>({
                    x: Math.random() * window.innerWidth,
                    y: Math.random() * window.innerHeight,
                    vx: (Math.random() - 0.5) * 0.25,
                    vy: (Math.random() - 0.5) * 0.25,
                    r: 0.8 + Math.random() * 1.6,
                    hue: Math.random()
                }));
        };
        resize();
        window.addEventListener("resize", resize);
        const palettePurple = [
            [
                80,
                10,
                140
            ],
            [
                153,
                10,
                227
            ],
            [
                194,
                63,
                227
            ],
            [
                244,
                224,
                255
            ]
        ];
        const paletteFuture = [
            [
                0,
                130,
                124
            ],
            [
                0,
                212,
                255
            ],
            [
                125,
                211,
                252
            ],
            [
                105,
                240,
                174
            ]
        ];
        const animate = ()=>{
            t.current += 0.0065;
            const time = t.current;
            const w = window.innerWidth;
            const h = window.innerHeight;
            const isFuture = active >= 7; // shift palette toward cyan/teal in future sections
            const palette = isFuture ? paletteFuture : palettePurple;
            if (last.current !== active) last.current = active;
            const g = ctx.createRadialGradient(w * 0.7, h * 0.3, 50, w * 0.5, h * 0.5, Math.max(w, h));
            g.addColorStop(0, isFuture ? "rgba(0, 130, 124, 0.22)" : "rgba(153, 10, 227, 0.22)");
            g.addColorStop(0.4, "rgba(61, 21, 86, 0.85)");
            g.addColorStop(1, "#1A0533");
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, w, h);
            ctx.beginPath();
            const ax = w * 0.7 + Math.sin(time * 0.3) * 40;
            const ay = h * 0.3 + Math.cos(time * 0.2) * 28;
            ctx.arc(ax, ay, Math.min(w, h) * 0.48, -0.8 + Math.sin(time * 0.15) * 0.2, 1.5 + Math.cos(time * 0.1) * 0.3);
            ctx.strokeStyle = isFuture ? "rgba(0,212,255,0.10)" : "rgba(153,10,227,0.13)";
            ctx.lineWidth = 60;
            ctx.stroke();
            const ns = nodes.current;
            for (const n of ns){
                n.x += n.vx + Math.sin(time + n.hue * 12) * 0.05;
                n.y += n.vy + Math.cos(time * 0.8 + n.hue * 9) * 0.05;
                if (n.x < -30) n.x = w + 20;
                if (n.x > w + 30) n.x = -20;
                if (n.y < -30) n.y = h + 20;
                if (n.y > h + 30) n.y = -20;
            }
            const maxD2 = 25600;
            ctx.lineWidth = 0.6;
            for(let i = 0; i < ns.length; i++){
                const a = ns[i];
                for(let j = i + 1; j < ns.length; j++){
                    const b = ns[j];
                    const dx = a.x - b.x, dy = a.y - b.y;
                    const d2 = dx * dx + dy * dy;
                    if (d2 < maxD2) {
                        const k = 1 - d2 / maxD2;
                        const c = palette[Math.floor((a.hue + b.hue) * 0.5 * palette.length) % palette.length];
                        ctx.strokeStyle = `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${k * 0.16})`;
                        ctx.beginPath();
                        ctx.moveTo(a.x, a.y);
                        ctx.lineTo(b.x, b.y);
                        ctx.stroke();
                    }
                }
            }
            for (const n of ns){
                const pulse = 0.6 + 0.4 * Math.sin(time * 2 + n.hue * 6.28);
                const c = palette[Math.floor(n.hue * palette.length) % palette.length];
                ctx.fillStyle = `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${0.55 * pulse})`;
                ctx.beginPath();
                ctx.arc(n.x, n.y, n.r * (1 + pulse * 0.4), 0, Math.PI * 2);
                ctx.fill();
            }
            if (active === 0 || active === 6 || active === 7) {
                const burst = 8;
                for(let k = 0; k < burst; k++){
                    const phase = (time * 0.6 + k / burst) % 1;
                    const i1 = k * 7 % ns.length;
                    const i2 = (k * 13 + 3) % ns.length;
                    const a = ns[i1], b = ns[i2];
                    if (!a || !b) continue;
                    const px = a.x + (b.x - a.x) * phase;
                    const py = a.y + (b.y - a.y) * phase;
                    const c = palette[3];
                    ctx.fillStyle = `rgba(${c[0]}, ${c[1]}, ${c[2]}, 0.85)`;
                    ctx.beginPath();
                    ctx.arc(px, py, 2.2, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
            raf.current = requestAnimationFrame(animate);
        };
        animate();
        return ()=>{
            cancelAnimationFrame(raf.current);
            window.removeEventListener("resize", resize);
        };
    }, [
        active
    ]);
    return /*#__PURE__*/ (0, $caV3w.jsx)("canvas", {
        ref: ref,
        style: {
            position: "fixed",
            inset: 0,
            zIndex: 0,
            pointerEvents: "none"
        }
    });
}
// ─────────────────────────────────────────────────────────────────────────
// COUNTER (large, animated)
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$Counter({ to: to, prefix: prefix = "", suffix: suffix = "", active: active, duration: duration = 1800, decimals: decimals = 0 }) {
    const [v, setV] = (0, $8XEkF.useState)(0);
    (0, $8XEkF.useEffect)(()=>{
        if (!active) {
            setV(0);
            return;
        }
        let raf = 0;
        const start = performance.now();
        const tick = (now)=>{
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setV(eased * to);
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(raf);
    }, [
        to,
        active,
        duration
    ]);
    const display = decimals > 0 ? v.toFixed(decimals) : Math.round(v).toLocaleString();
    return /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
        children: [
            prefix,
            display,
            suffix
        ]
    });
}
// ─────────────────────────────────────────────────────────────────────────
// REVEAL — small utility for fade/translate
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$Reveal({ active: active, delay: delay = 0, children: children, y: y = 16, scale: scale = 1, style: style }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("div", {
        style: {
            opacity: active ? 1 : 0,
            transform: active ? "translateY(0) scale(1)" : `translateY(${y}px) scale(${scale === 1 ? 0.985 : scale})`,
            transition: `opacity 0.6s ease ${delay}s, transform 0.6s cubic-bezier(0.16,1,0.3,1) ${delay}s`,
            ...style
        },
        children: children
    });
}
// ─────────────────────────────────────────────────────────────────────────
// THREE WAVES
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$WaveBands({ active: active }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 18,
            width: "100%"
        },
        children: (0, $5jQtK.COPY).waves.bands.map((b, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                active: active,
                delay: 0.2 + i * 0.14,
                children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        background: `linear-gradient(180deg, ${b.color}0e, ${b.color}03)`,
                        border: `1px solid ${b.color}30`,
                        borderRadius: 18,
                        padding: "22px 20px",
                        minHeight: 360,
                        position: "relative",
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                position: "absolute",
                                top: -40,
                                right: -40,
                                width: 160,
                                height: 160,
                                borderRadius: "50%",
                                background: `radial-gradient(circle, ${b.color}33, transparent 70%)`,
                                filter: "blur(8px)"
                            }
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                marginBottom: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontSize: 28,
                                        lineHeight: 1
                                    },
                                    children: b.icon
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                        fontSize: 10,
                                        letterSpacing: 2,
                                        color: b.color,
                                        textTransform: "uppercase"
                                    },
                                    children: b.tag
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                fontWeight: 300,
                                fontSize: 36,
                                color: (0, $6uXpe.P).white,
                                marginBottom: 12,
                                letterSpacing: -0.5
                            },
                            children: b.title
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontSize: 13,
                                color: (0, $6uXpe.P).dim,
                                lineHeight: 1.6,
                                marginBottom: 16
                            },
                            children: b.summary
                        }),
                        b.bullets.map((tx, j)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: 8,
                                    fontSize: 12,
                                    color: "rgba(244,224,255,0.78)",
                                    lineHeight: 1.55,
                                    marginBottom: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                        style: {
                                            color: b.color,
                                            fontSize: 8,
                                            marginTop: 7,
                                            flexShrink: 0
                                        },
                                        children: "\u25C6"
                                    }),
                                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                        children: tx
                                    })
                                ]
                            }, j))
                    ]
                })
            }, b.title))
    });
}
// ─────────────────────────────────────────────────────────────────────────
// AI-NATIVE — animated SVG closed-loop
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$ClosedLoopSVG({ active: active }) {
    const stages = (0, $5jQtK.COPY).ainative.loop;
    return /*#__PURE__*/ (0, $caV3w.jsxs)("svg", {
        viewBox: "0 0 820 460",
        style: {
            width: "100%",
            height: 380,
            opacity: active ? 1 : 0,
            transition: "opacity 0.8s"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsxs)("radialGradient", {
                        id: "brain",
                        cx: "50%",
                        cy: "50%",
                        r: "50%",
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                offset: "0%",
                                stopColor: (0, $6uXpe.P).purple,
                                stopOpacity: "0.55"
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                offset: "60%",
                                stopColor: (0, $6uXpe.P).magenta,
                                stopOpacity: "0.18"
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                offset: "100%",
                                stopColor: (0, $6uXpe.P).purple,
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("filter", {
                        id: "g1",
                        x: "-50%",
                        y: "-50%",
                        width: "200%",
                        height: "200%",
                        children: /*#__PURE__*/ (0, $caV3w.jsx)("feGaussianBlur", {
                            stdDeviation: "4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                cx: "410",
                cy: "220",
                r: "120",
                fill: "url(#brain)"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                cx: "410",
                cy: "220",
                r: "60",
                fill: "none",
                stroke: (0, $6uXpe.P).light,
                strokeOpacity: "0.18",
                strokeDasharray: "3 5"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                x: "410",
                y: "218",
                textAnchor: "middle",
                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                fontWeight: "300",
                fontSize: "22",
                fill: (0, $6uXpe.P).white,
                children: (0, $5jQtK.COPY).ainative.brainTitle
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                x: "410",
                y: "240",
                textAnchor: "middle",
                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                fontSize: "10",
                letterSpacing: "2",
                fill: (0, $6uXpe.P).light,
                opacity: "0.6",
                children: (0, $5jQtK.COPY).ainative.brainSub
            }),
            stages.map((s, i)=>{
                const next = stages[(i + 1) % stages.length];
                const d = `M ${s.x} ${s.y} Q ${(s.x + next.x) / 2} ${(s.y + next.y) / 2 + (i % 2 ? -40 : 40)} ${next.x} ${next.y}`;
                return /*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                            d: d,
                            fill: "none",
                            stroke: s.color,
                            strokeOpacity: "0.45",
                            strokeWidth: "1.5",
                            strokeDasharray: "4 6",
                            children: /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                                attributeName: "stroke-dashoffset",
                                from: "0",
                                to: "-200",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsxs)("circle", {
                            r: "4",
                            fill: s.color,
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("animateMotion", {
                                    dur: `${3 + i * 0.2}s`,
                                    repeatCount: "indefinite",
                                    path: d
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                                    attributeName: "opacity",
                                    values: "0.2;1;0.2",
                                    dur: "3s",
                                    repeatCount: "indefinite"
                                })
                            ]
                        })
                    ]
                }, i);
            }),
            stages.map((s)=>/*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                    transform: `translate(${s.x},${s.y})`,
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                            r: "34",
                            fill: `${s.color}22`,
                            stroke: s.color,
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                            r: "34",
                            fill: `${s.color}10`,
                            filter: "url(#g1)"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                            textAnchor: "middle",
                            y: "-2",
                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                            fontSize: "11",
                            fontWeight: "700",
                            letterSpacing: "1.5",
                            fill: s.color,
                            children: s.label
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                            textAnchor: "middle",
                            y: "14",
                            fontFamily: $c34dc2e4c25042c0$var$FF_BODY,
                            fontSize: "9",
                            fill: (0, $6uXpe.P).dim,
                            children: s.sub
                        })
                    ]
                }, s.label))
        ]
    });
}
// ─────────────────────────────────────────────────────────────────────────
// ISAC RADAR
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$ISACVisual({ active: active }) {
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            position: "relative",
            aspectRatio: "1.6 / 1",
            width: "100%",
            maxWidth: 540,
            margin: "0 auto",
            borderRadius: 16,
            background: `radial-gradient(circle at 30% 50%, ${(0, $6uXpe.P).purple}22, transparent 70%)`,
            border: `1px solid ${(0, $6uXpe.P).purple}33`,
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("style", {
                children: `
        @keyframes radarRing { 0% { transform: scale(0.05); opacity: 0.7; } 100% { transform: scale(1); opacity: 0; } }
        @keyframes targetBlink { 0%, 100% { opacity: 0.25; transform: scale(0.9); } 50% { opacity: 1; transform: scale(1.2); } }
      `
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    position: "absolute",
                    left: 28,
                    top: "50%",
                    transform: "translateY(-50%)",
                    textAlign: "center",
                    zIndex: 3
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: {
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            background: `radial-gradient(circle, ${(0, $6uXpe.P).cyan}, ${(0, $6uXpe.P).purple}aa)`,
                            boxShadow: `0 0 30px ${(0, $6uXpe.P).cyan}88`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 22
                        },
                        children: "\uD83D\uDCE1"
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: {
                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                            fontSize: 9,
                            color: (0, $6uXpe.P).light,
                            marginTop: 6,
                            letterSpacing: 1
                        },
                        children: (0, $5jQtK.COPY).ambient.gnbLabel
                    })
                ]
            }),
            active && [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        position: "absolute",
                        left: 50,
                        top: "50%",
                        width: "120%",
                        aspectRatio: "1/1",
                        borderRadius: "50%",
                        border: `1px solid ${(0, $6uXpe.P).cyan}55`,
                        transform: "translateY(-50%)",
                        transformOrigin: "center",
                        animation: `radarRing 3.6s ease-out ${i * 1.2}s infinite`
                    }
                }, i)),
            (0, $5jQtK.COPY).ambient.targets.map((tg, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        position: "absolute",
                        left: `${tg.x}%`,
                        top: `${tg.y}%`,
                        opacity: active ? 1 : 0,
                        transition: `opacity 0.6s ease ${0.4 + i * 0.12}s`
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                width: 14,
                                height: 14,
                                borderRadius: "50%",
                                background: tg.color,
                                boxShadow: `0 0 18px ${tg.color}cc`,
                                animation: "targetBlink 2.4s ease-in-out infinite",
                                animationDelay: `${i * 0.4}s`
                            }
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                fontSize: 9,
                                color: tg.color,
                                marginTop: 4,
                                letterSpacing: 1,
                                whiteSpace: "nowrap"
                            },
                            children: tg.label
                        })
                    ]
                }, i))
        ]
    });
}
// ─────────────────────────────────────────────────────────────────────────
// NTN ORBITAL
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$OrbitalView({ active: active }) {
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            position: "relative",
            width: "100%",
            maxWidth: 460,
            aspectRatio: "1/1",
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("style", {
                children: `
        @keyframes orbit1 { from { transform: rotate(0); } to { transform: rotate(360deg); } }
        @keyframes orbit2 { from { transform: rotate(360deg); } to { transform: rotate(0); } }
      `
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: "30%",
                    borderRadius: "50%",
                    background: `radial-gradient(circle at 35% 35%, ${(0, $6uXpe.P).teal}, ${(0, $6uXpe.P).dark} 70%)`,
                    boxShadow: `0 0 60px ${(0, $6uXpe.P).teal}66, inset -20px -20px 60px ${(0, $6uXpe.P).deep}`,
                    opacity: active ? 1 : 0,
                    transition: "opacity 0.8s"
                }
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: "22%",
                    borderRadius: "50%",
                    background: `radial-gradient(circle, transparent 60%, ${(0, $6uXpe.P).cyan}22)`,
                    filter: "blur(8px)"
                }
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: 8,
                    borderRadius: "50%",
                    border: `1px dashed ${(0, $6uXpe.P).light}33`,
                    animation: active ? "orbit1 24s linear infinite" : "none"
                },
                children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: "-8px",
                        left: "50%",
                        width: 16,
                        height: 16,
                        transform: "translateX(-50%)",
                        fontSize: 16
                    },
                    children: "\uD83D\uDEF0\uFE0F"
                })
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: 32,
                    borderRadius: "50%",
                    border: `1px dashed ${(0, $6uXpe.P).cyan}44`,
                    animation: active ? "orbit2 18s linear infinite" : "none"
                },
                children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        position: "absolute",
                        bottom: "-6px",
                        left: "30%",
                        width: 14,
                        height: 14,
                        fontSize: 14
                    },
                    children: "\uD83D\uDEF0\uFE0F"
                })
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: 56,
                    borderRadius: "50%",
                    border: `1px dashed ${(0, $6uXpe.P).magenta}44`,
                    animation: active ? "orbit1 14s linear infinite" : "none"
                },
                children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: "30%",
                        right: "-6px",
                        width: 14,
                        height: 14,
                        fontSize: 14
                    },
                    children: "\uD83D\uDCE1"
                })
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("svg", {
                viewBox: "0 0 200 200",
                style: {
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                        x1: "100",
                        y1: "10",
                        x2: "100",
                        y2: "80",
                        stroke: (0, $6uXpe.P).cyan,
                        strokeOpacity: active ? 0.4 : 0,
                        strokeWidth: "1",
                        strokeDasharray: "2 3",
                        children: /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                            attributeName: "stroke-dashoffset",
                            from: "0",
                            to: "20",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                        x1: "40",
                        y1: "160",
                        x2: "80",
                        y2: "110",
                        stroke: (0, $6uXpe.P).magenta,
                        strokeOpacity: active ? 0.4 : 0,
                        strokeWidth: "1",
                        strokeDasharray: "2 3",
                        children: /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                            attributeName: "stroke-dashoffset",
                            from: "0",
                            to: "20",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                        x1: "190",
                        y1: "80",
                        x2: "120",
                        y2: "100",
                        stroke: (0, $6uXpe.P).gold,
                        strokeOpacity: active ? 0.4 : 0,
                        strokeWidth: "1",
                        strokeDasharray: "2 3",
                        children: /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                            attributeName: "stroke-dashoffset",
                            from: "0",
                            to: "20",
                            dur: "0.9s",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        ]
    });
}
// ─────────────────────────────────────────────────────────────────────────
// VERTICAL CARD
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$VerticalCard({ icon: icon, title: title, year: year, body: body, tech: tech, color: color, active: active, delay: delay }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
        active: active,
        delay: delay,
        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
            style: {
                background: `linear-gradient(180deg, ${color}10, ${color}02)`,
                border: `1px solid ${color}30`,
                borderRadius: 16,
                padding: "20px 18px",
                position: "relative",
                overflow: "hidden",
                height: "100%",
                boxSizing: "border-box"
            },
            children: [
                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        position: "absolute",
                        inset: 0,
                        opacity: 0.06,
                        background: `radial-gradient(circle at 90% 10%, ${color}, transparent 60%)`
                    }
                }),
                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                            style: {
                                fontSize: 26
                            },
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                        fontSize: 10,
                                        letterSpacing: 2,
                                        color: color
                                    },
                                    children: [
                                        "BY ",
                                        year
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                        fontWeight: 300,
                                        fontSize: 18,
                                        color: (0, $6uXpe.P).white,
                                        lineHeight: 1.1
                                    },
                                    children: title
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        fontSize: 12,
                        color: (0, $6uXpe.P).dim,
                        lineHeight: 1.55,
                        marginBottom: 10
                    },
                    children: body
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                    style: {
                        fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                        fontSize: 10,
                        color: color,
                        opacity: 0.9,
                        letterSpacing: 1
                    },
                    children: tech
                })
            ]
        })
    });
}
// ─────────────────────────────────────────────────────────────────────────
// ECONOMY — animated area chart
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$EconomyChart({ active: active }) {
    const { years: years, connectivity: connectivity, slices: slices, apis: apis, sensing: sensing, axisMax: max } = (0, $5jQtK.COPY).economy.chart;
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            maxWidth: 800,
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 14,
                    marginBottom: 10,
                    fontSize: 11,
                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO
                },
                children: (0, $5jQtK.COPY).economy.legend.map((lg, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Legend, {
                        color: lg.color,
                        label: lg.label
                    }, i))
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("svg", {
                viewBox: "0 0 800 320",
                style: {
                    width: "100%",
                    height: 300
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsxs)("linearGradient", {
                                id: "grad-cy",
                                x1: "0",
                                x2: "0",
                                y1: "0",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: (0, $6uXpe.P).cyan,
                                        stopOpacity: "0.85"
                                    }),
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: (0, $6uXpe.P).cyan,
                                        stopOpacity: "0.15"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsxs)("linearGradient", {
                                id: "grad-ma",
                                x1: "0",
                                x2: "0",
                                y1: "0",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: (0, $6uXpe.P).magenta,
                                        stopOpacity: "0.85"
                                    }),
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: (0, $6uXpe.P).magenta,
                                        stopOpacity: "0.15"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsxs)("linearGradient", {
                                id: "grad-go",
                                x1: "0",
                                x2: "0",
                                y1: "0",
                                y2: "1",
                                children: [
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: (0, $6uXpe.P).gold,
                                        stopOpacity: "0.85"
                                    }),
                                    /*#__PURE__*/ (0, $caV3w.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: (0, $6uXpe.P).gold,
                                        stopOpacity: "0.15"
                                    })
                                ]
                            })
                        ]
                    }),
                    [
                        0,
                        50,
                        100,
                        150,
                        200
                    ].map((v)=>/*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                                    x1: "50",
                                    x2: "780",
                                    y1: 280 - v / max * 240,
                                    y2: 280 - v / max * 240,
                                    stroke: (0, $6uXpe.P).faint,
                                    strokeDasharray: "2 4"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("text", {
                                    x: "40",
                                    y: 284 - v / max * 240,
                                    textAnchor: "end",
                                    fontSize: "9",
                                    fill: (0, $6uXpe.P).muted,
                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                    children: [
                                        "$",
                                        v,
                                        "B"
                                    ]
                                })
                            ]
                        }, v)),
                    /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                        d: $c34dc2e4c25042c0$var$makePath(years, connectivity, max, active),
                        fill: "none",
                        stroke: (0, $6uXpe.P).faint,
                        strokeWidth: "2",
                        strokeDasharray: "6 4"
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                        d: $c34dc2e4c25042c0$var$makeArea(years, slices, max, active),
                        fill: "url(#grad-cy)",
                        opacity: active ? 0.7 : 0,
                        style: {
                            transition: "opacity 1s"
                        }
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                        d: $c34dc2e4c25042c0$var$makeArea(years, apis, max, active),
                        fill: "url(#grad-ma)",
                        opacity: active ? 0.7 : 0,
                        style: {
                            transition: "opacity 1.2s"
                        }
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                        d: $c34dc2e4c25042c0$var$makeArea(years, sensing, max, active),
                        fill: "url(#grad-go)",
                        opacity: active ? 0.6 : 0,
                        style: {
                            transition: "opacity 1.4s"
                        }
                    }),
                    years.map((y, i)=>/*#__PURE__*/ (0, $caV3w.jsx)("text", {
                            x: 50 + i * 146,
                            y: "305",
                            textAnchor: "middle",
                            fontSize: "11",
                            fill: (0, $6uXpe.P).dim,
                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                            children: y
                        }, y))
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    fontSize: 11,
                    color: (0, $6uXpe.P).muted,
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: 6
                },
                children: (0, $5jQtK.COPY).economy.caption
            })
        ]
    });
}
function $c34dc2e4c25042c0$var$Legend({ color: color, label: label }) {
    return /*#__PURE__*/ (0, $caV3w.jsxs)("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            color: (0, $6uXpe.P).dim
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                style: {
                    width: 10,
                    height: 10,
                    borderRadius: 2,
                    background: color
                }
            }),
            label
        ]
    });
}
function $c34dc2e4c25042c0$var$makePath(years, vals, max, active) {
    const w = 730 / (years.length - 1);
    return vals.map((v, i)=>{
        const x = 50 + i * w;
        const y = 280 - (active ? v / max * 240 : 0);
        return `${i === 0 ? "M" : "L"} ${x} ${y}`;
    }).join(" ");
}
function $c34dc2e4c25042c0$var$makeArea(years, vals, max, active) {
    const w = 730 / (years.length - 1);
    const top = vals.map((v, i)=>{
        const x = 50 + i * w;
        const y = 280 - (active ? v / max * 240 : 0);
        return `${i === 0 ? "M" : "L"} ${x} ${y}`;
    }).join(" ");
    return `${top} L 780 280 L 50 280 Z`;
}
function $c34dc2e4c25042c0$export$e0a377037e4b345e({ active: active }) {
    const data = (0, $5jQtK.COPY).roadmap.data;
    const cats = (0, $5jQtK.COPY).roadmap.cats;
    const YEAR_COLOR = (0, $5jQtK.COPY).roadmap.yearColors;
    const years = Object.keys(data);
    const [open, setOpen] = (0, $8XEkF.useState)(null);
    (0, $8XEkF.useEffect)(()=>{
        if (active && open === null) {
            const t = setTimeout(()=>setOpen(0), 600);
            return ()=>clearTimeout(t);
        }
    }, [
        active,
        open
    ]);
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            maxWidth: 980,
            margin: "0 auto"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    display: "flex",
                    gap: 6,
                    marginBottom: 20
                },
                children: years.map((y, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                        onClick: ()=>setOpen(open === i ? null : i),
                        style: {
                            flex: 1,
                            cursor: "pointer",
                            opacity: active ? 1 : 0,
                            transform: active ? "translateY(0)" : `translateY(${28 + i * 8}px)`,
                            transition: `all 0.55s cubic-bezier(0.16,1,0.3,1) ${i * 0.08}s`
                        },
                        children: [
                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                style: {
                                    height: 7,
                                    borderRadius: 4,
                                    background: YEAR_COLOR[y],
                                    marginBottom: 12,
                                    boxShadow: open === i ? `0 0 20px ${YEAR_COLOR[y]}aa` : `0 0 10px ${YEAR_COLOR[y]}55`,
                                    transition: "box-shadow 0.3s"
                                }
                            }),
                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                style: {
                                    fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                    fontWeight: 300,
                                    fontSize: 22,
                                    color: open === i ? YEAR_COLOR[y] : (0, $6uXpe.P).white,
                                    textAlign: "center"
                                },
                                children: y
                            })
                        ]
                    }, y))
            }),
            open !== null && (()=>{
                const y = years[open];
                const color = YEAR_COLOR[y];
                const d = data[y];
                return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        background: `${color}10`,
                        border: `1px solid ${color}40`,
                        borderRadius: 18,
                        padding: "22px 26px",
                        animation: "fadeSlideUp 0.4s ease"
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                fontSize: 11,
                                color: color,
                                letterSpacing: 2,
                                marginBottom: 16,
                                textTransform: "uppercase"
                            },
                            children: [
                                y,
                                " \xb7 ",
                                (0, $5jQtK.COPY).ui.roadmapMilestones
                            ]
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "14px 24px"
                            },
                            children: cats.map((c)=>{
                                const items = d[c.id] || [];
                                if (!items.length) return null;
                                return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                            style: {
                                                fontSize: 11,
                                                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                color: `${color}dd`,
                                                letterSpacing: 1,
                                                textTransform: "uppercase",
                                                marginBottom: 6,
                                                borderBottom: `1px solid ${color}33`,
                                                paddingBottom: 4,
                                                display: "flex",
                                                gap: 6,
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                    style: {
                                                        fontSize: 13
                                                    },
                                                    children: c.icon
                                                }),
                                                c.label
                                            ]
                                        }),
                                        items.map((it, j)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                style: {
                                                    fontSize: 12,
                                                    color: "rgba(244,224,255,0.78)",
                                                    lineHeight: 1.55,
                                                    marginBottom: 3,
                                                    display: "flex",
                                                    gap: 6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                        style: {
                                                            color: color,
                                                            fontSize: 8,
                                                            marginTop: 6,
                                                            flexShrink: 0
                                                        },
                                                        children: "\u25C6"
                                                    }),
                                                    it
                                                ]
                                            }, j))
                                    ]
                                }, c.id);
                            })
                        })
                    ]
                });
            })(),
            open === null && /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    textAlign: "center",
                    color: (0, $6uXpe.P).muted,
                    fontSize: 12,
                    fontStyle: "italic",
                    marginTop: 16
                },
                children: (0, $5jQtK.COPY).ui.roadmapTapHint
            })
        ]
    });
}
function $c34dc2e4c25042c0$export$fe700ce4426e1829({ active: active }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 12,
            width: "100%",
            maxWidth: 980,
            margin: "0 auto"
        },
        children: (0, $5jQtK.COPY).sixg.items.map((it, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                active: active,
                delay: 0.15 + i * 0.1,
                children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                    style: {
                        background: `linear-gradient(180deg, ${it.color}0e, transparent)`,
                        border: `1px solid ${it.color}30`,
                        borderRadius: 14,
                        padding: "16px 14px",
                        minHeight: 220
                    },
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                height: 5,
                                background: it.color,
                                borderRadius: 3,
                                marginBottom: 10,
                                boxShadow: `0 0 10px ${it.color}aa`
                            }
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                fontSize: 11,
                                fontWeight: 700,
                                color: it.color,
                                letterSpacing: 1
                            },
                            children: it.rel
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontSize: 10,
                                color: (0, $6uXpe.P).muted,
                                marginTop: 2
                            },
                            children: it.period
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                            style: {
                                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                fontWeight: 300,
                                fontSize: 16,
                                color: (0, $6uXpe.P).white,
                                marginTop: 6,
                                marginBottom: 10,
                                lineHeight: 1.15
                            },
                            children: it.label
                        }),
                        it.bullets.map((b, j)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $6uXpe.P).dim,
                                    lineHeight: 1.5,
                                    display: "flex",
                                    gap: 6,
                                    marginBottom: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                        style: {
                                            color: it.color,
                                            fontSize: 7,
                                            marginTop: 6
                                        },
                                        children: "\u25C6"
                                    }),
                                    b
                                ]
                            }, j))
                    ]
                })
            }, it.rel))
    });
}
function $c34dc2e4c25042c0$export$10edde2d298a8102({ children: children, color: color, align: align = "center", mb: mb = 14 }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("div", {
        style: {
            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
            fontSize: 12,
            color: color,
            letterSpacing: 4,
            marginBottom: mb,
            textTransform: "uppercase",
            textAlign: align
        },
        children: children
    });
}
function $c34dc2e4c25042c0$export$a8a3e93435678ff9({ parts: parts, size: size = "clamp(26px, 5vw, 52px)", mb: mb = 12, lineHeight: lineHeight = 1.1 }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("h2", {
        style: {
            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
            fontWeight: 300,
            fontSize: size,
            textAlign: "center",
            margin: `0 0 ${mb}px`,
            letterSpacing: -1,
            lineHeight: lineHeight
        },
        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
            parts: parts
        })
    });
}
function $c34dc2e4c25042c0$export$b8e2ce21bebdf7bd({ children: children, size: size = 15, mb: mb = 28, max: max = 780 }) {
    return /*#__PURE__*/ (0, $caV3w.jsx)("div", {
        style: {
            textAlign: "center",
            color: (0, $6uXpe.P).dim,
            fontSize: size,
            marginBottom: mb,
            maxWidth: max,
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: 1.6
        },
        children: children
    });
}
// ─────────────────────────────────────────────────────────────────────────
// NORTHSTAR TOPOLOGY CIRCLE — core / edge / RAN with nomadic towers
// ─────────────────────────────────────────────────────────────────────────
function $c34dc2e4c25042c0$var$NorthStarCircle({ active: active }) {
    const R_OUT = 268, R_MID = 175, R_IN = 88;
    const TOWERS = 10, NOMADIC = 3, EDGE = 12;
    const renderTower = (key, x, y, deg, color, isNomadic)=>/*#__PURE__*/ (0, $caV3w.jsxs)("g", {
            transform: `translate(${x},${y}) rotate(${deg})`,
            children: [
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-5",
                    y1: "3",
                    x2: "-1.5",
                    y2: "-14",
                    stroke: color,
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "5",
                    y1: "3",
                    x2: "1.5",
                    y2: "-14",
                    stroke: color,
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-6",
                    y1: "3",
                    x2: "6",
                    y2: "3",
                    stroke: color,
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-4.5",
                    y1: "-3",
                    x2: "4.5",
                    y2: "-3",
                    stroke: color,
                    strokeWidth: "0.8"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-3.2",
                    y1: "-9",
                    x2: "3.2",
                    y2: "-9",
                    stroke: color,
                    strokeWidth: "0.8"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-5",
                    y1: "3",
                    x2: "0",
                    y2: "-3",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "5",
                    y1: "3",
                    x2: "0",
                    y2: "-3",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-4",
                    y1: "-3",
                    x2: "0",
                    y2: "-9",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "4",
                    y1: "-3",
                    x2: "0",
                    y2: "-9",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-2.5",
                    y1: "-9",
                    x2: "0",
                    y2: "-14",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "2.5",
                    y1: "-9",
                    x2: "0",
                    y2: "-14",
                    stroke: color,
                    strokeOpacity: "0.55",
                    strokeWidth: "0.6"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                    x1: "-2.6",
                    y1: "-14",
                    x2: "2.6",
                    y2: "-14",
                    stroke: color,
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("rect", {
                    x: "-3.6",
                    y: "-18.5",
                    width: "1.7",
                    height: "4.6",
                    rx: "0.4",
                    fill: color
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("rect", {
                    x: "-0.85",
                    y: "-19.6",
                    width: "1.7",
                    height: "5.7",
                    rx: "0.4",
                    fill: color
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("rect", {
                    x: "1.9",
                    y: "-18.5",
                    width: "1.7",
                    height: "4.6",
                    rx: "0.4",
                    fill: color
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                    d: "M -8 -19 Q 0 -27 8 -19",
                    fill: "none",
                    stroke: color,
                    strokeOpacity: "0.6",
                    strokeWidth: "0.9"
                }),
                /*#__PURE__*/ (0, $caV3w.jsx)("path", {
                    d: "M -11 -20 Q 0 -32 11 -20",
                    fill: "none",
                    stroke: color,
                    strokeOpacity: "0.3",
                    strokeWidth: "0.7"
                }),
                isNomadic && /*#__PURE__*/ (0, $caV3w.jsxs)("circle", {
                    cx: "0",
                    cy: "-22",
                    r: "3",
                    fill: "none",
                    stroke: color,
                    strokeWidth: "0.8",
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                            attributeName: "r",
                            from: "3",
                            to: "14",
                            dur: "2.4s",
                            repeatCount: "indefinite"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("animate", {
                            attributeName: "opacity",
                            from: "0.85",
                            to: "0",
                            dur: "2.4s",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        }, key);
    const staticT = Array.from({
        length: TOWERS
    }, (_, i)=>{
        const a = i / TOWERS * 2 * Math.PI - Math.PI / 2 + Math.PI / TOWERS;
        return {
            x: Math.cos(a) * R_OUT,
            y: Math.sin(a) * R_OUT,
            deg: a * 180 / Math.PI + 90
        };
    });
    const nomadicT = Array.from({
        length: NOMADIC
    }, (_, i)=>{
        const a = -Math.PI / 2 + 0.55 + (i - 1) * 0.22;
        return {
            x: Math.cos(a) * R_OUT,
            y: Math.sin(a) * R_OUT,
            deg: a * 180 / Math.PI + 90
        };
    });
    const edges = Array.from({
        length: EDGE
    }, (_, i)=>{
        const a = i / EDGE * 2 * Math.PI - Math.PI / 2;
        return {
            x: Math.cos(a) * R_MID,
            y: Math.sin(a) * R_MID,
            isReg: i % 4 === 0
        };
    });
    return /*#__PURE__*/ (0, $caV3w.jsxs)("svg", {
        viewBox: "-300 -300 600 600",
        style: {
            width: "100%",
            height: "100%",
            display: "block",
            overflow: "visible"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                r: R_OUT,
                fill: "none",
                stroke: `${(0, $6uXpe.P).cyan}1f`,
                strokeWidth: "16"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                r: R_OUT,
                fill: "none",
                stroke: `${(0, $6uXpe.P).cyan}55`,
                strokeWidth: "1.4",
                strokeDasharray: "3 6"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                r: R_MID,
                fill: "none",
                stroke: `${(0, $6uXpe.P).magenta}55`,
                strokeWidth: "1.4",
                strokeDasharray: "3 6"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                r: R_IN,
                fill: `${(0, $6uXpe.P).deep}cc`,
                stroke: `${(0, $6uXpe.P).cyan}aa`,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                x: "0",
                y: -(R_OUT + 18),
                textAnchor: "middle",
                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                fontSize: "11",
                fill: (0, $6uXpe.P).cyan,
                letterSpacing: "2",
                children: "5G RAN \xb7 including nomadic coverage"
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                x: "0",
                y: -(R_MID + 14),
                textAnchor: "middle",
                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                fontSize: "11",
                fill: (0, $6uXpe.P).light,
                letterSpacing: "2",
                children: "5G edge nodes with AI"
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                textAnchor: "middle",
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                        x: "0",
                        y: "-52",
                        fontSize: "10",
                        fill: (0, $6uXpe.P).cyan,
                        letterSpacing: "2",
                        children: "5G SA CORE"
                    }),
                    [
                        {
                            x: -32,
                            y: -15,
                            label: "Public",
                            color: (0, $6uXpe.P).dim
                        },
                        {
                            x: 32,
                            y: -15,
                            label: "Innovation",
                            color: (0, $6uXpe.P).cyan
                        },
                        {
                            x: 0,
                            y: 33,
                            label: "Special purpose",
                            color: (0, $6uXpe.P).gold
                        }
                    ].map((c, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                            transform: `translate(${c.x},${c.y})`,
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)("polygon", {
                                    points: "-15,0 -7.5,-13 7.5,-13 15,0 7.5,13 -7.5,13",
                                    fill: "none",
                                    stroke: `${c.color}40`,
                                    strokeWidth: "2.5"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("polygon", {
                                    points: "-13,0 -6.5,-11.3 6.5,-11.3 13,0 6.5,11.3 -6.5,11.3",
                                    fill: `${c.color}33`,
                                    stroke: c.color,
                                    strokeWidth: "1.4"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("polygon", {
                                    points: "-9,-1 -4.5,-8 4.5,-8 9,-1",
                                    fill: `${c.color}38`,
                                    stroke: "none"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                                    cx: "-13",
                                    cy: "0",
                                    r: "1.3",
                                    fill: c.color
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                                    cx: "13",
                                    cy: "0",
                                    r: "1.3",
                                    fill: c.color
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                                    y: "3",
                                    fontSize: "8",
                                    fill: c.color,
                                    fontWeight: "700",
                                    children: "5G"
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                                    y: "24",
                                    fontSize: "8",
                                    fill: c.color,
                                    children: c.label
                                })
                            ]
                        }, i))
                ]
            }),
            edges.map((n, i)=>{
                const c = n.isReg ? (0, $6uXpe.P).gold : (0, $6uXpe.P).cyan;
                return /*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                    transform: `translate(${n.x},${n.y})`,
                    children: [
                        /*#__PURE__*/ (0, $caV3w.jsx)("rect", {
                            x: "-11",
                            y: "-10",
                            width: "22",
                            height: "20",
                            rx: "3",
                            fill: `${c}1f`,
                            stroke: "none"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("rect", {
                            x: "-9",
                            y: "-9",
                            width: "18",
                            height: "18",
                            rx: "2.5",
                            fill: `${c}40`,
                            stroke: c,
                            strokeWidth: "1.2"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                            x1: "-6",
                            y1: "-5",
                            x2: "6",
                            y2: "-5",
                            stroke: c,
                            strokeOpacity: "0.75",
                            strokeWidth: "0.7"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                            x1: "-6",
                            y1: "-1.5",
                            x2: "6",
                            y2: "-1.5",
                            stroke: c,
                            strokeOpacity: "0.75",
                            strokeWidth: "0.7"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                            x1: "-6",
                            y1: "2",
                            x2: "6",
                            y2: "2",
                            stroke: c,
                            strokeOpacity: "0.75",
                            strokeWidth: "0.7"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("line", {
                            x1: "-6",
                            y1: "5.5",
                            x2: "6",
                            y2: "5.5",
                            stroke: c,
                            strokeOpacity: "0.75",
                            strokeWidth: "0.7"
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                            cx: "6.5",
                            cy: "-7",
                            r: "1.2",
                            fill: c
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("circle", {
                            cx: "-6.5",
                            cy: "-7",
                            r: "1.1",
                            fill: `${c}80`
                        }),
                        /*#__PURE__*/ (0, $caV3w.jsx)("text", {
                            x: "0",
                            y: "24",
                            textAnchor: "middle",
                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                            fontSize: "8",
                            fill: n.isReg ? (0, $6uXpe.P).gold : (0, $6uXpe.P).dim,
                            children: n.isReg ? "regional" : "local"
                        })
                    ]
                }, `e${i}`);
            }),
            staticT.map((t, i)=>renderTower(`t${i}`, t.x, t.y, t.deg, (0, $6uXpe.P).light, false)),
            /*#__PURE__*/ (0, $caV3w.jsxs)("g", {
                children: [
                    nomadicT.map((t, i)=>renderTower(`n${i}`, t.x, t.y, t.deg, (0, $6uXpe.P).gold, true)),
                    active && /*#__PURE__*/ (0, $caV3w.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 0 0",
                        to: "360 0 0",
                        dur: "55s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    });
}


function $c34dc2e4c25042c0$export$2e2bcd8739ae039() {
    const [active, setActive] = (0, $8XEkF.useState)(0);
    const [progress, setProgress] = (0, $8XEkF.useState)(0);
    const ref = (0, $8XEkF.useRef)(null);
    const onScroll = (0, $8XEkF.useCallback)(()=>{
        const el = ref.current;
        if (!el) return;
        setProgress(el.scrollTop / Math.max(1, el.scrollHeight - el.clientHeight));
        const cur = Math.round(el.scrollTop / el.clientHeight);
        if (cur !== active) setActive(cur);
    }, [
        active
    ]);
    const scrollTo = (i)=>ref.current?.scrollTo({
            top: i * ref.current.clientHeight,
            behavior: "smooth"
        });
    (0, $8XEkF.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        el.addEventListener("scroll", onScroll, {
            passive: true
        });
        return ()=>el.removeEventListener("scroll", onScroll);
    }, [
        onScroll
    ]);
    const S = {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        padding: "40px 60px",
        scrollSnapAlign: "start",
        boxSizing: "border-box"
    };
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: {
            width: "100%",
            height: "100vh",
            background: (0, $6uXpe.P).deep,
            fontFamily: $c34dc2e4c25042c0$var$FF_BODY,
            color: (0, $6uXpe.P).white,
            overflow: "hidden",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $caV3w.jsx)("style", {
                children: `
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700&display=swap');
        @keyframes fadeSlideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
        @keyframes pulse  { 0%, 100% { opacity: 0.45; } 50% { opacity: 1; } }
        @keyframes drift  { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes spin   { from { transform: rotate(0); } to { transform: rotate(360deg); } }
        * { scrollbar-width: none; } *::-webkit-scrollbar { display: none; }
      `
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$NeuralNebula, {
                active: active
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: 3,
                    zIndex: 100,
                    width: `${progress * 100}%`,
                    background: `linear-gradient(90deg, ${(0, $6uXpe.P).purple}, ${(0, $6uXpe.P).magenta}, ${(0, $6uXpe.P).cyan}, ${(0, $6uXpe.P).gold})`,
                    transition: "width 0.1s",
                    boxShadow: `0 0 16px ${(0, $6uXpe.P).purple}88`
                }
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                style: {
                    position: "fixed",
                    right: 22,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 100,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                },
                children: $c34dc2e4c25042c0$var$SECTIONS.map((id, i)=>/*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        onClick: ()=>scrollTo(i),
                        title: (0, $5jQtK.COPY).navLabels[i] || "Start",
                        style: {
                            width: active === i ? 12 : 7,
                            height: active === i ? 12 : 7,
                            borderRadius: "50%",
                            background: active === i ? (0, $6uXpe.P).light : "rgba(244,224,255,0.18)",
                            cursor: "pointer",
                            transition: "all 0.3s",
                            boxShadow: active === i ? `0 0 14px ${(0, $6uXpe.P).light}aa` : "none"
                        }
                    }, id))
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("a", {
                href: "index.html",
                style: {
                    position: "fixed",
                    top: 18,
                    right: 24,
                    zIndex: 110,
                    fontFamily: $c34dc2e4c25042c0$var$FF_BODY,
                    fontSize: 12,
                    color: (0, $6uXpe.P).light,
                    textDecoration: "none",
                    letterSpacing: 1,
                    opacity: 0.65,
                    padding: "6px 12px",
                    borderRadius: 999,
                    border: `1px solid ${(0, $6uXpe.P).faint}`
                },
                children: (0, $5jQtK.COPY).ui.backLink
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    position: "fixed",
                    top: 16,
                    left: 24,
                    zIndex: 100,
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    opacity: 0.7
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("img", {
                        src: new URL((parcelRequire("4f8JX"))),
                        alt: "Telia",
                        style: {
                            height: 36,
                            objectFit: "contain"
                        }
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                        style: {
                            color: "rgba(255,255,255,0.2)",
                            fontSize: 18
                        },
                        children: "\xd7"
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("img", {
                        src: new URL((parcelRequire("2DgLD"))),
                        alt: "Ericsson",
                        style: {
                            height: 36,
                            objectFit: "contain",
                            filter: "brightness(0) invert(1)"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                ref: ref,
                style: {
                    height: "100vh",
                    overflowY: "auto",
                    scrollSnapType: "y mandatory",
                    position: "relative",
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                textAlign: "center",
                                maxWidth: 1100
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 0,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                            fontSize: 12,
                                            color: (0, $6uXpe.P).cyan,
                                            letterSpacing: 6,
                                            textTransform: "uppercase",
                                            marginBottom: 26
                                        },
                                        children: (0, $5jQtK.COPY).hero.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 0,
                                    delay: 0.1,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("h1", {
                                        style: {
                                            fontSize: "clamp(56px, 10vw, 140px)",
                                            fontWeight: 300,
                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                            margin: 0,
                                            lineHeight: 0.92,
                                            letterSpacing: -3,
                                            background: `linear-gradient(135deg, ${(0, $6uXpe.P).white} 0%, ${(0, $6uXpe.P).light} 35%, ${(0, $6uXpe.P).cyan} 65%, ${(0, $6uXpe.P).magenta} 100%)`,
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                            backgroundSize: "200% 200%",
                                            animation: "shimmer 8s ease-in-out infinite"
                                        },
                                        children: (0, $5jQtK.COPY).hero.title
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 0,
                                    delay: 0.25,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                            fontWeight: 300,
                                            fontSize: "clamp(20px, 2.8vw, 32px)",
                                            color: (0, $6uXpe.P).white,
                                            marginTop: 18,
                                            lineHeight: 1.3
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                            parts: (0, $5jQtK.COPY).hero.subtitle
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 0,
                                    delay: 0.45,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 56,
                                            marginTop: 60,
                                            flexWrap: "wrap"
                                        },
                                        children: (0, $5jQtK.COPY).hero.stats.map((s, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                                active: active === 0,
                                                delay: 0.5 + i * 0.12,
                                                children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                            style: {
                                                                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                                fontWeight: 300,
                                                                fontSize: 44,
                                                                color: (0, $6uXpe.P).light,
                                                                letterSpacing: -1
                                                            },
                                                            children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Counter, {
                                                                to: s.v,
                                                                prefix: s.pre,
                                                                suffix: s.suf,
                                                                active: active === 0,
                                                                decimals: s.dec
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                            style: {
                                                                fontSize: 11,
                                                                color: (0, $6uXpe.P).muted,
                                                                marginTop: 6,
                                                                letterSpacing: 1,
                                                                maxWidth: 140
                                                            },
                                                            children: s.label
                                                        })
                                                    ]
                                                })
                                            }, i))
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 0,
                                    delay: 0.95,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            marginTop: 28,
                                            fontSize: 12,
                                            color: (0, $6uXpe.P).dim,
                                            maxWidth: 680,
                                            marginLeft: "auto",
                                            marginRight: "auto",
                                            lineHeight: 1.5
                                        },
                                        children: (0, $5jQtK.COPY).hero.note
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        marginTop: 36,
                                        animation: "pulse 2s infinite",
                                        color: (0, $6uXpe.P).muted,
                                        fontSize: 12,
                                        letterSpacing: 2
                                    },
                                    children: (0, $5jQtK.COPY).ui.scrollHint
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1080,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 1,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).gold,
                                        children: (0, $5jQtK.COPY).inflection.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 1,
                                    delay: 0.1,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).inflection.headline,
                                        size: "clamp(28px, 5vw, 56px)",
                                        mb: 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        marginTop: 50,
                                        position: "relative"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                left: "5%",
                                                right: "5%",
                                                top: 42,
                                                height: 3,
                                                background: `linear-gradient(90deg, ${(0, $6uXpe.P).faint}, ${(0, $6uXpe.P).purple} 32%, ${(0, $6uXpe.P).cyan} 48%, ${(0, $6uXpe.P).gold} 62%, ${(0, $6uXpe.P).green})`,
                                                borderRadius: 2,
                                                boxShadow: `0 0 14px ${(0, $6uXpe.P).cyan}55`
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                left: "calc(100% * 18.5 / 30)",
                                                top: 30,
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                background: (0, $6uXpe.P).gold,
                                                boxShadow: `0 0 22px ${(0, $6uXpe.P).gold}, 0 0 50px ${(0, $6uXpe.P).gold}88`,
                                                animation: "pulse 1.8s ease-in-out infinite",
                                                transform: "translateX(-50%)",
                                                opacity: active === 1 ? 1 : 0,
                                                transition: "opacity 0.6s ease 0.4s"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                left: "calc(100% * 18.5 / 30)",
                                                top: 0,
                                                transform: "translateX(-50%)",
                                                fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                fontSize: 11,
                                                color: (0, $6uXpe.P).gold,
                                                letterSpacing: 2,
                                                opacity: active === 1 ? 1 : 0,
                                                transition: "opacity 0.6s ease 0.5s",
                                                textTransform: "uppercase"
                                            },
                                            children: (0, $5jQtK.COPY).inflection.youAreHere
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                            style: {
                                                display: "grid",
                                                gridTemplateColumns: "2fr 2fr 3fr 3fr 5fr 7fr 8fr",
                                                gap: 0,
                                                marginTop: 90
                                            },
                                            children: (0, $5jQtK.COPY).inflection.eras.map((p, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                                    active: active === 1,
                                                    delay: 0.2 + i * 0.08,
                                                    children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                                    fontSize: 12,
                                                                    fontWeight: 700,
                                                                    color: p.c,
                                                                    letterSpacing: 1
                                                                },
                                                                children: p.era
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                                    fontSize: 10,
                                                                    color: (0, $6uXpe.P).muted,
                                                                    marginTop: 2
                                                                },
                                                                children: p.y
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontSize: 11,
                                                                    color: (0, $6uXpe.P).dim,
                                                                    marginTop: 6
                                                                },
                                                                children: p.t
                                                            })
                                                        ]
                                                    })
                                                }, p.era))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 1,
                                    delay: 0.6,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            marginTop: 50,
                                            background: `linear-gradient(135deg, ${(0, $6uXpe.P).purple}0e, ${(0, $6uXpe.P).cyan}0e)`,
                                            border: `1px solid ${(0, $6uXpe.P).purple}30`,
                                            borderRadius: 18,
                                            padding: "28px 32px",
                                            fontSize: 15,
                                            color: "rgba(244,224,255,0.85)",
                                            lineHeight: 1.65,
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                            parts: (0, $5jQtK.COPY).inflection.note
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 2,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).cyan,
                                        children: (0, $5jQtK.COPY).waves.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 2,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).waves.headline,
                                        size: "clamp(28px, 5vw, 52px)",
                                        mb: 36
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$WaveBands, {
                                    active: active === 2
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1180,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 3,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).cyan,
                                        children: (0, $5jQtK.COPY).innovation.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 3,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).innovation.headline,
                                        size: "clamp(26px, 5vw, 50px)",
                                        mb: 10
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 3,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        size: 14,
                                        mb: 14,
                                        max: 820,
                                        children: (0, $5jQtK.COPY).innovation.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        position: "relative",
                                        width: "100%",
                                        height: 580,
                                        marginTop: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 3,
                                            delay: 0.24,
                                            style: {
                                                position: "absolute",
                                                inset: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                zIndex: 1
                                            },
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                style: {
                                                    width: 560,
                                                    height: 560
                                                },
                                                children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$NorthStarCircle, {
                                                    active: active === 3
                                                })
                                            })
                                        }),
                                        (0, $5jQtK.COPY).innovation.pillars.map((p, i)=>{
                                            const corners = [
                                                {
                                                    top: 6,
                                                    left: 6
                                                },
                                                {
                                                    top: 6,
                                                    right: 6
                                                },
                                                {
                                                    bottom: 60,
                                                    left: 6
                                                },
                                                {
                                                    bottom: 60,
                                                    right: 6
                                                }
                                            ];
                                            return /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                                active: active === 3,
                                                delay: 0.4 + i * 0.08,
                                                style: {
                                                    position: "absolute",
                                                    ...corners[i],
                                                    width: 290,
                                                    zIndex: 2
                                                },
                                                children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                    style: {
                                                        background: `linear-gradient(180deg, ${p.c}26, rgba(20,8,38,0.85))`,
                                                        border: `1px solid ${p.c}66`,
                                                        borderRadius: 14,
                                                        padding: "12px 14px",
                                                        boxShadow: "0 10px 28px rgba(0,0,0,0.55)",
                                                        backdropFilter: "blur(6px)"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                            style: {
                                                                fontSize: 20,
                                                                marginBottom: 4
                                                            },
                                                            children: p.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                            style: {
                                                                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                                fontWeight: 300,
                                                                fontSize: 15,
                                                                color: (0, $6uXpe.P).white,
                                                                marginBottom: 4,
                                                                lineHeight: 1.2
                                                            },
                                                            children: p.title
                                                        }),
                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                            style: {
                                                                fontSize: 11.5,
                                                                color: (0, $6uXpe.P).dim,
                                                                lineHeight: 1.5
                                                            },
                                                            children: p.desc
                                                        })
                                                    ]
                                                })
                                            }, i);
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1180,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 4,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).cyan,
                                        children: (0, $5jQtK.COPY).demo.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 4,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).demo.headline,
                                        size: "clamp(26px, 5vw, 50px)",
                                        mb: 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 4,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        size: 14,
                                        mb: 26,
                                        max: 900,
                                        children: (0, $5jQtK.COPY).demo.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 24,
                                        alignItems: "start"
                                    },
                                    children: (0, $5jQtK.COPY).demo.clips.map((clip, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 4,
                                            delay: 0.26 + i * 0.12,
                                            children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                            fontSize: 12,
                                                            color: clip.c,
                                                            letterSpacing: 1,
                                                            textTransform: "uppercase"
                                                        },
                                                        children: clip.tag
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("video", {
                                                        src: $c34dc2e4c25042c0$var$DEMO_VIDEOS[i],
                                                        autoPlay: true,
                                                        muted: true,
                                                        loop: true,
                                                        playsInline: true,
                                                        controls: true,
                                                        preload: "metadata",
                                                        style: {
                                                            width: "100%",
                                                            borderRadius: 14,
                                                            border: `1px solid ${clip.c}59`,
                                                            boxShadow: "0 10px 34px rgba(0,0,0,0.45)",
                                                            display: "block",
                                                            background: "#000"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontSize: 13,
                                                            color: (0, $6uXpe.P).dim,
                                                            lineHeight: 1.55
                                                        },
                                                        children: clip.outcome
                                                    })
                                                ]
                                            })
                                        }, i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: {
                            ...S,
                            padding: "8px 16px"
                        },
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 5,
                                    style: {
                                        flex: "none"
                                    },
                                    children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "baseline",
                                            gap: 14,
                                            flexWrap: "wrap",
                                            marginBottom: 6,
                                            paddingLeft: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                style: {
                                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                    fontSize: 11,
                                                    color: (0, $6uXpe.P).gold,
                                                    letterSpacing: 1.5,
                                                    textTransform: "uppercase",
                                                    flex: "none"
                                                },
                                                children: (0, $5jQtK.COPY).core.kicker
                                            }),
                                            /*#__PURE__*/ (0, $caV3w.jsx)("h2", {
                                                style: {
                                                    margin: 0,
                                                    fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                    fontWeight: 300,
                                                    fontSize: "clamp(18px, 2.4vw, 26px)",
                                                    lineHeight: 1.15,
                                                    letterSpacing: -0.5
                                                },
                                                children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                                    parts: (0, $5jQtK.COPY).core.headline
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 5,
                                    delay: 0.16,
                                    style: {
                                        flex: 1,
                                        minHeight: 0,
                                        marginLeft: -16,
                                        marginRight: -16
                                    },
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            width: "calc(100% + 32px)",
                                            height: "100%",
                                            overflow: "hidden",
                                            borderTop: `1px solid ${(0, $6uXpe.P).purple}33`,
                                            borderBottom: `1px solid ${(0, $6uXpe.P).purple}33`,
                                            boxShadow: `0 8px 24px rgba(0,0,0,0.4)`,
                                            background: (0, $6uXpe.P).dark
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)("iframe", {
                                            src: "unified-5g-viz.html?teaser=1",
                                            title: "Network slicing \u2014 animated preview",
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                border: 0,
                                                display: "block",
                                                pointerEvents: "none"
                                            },
                                            loading: "lazy"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1280,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 6,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).cyan,
                                        mb: 8,
                                        children: (0, $5jQtK.COPY).slicing.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 6,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).slicing.headline,
                                        size: "clamp(24px, 4vw, 42px)",
                                        mb: 14
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 6,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        size: 14,
                                        mb: 16,
                                        max: 820,
                                        children: (0, $5jQtK.COPY).slicing.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 6,
                                    delay: 0.24,
                                    style: {
                                        flex: 1,
                                        minHeight: 0
                                    },
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            minHeight: 480,
                                            borderRadius: 18,
                                            overflow: "hidden",
                                            border: `1px solid ${(0, $6uXpe.P).cyan}33`,
                                            boxShadow: `0 20px 60px rgba(0,0,0,0.45), 0 0 24px ${(0, $6uXpe.P).cyan}33`,
                                            background: (0, $6uXpe.P).dark
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)("iframe", {
                                            src: "5g-sa-architecture-diagram.html?teaser=1",
                                            title: "Radio spectrum \u2014 animated preview",
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                border: 0,
                                                display: "block",
                                                pointerEvents: "none"
                                            },
                                            loading: "lazy"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 7,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).magenta,
                                        children: (0, $5jQtK.COPY).ainative.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 7,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).ainative.headline,
                                        mb: 8
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 7,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        mb: 24,
                                        children: (0, $5jQtK.COPY).ainative.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1.4fr 1fr",
                                        gap: 24,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 7,
                                            delay: 0.24,
                                            children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$ClosedLoopSVG, {
                                                        active: active === 7
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                                        style: {
                                                            margin: "12px 6px 0",
                                                            fontSize: 11.5,
                                                            color: (0, $6uXpe.P).dim,
                                                            lineHeight: 1.55
                                                        },
                                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                                            parts: (0, $5jQtK.COPY).ainative.note
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 7,
                                            delay: 0.34,
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                children: (0, $5jQtK.COPY).ainative.points.map((it, i)=>/*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            marginBottom: 14
                                                        },
                                                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                    style: {
                                                                        width: 6,
                                                                        borderRadius: 3,
                                                                        background: `linear-gradient(180deg, ${it.color}, transparent)`
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                            style: {
                                                                                fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                                                fontWeight: 300,
                                                                                fontSize: 18,
                                                                                color: (0, $6uXpe.P).white,
                                                                                marginBottom: 4
                                                                            },
                                                                            children: it.title
                                                                        }),
                                                                        /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                            style: {
                                                                                fontSize: 12.5,
                                                                                color: (0, $6uXpe.P).dim,
                                                                                lineHeight: 1.55
                                                                            },
                                                                            children: it.desc
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, i))
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 8,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).gold,
                                        children: (0, $5jQtK.COPY).ambient.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 8,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).ambient.headline,
                                        mb: 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 8,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        mb: 32,
                                        max: 800,
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                            parts: (0, $5jQtK.COPY).ambient.body
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 32,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 8,
                                            delay: 0.24,
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$ISACVisual, {
                                                active: active === 8
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 8,
                                            delay: 0.34,
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                children: (0, $5jQtK.COPY).ambient.uses.map((u, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 12,
                                                            marginBottom: 12
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontSize: 22
                                                                },
                                                                children: u.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                        style: {
                                                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                                            fontWeight: 300,
                                                                            fontSize: 16,
                                                                            color: (0, $6uXpe.P).white
                                                                        },
                                                                        children: u.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                        style: {
                                                                            fontSize: 12,
                                                                            color: (0, $6uXpe.P).dim,
                                                                            lineHeight: 1.5
                                                                        },
                                                                        children: u.desc
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, i))
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 9,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).green,
                                        children: (0, $5jQtK.COPY).positioning.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 9,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).positioning.headline,
                                        mb: 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 9,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        mb: 30,
                                        max: 760,
                                        children: (0, $5jQtK.COPY).positioning.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                        gap: 14
                                    },
                                    children: (0, $5jQtK.COPY).positioning.ladder.map((p, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 9,
                                            delay: 0.22 + i * 0.1,
                                            children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                style: {
                                                    background: `linear-gradient(180deg, ${p.color}26, rgba(255,255,255,0.045))`,
                                                    border: `1px solid ${p.color}59`,
                                                    borderRadius: 16,
                                                    padding: "18px 16px",
                                                    textAlign: "center",
                                                    height: 200,
                                                    position: "relative",
                                                    boxShadow: "0 6px 20px rgba(0,0,0,0.35)"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                            fontSize: 11,
                                                            color: p.color,
                                                            letterSpacing: 1,
                                                            marginBottom: 14
                                                        },
                                                        children: p.era
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                            fontWeight: 300,
                                                            fontSize: 36,
                                                            color: (0, $6uXpe.P).white,
                                                            marginBottom: 8,
                                                            letterSpacing: -1
                                                        },
                                                        children: p.acc
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: (0, $6uXpe.P).dim,
                                                            lineHeight: 1.5
                                                        },
                                                        children: p.detail
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "50%",
                                                            bottom: 12,
                                                            transform: "translateX(-50%)",
                                                            width: i < 3 ? `${50 - i * 12}%` : "8%",
                                                            height: 6,
                                                            borderRadius: 3,
                                                            background: p.color,
                                                            boxShadow: `0 0 12px ${p.color}aa`,
                                                            opacity: 0.7
                                                        }
                                                    })
                                                ]
                                            })
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 9,
                                    delay: 0.65,
                                    children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                        style: {
                                            marginTop: 30,
                                            borderTop: `1px solid ${(0, $6uXpe.P).faint}`,
                                            paddingTop: 18
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                style: {
                                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                    fontSize: 11,
                                                    color: (0, $6uXpe.P).dim,
                                                    letterSpacing: 1,
                                                    textTransform: "uppercase",
                                                    marginBottom: 12
                                                },
                                                children: (0, $5jQtK.COPY).positioning.examplesTitle
                                            }),
                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr 1fr",
                                                    gap: 12,
                                                    fontSize: 12,
                                                    color: (0, $6uXpe.P).dim
                                                },
                                                children: (0, $5jQtK.COPY).positioning.examples.map((it, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                        style: {
                                                            background: "rgba(255,255,255,0.03)",
                                                            border: `1px solid ${(0, $6uXpe.P).faint}`,
                                                            borderRadius: 12,
                                                            padding: "14px 16px",
                                                            display: "flex",
                                                            gap: 10,
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                                style: {
                                                                    fontSize: 22
                                                                },
                                                                children: it.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("span", {
                                                                style: {
                                                                    lineHeight: 1.5
                                                                },
                                                                children: it.what
                                                            })
                                                        ]
                                                    }, i))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 10,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).cyan,
                                        children: (0, $5jQtK.COPY).ntn.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 10,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).ntn.headline,
                                        mb: 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 10,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        mb: 30,
                                        max: 760,
                                        children: (0, $5jQtK.COPY).ntn.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1.2fr",
                                        gap: 32,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 10,
                                            delay: 0.24,
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$OrbitalView, {
                                                active: active === 10
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 10,
                                            delay: 0.34,
                                            children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 1fr",
                                                    gap: 12
                                                },
                                                children: (0, $5jQtK.COPY).ntn.items.map((it, i)=>/*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                        style: {
                                                            background: `linear-gradient(180deg, ${it.c}10, transparent)`,
                                                            border: `1px solid ${it.c}30`,
                                                            borderRadius: 14,
                                                            padding: "16px 14px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                                                    fontSize: 10,
                                                                    color: it.c,
                                                                    letterSpacing: 1,
                                                                    marginBottom: 6
                                                                },
                                                                children: it.y
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                                    fontWeight: 300,
                                                                    fontSize: 16,
                                                                    color: (0, $6uXpe.P).white,
                                                                    marginBottom: 6,
                                                                    lineHeight: 1.2
                                                                },
                                                                children: it.title
                                                            }),
                                                            /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                                style: {
                                                                    fontSize: 11,
                                                                    color: (0, $6uXpe.P).dim,
                                                                    lineHeight: 1.5
                                                                },
                                                                children: it.desc
                                                            })
                                                        ]
                                                    }, i))
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 10,
                                    delay: 0.5,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                        style: {
                                            margin: "20px auto 0",
                                            maxWidth: 860,
                                            fontSize: 11.5,
                                            color: (0, $6uXpe.P).dim,
                                            lineHeight: 1.55,
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                            parts: (0, $5jQtK.COPY).ntn.note
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1140,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 11,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).magenta,
                                        children: (0, $5jQtK.COPY).verticals.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 11,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).verticals.headline,
                                        size: "clamp(26px, 5vw, 50px)",
                                        mb: 10
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 11,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        size: 14,
                                        mb: 28,
                                        max: 720,
                                        children: (0, $5jQtK.COPY).verticals.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        gridAutoRows: "1fr",
                                        gap: 14
                                    },
                                    children: (0, $5jQtK.COPY).verticals.cards.map((c, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$VerticalCard, {
                                            active: active === 11,
                                            delay: 0.22 + i * 0.08,
                                            icon: c.icon,
                                            year: c.year,
                                            title: c.title,
                                            color: c.color,
                                            body: c.body,
                                            tech: c.tech
                                        }, i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1100,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 12,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$10edde2d298a8102, {
                                        color: (0, $6uXpe.P).gold,
                                        children: (0, $5jQtK.COPY).economy.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 12,
                                    delay: 0.08,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$a8a3e93435678ff9, {
                                        parts: (0, $5jQtK.COPY).economy.headline,
                                        size: "clamp(26px, 5vw, 50px)",
                                        mb: 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 12,
                                    delay: 0.16,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$export$b8e2ce21bebdf7bd, {
                                        size: 14,
                                        mb: 24,
                                        max: 760,
                                        children: (0, $5jQtK.COPY).economy.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 12,
                                    delay: 0.24,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$EconomyChart, {
                                        active: active === 12
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        marginTop: 24,
                                        display: "grid",
                                        gridTemplateColumns: "repeat(4, 1fr)",
                                        gap: 12
                                    },
                                    children: (0, $5jQtK.COPY).economy.stats.map((s, i)=>/*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                            active: active === 12,
                                            delay: 0.4 + i * 0.08,
                                            children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                                                style: {
                                                    border: `1px solid ${s.c}33`,
                                                    borderRadius: 14,
                                                    padding: "16px 14px",
                                                    background: `linear-gradient(180deg, ${s.c}0e, transparent)`,
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                                            fontWeight: 300,
                                                            fontSize: 26,
                                                            color: s.c,
                                                            letterSpacing: -0.5
                                                        },
                                                        children: s.v
                                                    }),
                                                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: (0, $6uXpe.P).dim,
                                                            marginTop: 4,
                                                            lineHeight: 1.4
                                                        },
                                                        children: s.l
                                                    })
                                                ]
                                            })
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 12,
                                    delay: 0.72,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            marginTop: 16,
                                            fontSize: 12,
                                            color: (0, $6uXpe.P).dim,
                                            textAlign: "center",
                                            lineHeight: 1.5,
                                            maxWidth: 820,
                                            marginLeft: "auto",
                                            marginRight: "auto"
                                        },
                                        children: (0, $5jQtK.COPY).economy.note
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                        style: S,
                        children: /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                            style: {
                                maxWidth: 1000,
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 13,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                            fontSize: 12,
                                            color: (0, $6uXpe.P).cyan,
                                            letterSpacing: 6,
                                            textTransform: "uppercase",
                                            marginBottom: 28
                                        },
                                        children: (0, $5jQtK.COPY).vision.kicker
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 13,
                                    delay: 0.1,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            fontFamily: $c34dc2e4c25042c0$var$FF_HEAD,
                                            fontWeight: 300,
                                            fontSize: "clamp(36px, 6.5vw, 76px)",
                                            lineHeight: 1.05,
                                            letterSpacing: -2
                                        },
                                        children: /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Rich, {
                                            parts: (0, $5jQtK.COPY).vision.headline
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 13,
                                    delay: 0.3,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                                        style: {
                                            fontSize: 17,
                                            color: (0, $6uXpe.P).dim,
                                            marginTop: 32,
                                            lineHeight: 1.7,
                                            maxWidth: 720,
                                            margin: "32px auto 0"
                                        },
                                        children: (0, $5jQtK.COPY).vision.body
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)($c34dc2e4c25042c0$var$Reveal, {
                                    active: active === 13,
                                    delay: 0.5,
                                    children: /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                        style: {
                                            marginTop: 44,
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 14,
                                            flexWrap: "wrap"
                                        },
                                        children: (0, $5jQtK.COPY).vision.ctas.map((c, i)=>/*#__PURE__*/ (0, $caV3w.jsx)("a", {
                                                href: c.href,
                                                style: c.primary ? $c34dc2e4c25042c0$var$ctaPrimary : $c34dc2e4c25042c0$var$ctaGhost,
                                                children: c.label
                                            }, i))
                                    })
                                }),
                                /*#__PURE__*/ (0, $caV3w.jsx)("div", {
                                    style: {
                                        marginTop: 60,
                                        fontFamily: $c34dc2e4c25042c0$var$FF_MONO,
                                        fontSize: 10,
                                        color: (0, $6uXpe.P).faint,
                                        letterSpacing: 3
                                    },
                                    children: (0, $5jQtK.COPY).ui.footer
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
const $c34dc2e4c25042c0$var$ctaPrimary = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "14px 32px",
    background: `linear-gradient(135deg, ${(0, $6uXpe.P).purple}, ${(0, $6uXpe.P).magenta})`,
    color: (0, $6uXpe.P).white,
    borderRadius: 999,
    textDecoration: "none",
    fontWeight: 500,
    fontSize: 14,
    border: 0,
    transition: "transform 0.2s, box-shadow 0.2s, background 0.2s",
    boxShadow: `0 8px 22px ${(0, $6uXpe.P).purple}55`
};
const $c34dc2e4c25042c0$var$ctaGhost = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "14px 28px",
    background: "transparent",
    color: (0, $6uXpe.P).light,
    border: `1px solid ${(0, $6uXpe.P).light}55`,
    borderRadius: 999,
    textDecoration: "none",
    fontWeight: 500,
    fontSize: 14,
    transition: "background 0.2s, color 0.2s, border-color 0.2s"
};

});
parcelRegister("8hO7X", function(module, exports) {
module.exports = $parcel$resolve("8V8OF");

});

parcelRegister("eLjQa", function(module, exports) {
module.exports = $parcel$resolve("h5zBs");

});

parcelRegister("4f8JX", function(module, exports) {
module.exports = $parcel$resolve("6fYiv");

});

parcelRegister("2DgLD", function(module, exports) {
module.exports = $parcel$resolve("8kxNx");

});


var $bc860237553e98e2$exports = {};
$parcel$extendImportMap({
    "8V8OF": "astazero-besteffort.ff8ba5ba.mp4",
    "h5zBs": "astazero-lowlatency.fb0cc557.mp4",
    "6fYiv": "Telia_Logotype_RGB_Purple.1cab6a79.png",
    "8kxNx": "Eric.27576b5e.png"
});


//# sourceMappingURL=northstar-future-vision.bb02b3aa.js.map
